/* eslint-disable */

/**
 * Generated by Verge3D Puzzles v.4.6.0
 * Thu, 06 Jun 2024 21:02:54 GMT
 * Prefer not editing this file as your changes may get overridden once Puzzles are saved.
 * Check out https://www.soft8soft.com/docs/manual/en/introduction/Using-JavaScript.html
 * for the information on how to add your own JavaScript to Verge3D apps.
 */
function createPL(v3d = window.v3d) {

// global variables used in the init tab
const _initGlob = {
    percentage: 0,
    output: {
        initOptions: {
            fadeAnnotations: true,
            useBkgTransp: false,
            preserveDrawBuf: false,
            useCompAssets: false,
            useFullscreen: true,
            useCustomPreloader: false,
            preloaderStartCb: function() {},
            preloaderProgressCb: function() {},
            preloaderEndCb: function() {},
        },
    },
};


// global variables/constants used by puzzles' functions
var _pGlob = {};

_pGlob.objCache = {};
_pGlob.fadeAnnotations = true;
_pGlob.pickedObject = '';
_pGlob.hoveredObject = '';
_pGlob.mediaElements = {};
_pGlob.loadedFile = '';
_pGlob.states = [];
_pGlob.percentage = 0;
_pGlob.openedFile = '';
_pGlob.openedFileMeta = {};
_pGlob.xrSessionAcquired = false;
_pGlob.xrSessionCallbacks = [];
_pGlob.screenCoords = new v3d.Vector2();
_pGlob.intervalTimers = {};
_pGlob.customEvents = new v3d.EventDispatcher();
_pGlob.eventListeners = [];

_pGlob.AXIS_X = new v3d.Vector3(1, 0, 0);
_pGlob.AXIS_Y = new v3d.Vector3(0, 1, 0);
_pGlob.AXIS_Z = new v3d.Vector3(0, 0, 1);
_pGlob.MIN_DRAG_SCALE = 10e-4;
_pGlob.SET_OBJ_ROT_EPS = 1e-8;

_pGlob.vec2Tmp = new v3d.Vector2();
_pGlob.vec2Tmp2 = new v3d.Vector2();
_pGlob.vec3Tmp = new v3d.Vector3();
_pGlob.vec3Tmp2 = new v3d.Vector3();
_pGlob.vec3Tmp3 = new v3d.Vector3();
_pGlob.vec3Tmp4 = new v3d.Vector3();
_pGlob.eulerTmp = new v3d.Euler();
_pGlob.eulerTmp2 = new v3d.Euler();
_pGlob.quatTmp = new v3d.Quaternion();
_pGlob.quatTmp2 = new v3d.Quaternion();
_pGlob.colorTmp = new v3d.Color();
_pGlob.mat4Tmp = new v3d.Matrix4();
_pGlob.planeTmp = new v3d.Plane();
_pGlob.raycasterTmp = new v3d.Raycaster(); // always check visibility

const createPzLib = ({ v3d=null, appInstance=null }) => {
    /**
     * Check if the given object is "worth processing", i.e. not irrelevant nor
     * purely utilitarian. This function is useful for listing all relevant objects
     * from a scene (see "objectList" and "groupList" puzzles) and for filtering out
     * irrelevant ones when traversing a scene.
     * @param {v3d.Object3D} obj Object to check.
     * @returns {boolean} Check result.
     */
    function isObjectWorthProcessing(obj) {
        return obj.type !== 'AmbientLight' && obj.name !== '' &&
                !(obj.isMesh && obj.isMaterialGeneratedMesh) &&
                !obj.isAuxClippingMesh;
    }
    
    /**
     * Get object by its name from the scene.
     * @param {string} objName Object name.
     * @returns {?v3d.Object3D} Object or null if not found.
     */
    function getObjectByName(objName) {
        let objFound = null;
    
        const runTime = _pGlob !== undefined;
        if (runTime && objName in _pGlob.objCache) {
            objFound = _pGlob.objCache[objName] || null;
        }
    
        if (objFound && objFound.name === objName) {
            return objFound;
        }
    
        if (appInstance.scene) {
            appInstance.scene.traverse(obj => {
                if (!objFound && isObjectWorthProcessing(obj) && (obj.name === objName)) {
                    objFound = obj;
                    if (runTime) {
                        _pGlob.objCache[objName] = objFound;
                    }
                }
            });
        }
        return objFound;
    }
        
    /**
     * Get the names of all objects belonging to the given group.
     * @param {string} groupName Group name.
     * @returns {Array<string>} Array of names of all objects belonging to the given
     * group.
     */
    function getObjectNamesByGroupName(groupName) {
        const objNameList = [];
        appInstance.scene.traverse(obj => {
            if (isObjectWorthProcessing(obj)) {
                const objGroupNames = obj.groupNames;
                if (!objGroupNames) {
                    return;
                }
    
                for (let i = 0; i < objGroupNames.length; i++) {
                    const objGroupName = objGroupNames[i];
                    if (objGroupName === groupName) {
                        objNameList.push(obj.name);
                    }
                }
            }
        });
        return objNameList;
    }
        
    /**
     * Get the names of all objects on the scene.
     * @returns {Array<string>} Array of names of all scene objects.
     */
    function getAllObjectNames() {
        const objNameList = [];
        appInstance.scene.traverse(obj => {
            if (isObjectWorthProcessing(obj)) {
                objNameList.push(obj.name);
            }
        });
        return objNameList;
    }
        
    /**
     * Accumulate object names from the given "currObjNames" parameter.
     * This is just a helper function which is supposed to be called from
     * "retrieveObjectNames".
     * @param {(string|Array)} objNames An object name, an array of object
     * names, an array in the format ["GROUP", GROUP_NAME], an array in the format
     * ["ALL_OBJECTS"].
     * @param {Array<string>} namesAccum Array accumulating object names.
     */
    function retrieveObjectNamesAccum(currObjNames, namesAccum) {
        if (typeof currObjNames === 'string') {
            namesAccum.push(currObjNames);
        } else if (Array.isArray(currObjNames) && currObjNames[0] === 'GROUP') {
            const newObjNames = getObjectNamesByGroupName(currObjNames[1]);
            for (let i = 0; i < newObjNames.length; i++) {
                namesAccum.push(newObjNames[i]);
            }
        } else if (Array.isArray(currObjNames) && currObjNames[0] === 'ALL_OBJECTS') {
            const newObjNames = getAllObjectNames();
            for (let i = 0; i < newObjNames.length; i++) {
                namesAccum.push(newObjNames[i]);
            }
        } else if (Array.isArray(currObjNames)) {
            for (let i = 0; i < currObjNames.length; i++) {
                retrieveObjectNamesAccum(currObjNames[i], namesAccum);
            }
        }
    }
        
    /**
     * Retreive object names from the given "objNames" parameter which potentially
     * represents an object, or an array of objects, or a group or all objects at
     * once. Empty string names ('') are always filtered out.
     * @param {(string|Array)} objNames An object name, an array of object
     * names, an array in the format ["GROUP", GROUP_NAME], an array in the format
     * ["ALL_OBJECTS"].
     * @returns {Array<string>} Array of retrieved object names.
     */
    function retrieveObjectNames(objNames) {
        const accum = [];
        retrieveObjectNamesAccum(objNames, accum);
        return accum.filter(name => name !== '');
    }
        
    /**
     * Check whether 2 event listeners are the same or not.
     * NOTE: "capture" is the only option that affects the fact if the listeners are
     * the same or not.
     * @see https://dom.spec.whatwg.org/#ref-for-dom-eventtarget-addeventlistener%E2%91%A2
     * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/removeEventListener#matching_event_listeners_for_removal
     * @param {EventTarget} target0 Event target the first event listener is
     * registered on.
     * @param {string} type0 Event type of the first even listener.
     * @param {?Function} listener0 Listener object (null, function or an object
     * with a handleEvent() method) of the first event listener.
     * @param {(Object|boolean)} optionsOrUseCapture0 Event listener options (or the
     * useCapture flag) of the first event listener.
     * @param {EventTarget} target1 Event target the second listener is registered
     * on.
     * @param {string} type1 Event type of the second even listener.
     * @param {?Function} listener1 Listener object (null, function or an object
     * with a handleEvent() method) of the second event listener.
     * @param {(Object|boolean)} optionsOrUseCapture1 Event listener options (or the
     * useCapture flag) of the second event listener.
     * @returns {boolean} Check result.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
     */
    function areListenersSame(target0, type0, listener0, optionsOrUseCapture0,
            target1, type1, listener1, optionsOrUseCapture1) {
        const capture0 = Boolean(optionsOrUseCapture0 instanceof Object
                ? optionsOrUseCapture0.capture : optionsOrUseCapture0);
        const capture1 = Boolean(optionsOrUseCapture1 instanceof Object
                ? optionsOrUseCapture1.capture : optionsOrUseCapture1);
        return target0 === target1 && type0 === type1 && listener0 === listener1
                && capture0 === capture1;
    }
    
    /**
     * Add the specified event listener to the specified event target. Also register
     * it in _pGlob.eventListeners for easier removal further. This function doesn't
     * add the exact same listener if it was already added.
     *
     * NOTE: automatic removal of an event listener via options.once and
     * options.signal is not reflected in _pGlob.eventListeners. In such cases
     * one must call unbindListener() manually to keep _pGlob.eventListeners
     * updated and to avoid potential issues with how the code checks if the given
     * listener already exists in _pGlob.eventListeners or not.
     *
     * @param {EventTarget} target Event target.
     * @param {string} type Event type.
     * @param {?Function} listener Listener object (null, function or an object
     * with a handleEvent() method).
     * @param {(Object|boolean)} optionsOrUseCapture Event listener options (or the
     * useCapture flag).
     * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
     */
    function bindListener(target, type, listener, optionsOrUseCapture) {
        const alreadyExists = _pGlob.eventListeners.some(elem => {
            return areListenersSame(elem.target, elem.type, elem.listener,
                    elem.optionsOrUseCapture, target, type, listener,
                    optionsOrUseCapture);
        });
    
        if (!alreadyExists) {
            target.addEventListener(type, listener, optionsOrUseCapture);
            _pGlob.eventListeners.push({ target, type, listener,
                    optionsOrUseCapture });
        }
    }
        
    /**
     * Get an HTML element by the given id.
     * @param {(string|Array<string>)} id An HTML element id or an array in the
     * format ["CONTAINER"] (app's container HTML element), or in the format
     * ["WINDOW"] (page's window object), or in the format ["DOCUMENT"] (page's
     * document object), or in the format ["BODY"] (document's body element) or in
     * the format ["QUERYSELECTOR"] (CSS selector string).
     * @param {boolean} [isParent=false] Use the parent document/window to search
     * for the element.
     * @returns {?(HTMLElement|Window|Document)} An HTML element, window,
     * document depending on the given "id" parameter or "null" if nothing was
     * found.
     */
    function getElement(id, isParent=false) {
        let elem;
        if (Array.isArray(id) && id[0] === 'CONTAINER') {
            if (appInstance !== null) {
                elem = appInstance.container;
            } else if (typeof _initGlob !== 'undefined') {
                // if we are on the initialization stage, we still can have access
                // to the container element
                const contId = _initGlob.container;
                elem = isParent ? parent.document.getElementById(contId)
                        : document.getElementById(contId);
            }
        } else if (Array.isArray(id) && id[0] === 'WINDOW') {
            elem = isParent ? parent : window;
        } else if (Array.isArray(id) && id[0] === 'DOCUMENT') {
            elem = isParent ? parent.document : document;
        } else if (Array.isArray(id) && id[0] === 'BODY') {
            elem = isParent ? parent.document.body : document.body;
        } else if (Array.isArray(id) && id[0] === 'QUERYSELECTOR') {
            elem = isParent ? parent.document.querySelector(id)
                    : document.querySelector(id);
        } else {
            elem = isParent ? parent.document.getElementById(id)
                    : document.getElementById(id);
        }
        return elem;
    }
    
    /**
     * Get an array of HTML elements or a single HTML element by the given ids/id.
     * @param {Array<string>} ids An array of HTML element ids or an array with its
     * first element being "CONTAINER" (app's container HTML element),
     * "WINDOW" (page's window object), "DOCUMENT" (page's document object),
     * "BODY" (document's body element) or "QUERYSELECTOR" (CSS selector string).
     * @param {boolean} [isParent=false] Use the parent document/window to search
     * for elements.
     * @returns {?(Array<?HTMLElement>|HTMLElement|Window|Document)} An array of
     * HTML elements or a single HTML element, window, document depending on the
     * given "ids" parameter or "null" if nothing was found.
     */
    function getElements(ids, isParent=false) {
        const elems = [];
        if (Array.isArray(ids) && ids[0] !== 'CONTAINER' && ids[0] !== 'WINDOW'
                && ids[0] !== 'DOCUMENT' && ids[0] !== 'BODY'
                && ids[0] !== 'QUERYSELECTOR') {
            for (let i = 0; i < ids.length; i++) {
                elems.push(getElement(ids[i], isParent));
            }
        } else {
            elems.push(getElement(ids, isParent));
        }
        return elems;
    }
        
    /**
     * Transform the given coordinates from one space to another. Can be used with
     * both v3d.Vector3 or v3d.Euler.
     * @param {(v3d.Vector3|v3d.Euler)} coords Coordinates to transform.
     * @param {string} spaceFrom Space to transform from.
     * @param {string} spaceTo Space to transform into.
     * @param {boolean} [noSignChange=false] Don't change a component's sign in case
     * of the Z->(-Y), Y->(-Z) transformations. "true" is relevant for vectors
     * containing values that shouldn't change the sign (e.g. scale, dimension,
     * etc...).
     * @returns {(v3d.Vector3|v3d.Euler)} Transformed coordinates.
     */
    function transformCoordsSpace(coords, spaceFrom, spaceTo, noSignChange=false) {
    
        if (spaceFrom === spaceTo) {
            return coords;
        }
    
        const y = coords.y;
        const z = coords.z;
    
        if (spaceFrom === 'Z_UP_RIGHT' && spaceTo === 'Y_UP_RIGHT') {
            coords.y = z;
            coords.z = noSignChange ? y : -y;
        } else if (spaceFrom === 'Y_UP_RIGHT' && spaceTo === 'Z_UP_RIGHT') {
            coords.y = noSignChange ? z : -z;
            coords.z = y;
        } else {
            console.error('transformCoordsSpace: Unsupported coordinate space');
        }
    
        return coords;
    }
    
    /**
     * Get the coordinate system of the current scene.
     * @returns {string} Scene's coordinate system.
     */
    function getSceneCoordSystem() {
        const scene = appInstance.scene;
        if (scene && 'coordSystem' in scene.userData) {
            return scene.userData.coordSystem;
        }
    
        return 'Y_UP_RIGHT';
    }

    return {
        getObjectByName, retrieveObjectNames, bindListener, getElements,
        transformCoordsSpace, getSceneCoordSystem, getElement,
    };
};

var PL = {};
// backward compatibility
if (v3d[Symbol.toStringTag] !== 'Module') {
    v3d.PL = v3d.puzzles = PL;
}

PL.procedures = PL.procedures || {};




PL.execInitPuzzles = function(options) {
    // always null, should not be available in "init" puzzles
    var appInstance = null;
    // app is more conventional than appInstance (used in exec script and app templates)
    var app = null;

    const PzLib = createPzLib({ v3d });

    // provide the container's id to puzzles that need access to the container
    _initGlob.container = options !== undefined && 'container' in options
            ? options.container : "";

    

    // initSettings puzzle
_initGlob.output.initOptions.fadeAnnotations = true;
_initGlob.output.initOptions.useBkgTransp = false;
_initGlob.output.initOptions.preserveDrawBuf = true;
_initGlob.output.initOptions.useCompAssets = true;
_initGlob.output.initOptions.useFullscreen = false;

    return _initGlob.output;
}

PL.init = function(appInstance, initOptions) {

// app is more conventional than appInstance (used in exec script and app templates)
var app = appInstance;

const PzLib = createPzLib({ v3d, appInstance });

initOptions = initOptions || {};

if ('fadeAnnotations' in initOptions) {
    _pGlob.fadeAnnotations = initOptions.fadeAnnotations;
}



var PROC = {
    
};

var VARS = Object.defineProperties({}, {
    '61d': { get: function() { return my_61d; }, set: function(val) { my_61d = val; } },
    'Wiata1': { get: function() { return Wiata1; }, set: function(val) { Wiata1 = val; } },
    '5.a': { get: function() { return my_5_a; }, set: function(val) { my_5_a = val; } },
    '61e': { get: function() { return my_61e; }, set: function(val) { my_61e = val; } },
    'Wiata2': { get: function() { return Wiata2; }, set: function(val) { Wiata2 = val; } },
    '<': { get: function() { return _3C; }, set: function(val) { _3C = val; } },
    'GaP': { get: function() { return GaP; }, set: function(val) { GaP = val; } },
    'Wiata3': { get: function() { return Wiata3; }, set: function(val) { Wiata3 = val; } },
    '5.b': { get: function() { return my_5_b; }, set: function(val) { my_5_b = val; } },
    'GaL': { get: function() { return GaL; }, set: function(val) { GaL = val; } },
    'PomL': { get: function() { return PomL; }, set: function(val) { PomL = val; } },
    '5.c': { get: function() { return my_5_c; }, set: function(val) { my_5_c = val; } },
    'PomP': { get: function() { return PomP; }, set: function(val) { PomP = val; } },
    'SL': { get: function() { return SL; }, set: function(val) { SL = val; } },
    'SP': { get: function() { return SP; }, set: function(val) { SP = val; } },
    '5.d': { get: function() { return my_5_d; }, set: function(val) { my_5_d = val; } },
    '>': { get: function() { return _3E; }, set: function(val) { _3E = val; } },
    'PomB': { get: function() { return PomB; }, set: function(val) { PomB = val; } },
    'SB': { get: function() { return SB; }, set: function(val) { SB = val; } },
});

var my_61d, Wiata1, my_5_a, my_61e, Wiata2, _3C, GaP, Wiata3, my_5_b, GaL, PomL, my_5_c, PomP, SL, SP, my_5_d, _3E, PomB, SB;

// assignMaterial puzzle
function assignMat(objSelector, matName) {
    var objNames = PzLib.retrieveObjectNames(objSelector);
    if (!matName)
        return;
    var mat = v3d.SceneUtils.getMaterialByName(appInstance, matName);
    if (!mat)
        return;
    for (var i = 0; i < objNames.length; i++) {
        var objName = objNames[i];
        if (!objName)
            continue;
        var obj = PzLib.getObjectByName(objName);
        if (obj) {
            var firstSubmesh = obj.resolveMultiMaterial()[0];
            firstSubmesh.material = mat;
        }
    }
}

// eventHTMLElem puzzle
function eventHTMLElem(eventType, ids, isParent, callback) {
    var elems = PzLib.getElements(ids, isParent);
    for (var i = 0; i < elems.length; i++) {
        var elem = elems[i];
        if (!elem)
            continue;

        PzLib.bindListener(elem, eventType, callback);
    }
}

// setInterval puzzle
function registerInterval(timeout, callback) {
    var timerId = window.setInterval(function() { callback(timerId) }, 1000 * timeout);
}

// tweenCamera puzzle
function tweenCamera(posOrObj, targetOrObj, duration, doSlot, movementType) {
    var camera = appInstance.getCamera();

    if (Array.isArray(posOrObj)) {
        var worldPos = _pGlob.vec3Tmp.fromArray(posOrObj);
        worldPos = PzLib.transformCoordsSpace(worldPos,
                PzLib.getSceneCoordSystem(), 'Y_UP_RIGHT');
    } else if (posOrObj) {
        var posObj = PzLib.getObjectByName(posOrObj);
        if (!posObj) return;
        var worldPos = posObj.getWorldPosition(_pGlob.vec3Tmp);
    } else {
        // empty input means: don't change the position
        var worldPos = camera.getWorldPosition(_pGlob.vec3Tmp);
    }

    if (Array.isArray(targetOrObj)) {
        var worldTarget = _pGlob.vec3Tmp2.fromArray(targetOrObj);
        worldTarget = PzLib.transformCoordsSpace(worldTarget,
                PzLib.getSceneCoordSystem(), 'Y_UP_RIGHT');
    } else {
        var targObj = PzLib.getObjectByName(targetOrObj);
        if (!targObj) return;
        var worldTarget = targObj.getWorldPosition(_pGlob.vec3Tmp2);
    }

    duration = Math.max(0, duration);

    if (appInstance.controls && appInstance.controls.tween) {
        // orbit and flying cameras
        if (!appInstance.controls.inTween) {
            appInstance.controls.tween(worldPos, worldTarget, duration, doSlot,
                    movementType);
        }
    } else {
        // TODO: static camera, just position it for now
        if (camera.parent) {
            camera.parent.worldToLocal(worldPos);
        }
        camera.position.copy(worldPos);
        camera.lookAt(worldTarget);
        doSlot();
    }
}

function setScreenScale(factor) {

    // already have maximum pixel ratio in HiDPI mode
    if (!appInstance.useHiDPIRenderPass)
        appInstance.renderer.setPixelRatio(factor);

    if (appInstance.postprocessing)
        appInstance.postprocessing.composer.setPixelRatio(factor);

    // to update possible post-processing passes
    appInstance.onResize();
}

// setCameraParam puzzle
function setCameraParam(type, camSelector, param) {

    const camNames = PzLib.retrieveObjectNames(camSelector);

    camNames.forEach(function(camName) {
        if (!camName)
            return;

        var cam = PzLib.getObjectByName(camName);
        if (!cam || !cam.isCamera) return;

        if (!(cam.isPerspectiveCamera || cam.isOrthographicCamera)) {
            console.error('setCameraParam: Incompatible camera type, have to be perspective or orthographic');
            return;
        }

        let isSetOrbitParam = false;
        let isSetFirstpersonParam = false;

        switch (type) {
            case 'ORBIT_MIN_DISTANCE_PERSP':
            case 'ORBIT_MAX_DISTANCE_PERSP':
            case 'ORBIT_MIN_ZOOM_ORTHO':
            case 'ORBIT_MAX_ZOOM_ORTHO':
            case 'ORBIT_MIN_VERTICAL_ANGLE':
            case 'ORBIT_MAX_VERTICAL_ANGLE':
            case 'ORBIT_MIN_HORIZONTAL_ANGLE':
            case 'ORBIT_MAX_HORIZONTAL_ANGLE':
            case 'ORBIT_ALLOW_TURNOVER':
                isSetOrbitParam = true;
                break;
            case 'ENABLE_COLLISIONS':
                isSetFirstpersonParam = true;
                break;
        }

        let isSetControlsParam = (['ROTATION_SPEED', 'MOVEMENT_SPEED', 'ALLOW_PANNING', 'ALLOW_ZOOM', 'KEYBOARD_CONTROLS'].includes(type) || isSetOrbitParam || isSetFirstpersonParam);

        if (isSetControlsParam) {
            if (!cam.controls) {
                console.error('setCameraParam: The "' + camName +'" camera has no controller');
                return;
            } else if ((isSetOrbitParam && cam.controls.type != 'ORBIT') ||
                    (isSetFirstpersonParam && cam.controls.type != 'FIRST_PERSON')) {
                console.error('setCameraParam: Incompatible camera controller: ' + cam.controls.type);
                return;
            }
        }

        switch (type) {
            case 'FIELD_OF_VIEW':
                if (cam.isPerspectiveCamera) {
                    cam.fov = param;
                    cam.updateProjectionMatrix();
                } else {
                    console.error('setCameraParam: Incompatible camera type, have to be perspective');
                    return;
                }
                break;
            case 'ORTHO_SCALE':
                if (cam.isOrthographicCamera) {
                    cam.zoom = param;
                    cam.updateProjectionMatrix();
                } else {
                    console.error('setCameraParam: Incompatible camera type, have to be orthographic');
                    return;
                }
                break;
            case 'ROTATION_SPEED':
                cam.controls.rotateSpeed = param;
                break;
            case 'MOVEMENT_SPEED':
                cam.controls.moveSpeed = param;
                break;
            case 'ALLOW_PANNING':
                cam.controls.enablePan = param;
                break;
            case 'ALLOW_ZOOM':
                cam.controls.enableZoom = param;
                break;
            case 'KEYBOARD_CONTROLS':
                cam.controls.enableKeys = param;
                break;
            case 'ORBIT_MIN_DISTANCE_PERSP':
                if (cam.isPerspectiveCamera) {
                    cam.controls.orbitMinDistance = param;
                } else {
                    console.error('setCameraParam: Incompatible camera type, have to be perspective');
                    return;
                }
                break;
            case 'ORBIT_MAX_DISTANCE_PERSP':
                if (cam.isPerspectiveCamera) {
                    cam.controls.orbitMaxDistance = param;
                } else {
                    console.error('setCameraParam: Incompatible camera type, have to be perspective');
                    return;
                }
                break;
            case 'ORBIT_MIN_ZOOM_ORTHO':
                if (cam.isOrthographicCamera) {
                    cam.controls.orbitMinZoom = param;
                } else {
                    console.error('setCameraParam: Incompatible camera type, have to be orthographic');
                    return;
                }
                break;
            case 'ORBIT_MAX_ZOOM_ORTHO':
                if (cam.isOrthographicCamera) {
                    cam.controls.orbitMaxZoom = param;
                } else {
                    console.error('setCameraParam: Incompatible camera type, have to be orthographic');
                    return;
                }
                break;
            case 'ORBIT_MIN_VERTICAL_ANGLE':
                cam.controls.orbitMinPolarAngle = v3d.MathUtils.degToRad(param);
                break;
            case 'ORBIT_MAX_VERTICAL_ANGLE':
                cam.controls.orbitMaxPolarAngle = v3d.MathUtils.degToRad(param);
                break;
            case 'ORBIT_MIN_HORIZONTAL_ANGLE':
                cam.controls.orbitMinAzimuthAngle = v3d.MathUtils.degToRad(param);
                break;
            case 'ORBIT_MAX_HORIZONTAL_ANGLE':
                cam.controls.orbitMaxAzimuthAngle = v3d.MathUtils.degToRad(param);
                break;
            case 'ORBIT_ALLOW_TURNOVER':
                cam.controls.orbitEnableTurnover = param;
                break;
            case 'ENABLE_COLLISIONS':
                cam.controls.enableCollisions = param;
                break;
            case 'CLIP_START':
                cam.near = param;
                cam.updateProjectionMatrix();
                break;
            case 'CLIP_END':
                cam.far = param;
                cam.updateProjectionMatrix();
                break;
        }

        if (isSetControlsParam)
            appInstance.enableControls();

    });
}

// show and hide puzzles
function changeVis(objSelector, bool) {
    var objNames = PzLib.retrieveObjectNames(objSelector);

    for (var i = 0; i < objNames.length; i++) {
        var objName = objNames[i]
        if (!objName)
            continue;
        var obj = PzLib.getObjectByName(objName);
        if (!obj)
            continue;
        obj.visible = bool;
        obj.resolveMultiMaterial().forEach(function(objR) {
            objR.visible = bool;
        });
    }
}

// getHTMLElemAttribute puzzle
function getHTMLElemAttribute(attr, id, isParent) {
    var elem = PzLib.getElement(id, isParent);
    return elem ? elem[attr]: '';
}

function setMorphFactor(objName, targetName, factor) {

    if (objName && targetName) {
        var obj = PzLib.getObjectByName(objName);
        if (obj) {
            obj.resolveMultiMaterial().forEach(function(objR) {
                if (objR.morphTargetDictionary && targetName in objR.morphTargetDictionary) {
                    var idx = objR.morphTargetDictionary[targetName];
                    objR.morphTargetInfluences[idx] = Number(factor);
                }
            });

            obj.resolveMultiMaterial().forEach(function(objR) {
                objR.getAuxClippingMeshes().forEach(function(objC) {
                    if (objC.morphTargetDictionary && targetName in objC.morphTargetDictionary) {
                        var idx = objC.morphTargetDictionary[targetName];
                        objC.morphTargetInfluences[idx] = Number(factor);
                    }
                });
            });
        }
    }

}

// isObjectVisible puzzle
function isObjectVisible(objSelector) {
    var objNames = PzLib.retrieveObjectNames(objSelector);

    for (var i = 0; i < objNames.length; i++) {
        var objName = objNames[i]
        if (!objName)
            continue;
        var obj = PzLib.getObjectByName(objName);
        if (!obj)
            continue;
        if (obj.visible)
            return true;
    }
    return false;
}


// Wiata 3x6 wybór koloru dachu
eventHTMLElem('click', '4.1.a', true, function(event) {
  assignMat(['GROUP', 'Profil 3x6'], 'Metal Gray');
  assignMat(['GROUP', 'Profil 6x6'], 'Metal Gray');
  assignMat('PG tył profil 1', 'Metal Gray');
  assignMat('PG tył profil 2', 'Metal Gray');
  assignMat('PG tył profil 3', 'Metal Gray');
  assignMat('PG tył profil 4', 'Metal Gray');
  assignMat('PG tył profil 5', 'Metal Gray');
  assignMat('PG tył profil 6', 'Metal Gray');
  assignMat('Profil garaż lewy  1 700', 'Metal Gray');
  assignMat('Profil garaż lewy  2 700', 'Metal Gray');
  assignMat('Profil garaż lewy  2 900', 'Metal Gray');
  assignMat('Profil garaż lewy  3', 'Metal Gray');
  assignMat('Profil garaż lewy  4 700', 'Metal Gray');
  assignMat('Profil garaż lewy  4 900', 'Metal Gray');
  assignMat('Profil garaż lewy  5 700', 'Metal Gray');
  assignMat('Profil garaż prawy 1 700', 'Metal Gray');
  assignMat('Profil garaż prawy 2 700', 'Metal Gray');
  assignMat('Profil garaż prawy 2 900', 'Metal Gray');
  assignMat('Profil garaż prawy 3', 'Metal Gray');
  assignMat('Profil garaż prawy 4 700', 'Metal Gray');
  assignMat('Profil garaż prawy 4 900', 'Metal Gray');
  assignMat('Profil garaż prawy 5 700', 'Metal Gray');
  assignMat('PG lewe profil 3', 'Metal Gray');
  assignMat('PG lewe profil 700 1', 'Metal Gray');
  assignMat('PG lewe profil 700 2', 'Metal Gray');
  assignMat('PG lewe profil 700 3', 'Metal Gray');
  assignMat('PG lewe profil 700 4', 'Metal Gray');
  assignMat('PG lewe profil 900 1', 'Metal Gray');
  assignMat('PG lewe profil 900 2', 'Metal Gray');
  assignMat('PG prawe profil 3', 'Metal Gray');
  assignMat('PG prawe profil 700 1', 'Metal Gray');
  assignMat('PG prawe profil 700 2', 'Metal Gray');
  assignMat('PG prawe profil 700 3', 'Metal Gray');
  assignMat('PG prawe profil 700 4', 'Metal Gray');
  assignMat('PG prawe profil 900 1', 'Metal Gray');
  assignMat('PG prawe profil 900 2', 'Metal Gray');
  assignMat('Profil Wielostan 1 700', 'Metal Gray');
  assignMat('Profil Wielostan 2 700', 'Metal Gray');
  assignMat('Profil Wielostan 3', 'Metal Gray');
  assignMat('Profil Wielostan 2 900', 'Metal Gray');
  assignMat('Profil Wielostan 4 700', 'Metal Gray');
  assignMat('Profil Wielostan 4 900', 'Metal Gray');
  assignMat('Profil Wielostan 5 700', 'Metal Gray');
  assignMat('Profil Wielostan dodatek', 'Metal Gray');
});
// Wiata 3x6 wybór koloru dachu
eventHTMLElem('click', '4.1.b', true, function(event) {
  assignMat(['GROUP', 'Profil 3x6'], 'Bronze');
  assignMat(['GROUP', 'Profil 6x6'], 'Bronze');
  assignMat('PG tył profil 1', 'Bronze');
  assignMat('PG tył profil 2', 'Bronze');
  assignMat('PG tył profil 3', 'Bronze');
  assignMat('PG tył profil 4', 'Bronze');
  assignMat('PG tył profil 5', 'Bronze');
  assignMat('PG tył profil 6', 'Bronze');
  assignMat('Profil garaż lewy  1 700', 'Bronze');
  assignMat('Profil garaż lewy  2 700', 'Bronze');
  assignMat('Profil garaż lewy  2 900', 'Bronze');
  assignMat('Profil garaż lewy  3', 'Bronze');
  assignMat('Profil garaż lewy  4 700', 'Bronze');
  assignMat('Profil garaż lewy  4 900', 'Bronze');
  assignMat('Profil garaż lewy  5 700', 'Bronze');
  assignMat('Profil garaż prawy 1 700', 'Bronze');
  assignMat('Profil garaż prawy 2 700', 'Bronze');
  assignMat('Profil garaż prawy 2 900', 'Bronze');
  assignMat('Profil garaż prawy 3', 'Bronze');
  assignMat('Profil garaż prawy 4 700', 'Bronze');
  assignMat('Profil garaż prawy 4 900', 'Bronze');
  assignMat('Profil garaż prawy 5 700', 'Bronze');
  assignMat('PG lewe profil 3', 'Bronze');
  assignMat('PG lewe profil 700 1', 'Bronze');
  assignMat('PG lewe profil 700 2', 'Bronze');
  assignMat('PG lewe profil 700 3', 'Bronze');
  assignMat('PG lewe profil 700 4', 'Bronze');
  assignMat('PG lewe profil 900 1', 'Bronze');
  assignMat('PG lewe profil 900 2', 'Bronze');
  assignMat('PG prawe profil 3', 'Bronze');
  assignMat('PG prawe profil 700 1', 'Bronze');
  assignMat('PG prawe profil 700 2', 'Bronze');
  assignMat('PG prawe profil 700 3', 'Bronze');
  assignMat('PG prawe profil 700 4', 'Bronze');
  assignMat('PG prawe profil 900 1', 'Bronze');
  assignMat('PG prawe profil 900 2', 'Bronze');
  assignMat('Profil Wielostan 1 700', 'Bronze');
  assignMat('Profil Wielostan 2 700', 'Bronze');
  assignMat('Profil Wielostan 3', 'Bronze');
  assignMat('Profil Wielostan 2 900', 'Bronze');
  assignMat('Profil Wielostan 4 700', 'Bronze');
  assignMat('Profil Wielostan 4 900', 'Bronze');
  assignMat('Profil Wielostan 5 700', 'Bronze');
  assignMat('Profil Wielostan dodatek', 'Bronze');
});
// Wiata 3x6 wybór koloru dachu
eventHTMLElem('click', '4.1.c', true, function(event) {
  assignMat(['GROUP', 'Profil 3x6'], 'Bronze Light');
  assignMat(['GROUP', 'Profil 6x6'], 'Bronze Light');
  assignMat('PG tył profil 1', 'Bronze Light');
  assignMat('PG tył profil 2', 'Bronze Light');
  assignMat('PG tył profil 3', 'Bronze Light');
  assignMat('PG tył profil 4', 'Bronze Light');
  assignMat('PG tył profil 5', 'Bronze Light');
  assignMat('PG tył profil 6', 'Bronze Light');
  assignMat('Profil garaż lewy  1 700', 'Bronze Light');
  assignMat('Profil garaż lewy  2 700', 'Bronze Light');
  assignMat('Profil garaż lewy  2 900', 'Bronze Light');
  assignMat('Profil garaż lewy  3', 'Bronze Light');
  assignMat('Profil garaż lewy  4 700', 'Bronze Light');
  assignMat('Profil garaż lewy  4 900', 'Bronze Light');
  assignMat('Profil garaż lewy  5 700', 'Bronze Light');
  assignMat('Profil garaż prawy 1 700', 'Bronze Light');
  assignMat('Profil garaż prawy 2 700', 'Bronze Light');
  assignMat('Profil garaż prawy 2 900', 'Bronze Light');
  assignMat('Profil garaż prawy 3', 'Bronze Light');
  assignMat('Profil garaż prawy 4 700', 'Bronze Light');
  assignMat('Profil garaż prawy 4 900', 'Bronze Light');
  assignMat('Profil garaż prawy 5 700', 'Bronze Light');
  assignMat('PG lewe profil 3', 'Bronze Light');
  assignMat('PG lewe profil 700 1', 'Bronze Light');
  assignMat('PG lewe profil 700 2', 'Bronze Light');
  assignMat('PG lewe profil 700 3', 'Bronze Light');
  assignMat('PG lewe profil 700 4', 'Bronze Light');
  assignMat('PG lewe profil 900 1', 'Bronze Light');
  assignMat('PG lewe profil 900 2', 'Bronze Light');
  assignMat('PG prawe profil 3', 'Bronze Light');
  assignMat('PG prawe profil 700 1', 'Bronze Light');
  assignMat('PG prawe profil 700 2', 'Bronze Light');
  assignMat('PG prawe profil 700 3', 'Bronze Light');
  assignMat('PG prawe profil 700 4', 'Bronze Light');
  assignMat('PG prawe profil 900 1', 'Bronze Light');
  assignMat('PG prawe profil 900 2', 'Bronze Light');
  assignMat('Profil Wielostan 1 700', 'Bronze Light');
  assignMat('Profil Wielostan 2 700', 'Bronze Light');
  assignMat('Profil Wielostan 3', 'Bronze Light');
  assignMat('Profil Wielostan 2 900', 'Bronze Light');
  assignMat('Profil Wielostan 4 700', 'Bronze Light');
  assignMat('Profil Wielostan 4 900', 'Bronze Light');
  assignMat('Profil Wielostan 5 700', 'Bronze Light');
  assignMat('Profil Wielostan dodatek', 'Bronze Light');
});
// Wiata 3x6 wybór koloru dachu
eventHTMLElem('click', '4.1.d', true, function(event) {
  assignMat(['GROUP', 'Profil 3x6'], 'Silver');
  assignMat(['GROUP', 'Profil 6x6'], 'Silver');
  assignMat('PG tył profil 1', 'Silver');
  assignMat('PG tył profil 2', 'Silver');
  assignMat('PG tył profil 3', 'Silver');
  assignMat('PG tył profil 4', 'Silver');
  assignMat('PG tył profil 5', 'Silver');
  assignMat('PG tył profil 6', 'Silver');
  assignMat('Profil garaż lewy  1 700', 'Silver');
  assignMat('Profil garaż lewy  2 700', 'Silver');
  assignMat('Profil garaż lewy  2 900', 'Silver');
  assignMat('Profil garaż lewy  3', 'Silver');
  assignMat('Profil garaż lewy  4 700', 'Silver');
  assignMat('Profil garaż lewy  4 900', 'Silver');
  assignMat('Profil garaż lewy  5 700', 'Silver');
  assignMat('Profil garaż prawy 1 700', 'Silver');
  assignMat('Profil garaż prawy 2 700', 'Silver');
  assignMat('Profil garaż prawy 2 900', 'Silver');
  assignMat('Profil garaż prawy 3', 'Silver');
  assignMat('Profil garaż prawy 4 700', 'Silver');
  assignMat('Profil garaż prawy 4 900', 'Silver');
  assignMat('Profil garaż prawy 5 700', 'Silver');
  assignMat('PG lewe profil 3', 'Silver');
  assignMat('PG lewe profil 700 1', 'Silver');
  assignMat('PG lewe profil 700 2', 'Silver');
  assignMat('PG lewe profil 700 3', 'Silver');
  assignMat('PG lewe profil 700 4', 'Silver');
  assignMat('PG lewe profil 900 1', 'Silver');
  assignMat('PG lewe profil 900 2', 'Silver');
  assignMat('PG prawe profil 3', 'Silver');
  assignMat('PG prawe profil 700 1', 'Silver');
  assignMat('PG prawe profil 700 2', 'Silver');
  assignMat('PG prawe profil 700 3', 'Silver');
  assignMat('PG prawe profil 700 4', 'Silver');
  assignMat('PG prawe profil 900 1', 'Silver');
  assignMat('PG prawe profil 900 2', 'Silver');
  assignMat('Profil Wielostan 1 700', 'Silver');
  assignMat('Profil Wielostan 2 700', 'Silver');
  assignMat('Profil Wielostan 3', 'Silver');
  assignMat('Profil Wielostan 2 900', 'Silver');
  assignMat('Profil Wielostan 4 700', 'Silver');
  assignMat('Profil Wielostan 4 900', 'Silver');
  assignMat('Profil Wielostan 5 700', 'Silver');
  assignMat('Profil Wielostan dodatek', 'Silver');
});
// Wiata 3x6 wybór koloru dachu
eventHTMLElem('click', '4.1.e', true, function(event) {
  assignMat(['GROUP', 'Profil 3x6'], 'Black');
  assignMat(['GROUP', 'Profil 6x6'], 'Black');
  assignMat('PG tył profil 1', 'Black');
  assignMat('PG tył profil 2', 'Black');
  assignMat('PG tył profil 3', 'Black');
  assignMat('PG tył profil 4', 'Black');
  assignMat('PG tył profil 5', 'Black');
  assignMat('PG tył profil 6', 'Black');
  assignMat('Profil garaż lewy  1 700', 'Black');
  assignMat('Profil garaż lewy  2 700', 'Black');
  assignMat('Profil garaż lewy  2 900', 'Black');
  assignMat('Profil garaż lewy  3', 'Black');
  assignMat('Profil garaż lewy  4 700', 'Black');
  assignMat('Profil garaż lewy  4 900', 'Black');
  assignMat('Profil garaż lewy  5 700', 'Black');
  assignMat('Profil garaż prawy 1 700', 'Black');
  assignMat('Profil garaż prawy 2 700', 'Black');
  assignMat('Profil garaż prawy 2 900', 'Black');
  assignMat('Profil garaż prawy 3', 'Black');
  assignMat('Profil garaż prawy 4 700', 'Black');
  assignMat('Profil garaż prawy 4 900', 'Black');
  assignMat('Profil garaż prawy 5 700', 'Black');
  assignMat('PG lewe profil 3', 'Black');
  assignMat('PG lewe profil 700 1', 'Black');
  assignMat('PG lewe profil 700 2', 'Black');
  assignMat('PG lewe profil 700 3', 'Black');
  assignMat('PG lewe profil 700 4', 'Black');
  assignMat('PG lewe profil 900 1', 'Black');
  assignMat('PG lewe profil 900 2', 'Black');
  assignMat('PG prawe profil 3', 'Black');
  assignMat('PG prawe profil 700 1', 'Black');
  assignMat('PG prawe profil 700 2', 'Black');
  assignMat('PG prawe profil 700 3', 'Black');
  assignMat('PG prawe profil 700 4', 'Black');
  assignMat('PG prawe profil 900 1', 'Black');
  assignMat('PG prawe profil 900 2', 'Black');
  assignMat('Profil Wielostan 1 700', 'Black');
  assignMat('Profil Wielostan 2 700', 'Black');
  assignMat('Profil Wielostan 3', 'Black');
  assignMat('Profil Wielostan 2 900', 'Black');
  assignMat('Profil Wielostan 4 700', 'Black');
  assignMat('Profil Wielostan 4 900', 'Black');
  assignMat('Profil Wielostan 5 700', 'Black');
  assignMat('Profil Wielostan dodatek', 'Black');
});
// Wiata 3x6 wybór koloru dachu
eventHTMLElem('click', '4.1.f', true, function(event) {
  assignMat(['GROUP', 'Profil 3x6'], 'White');
  assignMat(['GROUP', 'Profil 6x6'], 'White');
  assignMat('PG tył profil 1', 'White');
  assignMat('PG tył profil 2', 'White');
  assignMat('PG tył profil 3', 'White');
  assignMat('PG tył profil 4', 'White');
  assignMat('PG tył profil 5', 'White');
  assignMat('PG tył profil 6', 'White');
  assignMat('Profil garaż lewy  1 700', 'White');
  assignMat('Profil garaż lewy  2 700', 'White');
  assignMat('Profil garaż lewy  2 900', 'White');
  assignMat('Profil garaż lewy  3', 'White');
  assignMat('Profil garaż lewy  4 700', 'White');
  assignMat('Profil garaż lewy  4 900', 'White');
  assignMat('Profil garaż lewy  5 700', 'White');
  assignMat('Profil garaż prawy 1 700', 'White');
  assignMat('Profil garaż prawy 2 700', 'White');
  assignMat('Profil garaż prawy 2 900', 'White');
  assignMat('Profil garaż prawy 3', 'White');
  assignMat('Profil garaż prawy 4 700', 'White');
  assignMat('Profil garaż prawy 4 900', 'White');
  assignMat('Profil garaż prawy 5 700', 'White');
  assignMat('PG lewe profil 3', 'White');
  assignMat('PG lewe profil 700 1', 'White');
  assignMat('PG lewe profil 700 2', 'White');
  assignMat('PG lewe profil 700 3', 'White');
  assignMat('PG lewe profil 700 4', 'White');
  assignMat('PG lewe profil 900 1', 'White');
  assignMat('PG lewe profil 900 2', 'White');
  assignMat('PG prawe profil 3', 'White');
  assignMat('PG prawe profil 700 1', 'White');
  assignMat('PG prawe profil 700 2', 'White');
  assignMat('PG prawe profil 700 3', 'White');
  assignMat('PG prawe profil 700 4', 'White');
  assignMat('PG prawe profil 900 1', 'White');
  assignMat('PG prawe profil 900 2', 'White');
  assignMat('Profil Wielostan 1 700', 'White');
  assignMat('Profil Wielostan 2 700', 'White');
  assignMat('Profil Wielostan 3', 'White');
  assignMat('Profil Wielostan 2 900', 'White');
  assignMat('Profil Wielostan 4 700', 'White');
  assignMat('Profil Wielostan 4 900', 'White');
  assignMat('Profil Wielostan 5 700', 'White');
  assignMat('Profil Wielostan dodatek', 'White');
});

registerInterval(10, function() {

  Function('app', 'v3d', 'puzzles', 'VARS', 'PROC', (('app.scene.traverse(function(object) {' + '\n' +
  '  if (object.isMesh) {' + '\n' +
  '    v3d.MaterialUtils.disposeTextures(object.material);' + '\n' +
  '    object.material.dispose();' + '\n' +
  '    object.geometry.dispose();' + '\n' +
  '  }' + '\n' +
  '});')))(appInstance, v3d, PL, VARS, PROC);

});

eventHTMLElem('click', 'Podsumowanie', true, function(event) {
  tweenCamera('', 'Dach 3x6', 1, function() {}, 0);
  setScreenScale(2.5);
});
setCameraParam('KEYBOARD_CONTROLS', ['ALL_OBJECTS'], false);

// Wybór między wiatą 3x6 a 6x6 (wiata wielo stanowiskowa jeszcze do zrobienia)
eventHTMLElem('click', '1.a', true, function(event) {
  Wiata1 = 1;
  Wiata2 = 0;
  Wiata3 = 0;
  my_5_a = 1;
  assignMat(['GROUP', 'Wielostanowiskowa'], 'Metal Gray');
  assignMat(['GROUP', 'Dwustanowiskowa'], 'Metal Gray');
  assignMat(['GROUP', 'Jednostanowiskowa'], 'Metal Gray');
  changeVis([['GROUP', 'Dach 1'], ['GROUP', 'Maskownica 1'], 'Falista 3x6 6.1.a', 'Falista 3x6 6.1.b', 'Falista 3x6 6.1.c', 'Falista 3x6 6.1.d', 'Falista 3x6 6.1.e', 'Falista 3x6 6.1.f', 'Falista 3x6 6.1.g', 'Profil 3x6 dodatek', 'Profil 3x6 1 700', 'Profil 3x6 2 700', 'Profil 3x6 4 700', 'Profil 3x6 5 700'], true);
  changeVis([['GROUP', 'Dwustanowiskowa'], ['GROUP', 'Wielostanowiskowa'], ['GROUP', 'Horyzontal 3x6'], ['GROUP', 'Modern Plus 3x6'], ['GROUP', 'Zaluzja 3x6'], ['GROUP', 'Ściany 1'], 'Profil 3x6 2 900', 'Profil 3x6  3', 'Profil 3x6 4 900', 'Falista 3x6 6.1.a2', 'Falista 3x6 6.1.b2', 'Falista 3x6 6.1.c2', 'Falista 3x6 6.1.e2', 'Falista 3x6 6.1.f2', 'Falista 3x6 6.1.g2', 'Falista 3x6 6.1.y', 'Falista 3x6 6.1.z', ['GROUP', 'Ściany 2'], ['GROUP', 'Ściany 3']], false);
});
// Wybór między wiatą 3x6 a 6x6 (wiata wielo stanowiskowa jeszcze do zrobienia)
eventHTMLElem('click', '1.b', true, function(event) {
  Wiata1 = 0;
  Wiata2 = 1;
  Wiata3 = 0;
  my_5_a = 1;
  PomB = 0;
  PomL = 0;
  PomP = 0;
  SB = 0;
  SL = 0;
  SP = 0;
  assignMat(['GROUP', 'Wielostanowiskowa'], 'Metal Gray');
  assignMat(['GROUP', 'Dwustanowiskowa'], 'Metal Gray');
  assignMat(['GROUP', 'Jednostanowiskowa'], 'Metal Gray');
  changeVis([['GROUP', 'Dach 2'], ['GROUP', 'Maskownica 2'], 'Falista 6x6 6.1.a', 'Falista 6x6 6.1.b', 'Falista 6x6 6.1.c', 'Falista 6x6 6.1.d', 'Falista 6x6 6.1.e', 'Falista 6x6 6.1.h', 'Falista 6x6 6.1.f', 'Falista 6x6 6.1.g', 'Profil 6x6 tył', 'Profil 6x6 1 700', 'Profil 6x6 2 700', 'Profil 6x6 4 700', 'Profil 6x6 5 700'], true);
  changeVis([['GROUP', 'Jednostanowiskowa'], ['GROUP', 'Wielostanowiskowa'], ['GROUP', 'Horyzontal 6x6'], ['GROUP', 'Modern Plus 6x6'], ['GROUP', 'Zaluzja 6x6'], ['GROUP', 'Ściany 2'], 'Profil 6x6 2 900', 'Profil 6x6  3', 'Profil 6x6 4 900', 'Falista 6x6 6.1.a2', 'Falista 6x6 6.1.b2', 'Falista 6x6 6.1.c2', 'Falista 6x6 6.1.e2', 'Falista 6x6 6.1.f2', 'Falista 6x6 6.1.g2', 'Falista 6x6 6.1.y', 'Falista 6x6 6.1.z', ['GROUP', 'Ściany 1'], ['GROUP', 'Ściany 3'], ['GROUP', 'Garaż lewy'], ['GROUP', 'PG lewe'], ['GROUP', 'PG tył'], ['GROUP', 'PG prawe'], ['GROUP', 'Garaż prawy']], false);
});
// Wybór między wiatą 3x6 a 6x6 (wiata wielo stanowiskowa jeszcze do zrobienia)
eventHTMLElem('click', '1.c', true, function(event) {
  Wiata1 = 0;
  Wiata2 = 0;
  Wiata3 = 1;
  my_5_a = 1;
  assignMat(['GROUP', 'Wielostanowiskowa'], 'Metal Gray');
  assignMat(['GROUP', 'Dwustanowiskowa'], 'Metal Gray');
  assignMat(['GROUP', 'Jednostanowiskowa'], 'Metal Gray');
  changeVis([['GROUP', 'Dach 2'], ['GROUP', 'Dach 3'], ['GROUP', 'Maskownica 3'], ['GROUP', 'Profil Wielostan'], ['GROUP', 'Falista Wielostan'], 'Falista 6x6 6.1.a', 'Falista 6x6 6.1.b', 'Falista 6x6 6.1.h', 'Falista 6x6 6.1.c', 'Falista 6x6 6.1.d', 'Profil 6x6 1 700', 'Profil 6x6 2 700', 'Profil 6x6 tył', 'Profil 6x6 4 700', 'Profil 6x6 5 700', 'Profil Podluzny 6x6', 'Profil Poprzeczny 6x6'], true);
  changeVis([['GROUP', 'Jednostanowiskowa'], ['GROUP', 'Horyzontal 6x6'], ['GROUP', 'Modern Plus 6x6'], ['GROUP', 'Zaluzja 6x6'], ['GROUP', 'Maskownica 2'], 'Falista 6x6 6.1.e', 'Falista 6x6 6.1.e2', 'Falista 6x6 6.1.f', 'Falista 6x6 6.1.f2', 'Falista 6x6 6.1.g', 'Falista 6x6 6.1.g2', 'Falista 6x6 6.1.z', 'Falista Wielostan 6.1.e2', 'Falista Wielostan 6.1.f2', 'Falista Wielostan 6.1.g2', 'Falista Wielostan 6.1.z', 'Profil 6x6 2 900', 'Profil 6x6 4 900', 'Profil 6x6  3', 'Profil Wielostan 2 900', 'Profil Wielostan 4 900', 'Profil Wielostan 3', ['GROUP', 'Garaż'], ['GROUP', 'Pomieszczenia Gospodarcze'], ['GROUP', 'Zaluzja Wielostan'], ['GROUP', 'Horyzontal Wielostan'], ['GROUP', 'Modern Plus Wielostan'], ['GROUP', 'Ściany 1'], ['GROUP', 'Ściany 2'], ['GROUP', 'Ściany 3']], false);
});
// Wybór między wiatą 3x6 a 6x6 (wiata wielo stanowiskowa jeszcze do zrobienia)
eventHTMLElem('click', '1.d', true, function(event) {
  Wiata1 = 0;
  Wiata2 = 1;
  Wiata3 = 0;
  my_5_a = 1;
  GaL = 1;
  PomB = 0;
  PomL = 0;
  PomP = 0;
  SB = 0;
  SL = 0;
  SP = 0;
  assignMat(['GROUP', 'Wielostanowiskowa'], 'Metal Gray');
  assignMat(['GROUP', 'Dwustanowiskowa'], 'Metal Gray');
  assignMat(['GROUP', 'Jednostanowiskowa'], 'Metal Gray');
  changeVis([['GROUP', 'Dach 2'], ['GROUP', 'Maskownica 2'], 'Falista 6x6 6.1.a', 'Falista 6x6 6.1.b', 'Falista 6x6 6.1.c', 'Falista 6x6 6.1.d', 'Falista 6x6 6.1.e', 'Falista 6x6 6.1.h', 'Falista 6x6 6.1.f', 'Falista 6x6 6.1.g', 'Profil 6x6 tył', 'Profil 6x6 1 700', 'Profil 6x6 2 700', 'Profil 6x6 4 700', 'Profil 6x6 5 700', ['GROUP', 'Garaż lewy'], null, null, null], true);
  changeVis([['GROUP', 'Jednostanowiskowa'], ['GROUP', 'Wielostanowiskowa'], ['GROUP', 'Horyzontal 6x6'], ['GROUP', 'Modern Plus 6x6'], ['GROUP', 'Zaluzja 6x6'], ['GROUP', 'Ściany 2'], 'Profil 6x6 2 900', 'Profil 6x6  3', 'Profil 6x6 4 900', 'Falista 6x6 6.1.a2', 'Falista 6x6 6.1.b2', 'Falista 6x6 6.1.c2', 'Falista 6x6 6.1.e2', 'Falista 6x6 6.1.f2', 'Falista 6x6 6.1.g2', 'Falista 6x6 6.1.y', 'Falista 6x6 6.1.z', 'Profil garaż lewy  2 900', ['GROUP', 'Ściany 1'], 'Profil garaż lewy  4 900', 'Profil garaż lewy  3', ['GROUP', 'PG lewe'], ['GROUP', 'PG tył'], ['GROUP', 'PG prawe'], ['GROUP', 'Ściany 3'], ['GROUP', 'Garaż prawy'], null], false);
});
// Wybór między wiatą 3x6 a 6x6 (wiata wielo stanowiskowa jeszcze do zrobienia)
eventHTMLElem('click', '1.e', true, function(event) {
  Wiata1 = 0;
  Wiata2 = 1;
  Wiata3 = 0;
  my_5_a = 1;
  PomB = 0;
  SB = 0;
  SL = 0;
  SP = 0;
  assignMat(['GROUP', 'Wielostanowiskowa'], 'Metal Gray');
  assignMat(['GROUP', 'Dwustanowiskowa'], 'Metal Gray');
  assignMat(['GROUP', 'Jednostanowiskowa'], 'Metal Gray');
  changeVis([null, null, 'Falista 6x6 6.1.a', 'Falista 6x6 6.1.b', 'Falista 6x6 6.1.c', 'Falista 6x6 6.1.d', 'Falista 6x6 6.1.e', 'Falista 6x6 6.1.h', 'Falista 6x6 6.1.f', 'Falista 6x6 6.1.g', 'Profil 6x6 tył', 'Profil 6x6 1 700', 'Profil 6x6 2 700', 'Profil 6x6 4 700', 'Profil 6x6 5 700', ['GROUP', 'PG lewe'], null, null, null], true);
  changeVis([['GROUP', 'Jednostanowiskowa'], ['GROUP', 'Wielostanowiskowa'], ['GROUP', 'Horyzontal 6x6'], ['GROUP', 'Modern Plus 6x6'], ['GROUP', 'Zaluzja 6x6'], ['GROUP', 'Ściany 2'], 'Profil 6x6 2 900', 'Profil 6x6  3', 'Profil 6x6 4 900', 'Falista 6x6 6.1.a2', 'Falista 6x6 6.1.b2', 'Falista 6x6 6.1.c2', 'Falista 6x6 6.1.e2', 'Falista 6x6 6.1.f2', 'Falista 6x6 6.1.g2', 'Falista 6x6 6.1.y', 'Falista 6x6 6.1.z', 'Profil garaż lewy  2 900', ['GROUP', 'Ściany 1'], 'Profil garaż lewy  4 900', 'Profil garaż lewy  3', ['GROUP', 'Garaż lewy'], ['GROUP', 'PG tył'], ['GROUP', 'Maskownica 2'], ['GROUP', 'Ściany 3'], ['GROUP', 'Dach 2'], ['GROUP', 'Garaż prawy'], ['GROUP', 'PG prawe'], 'PG lewe profil 900 1', 'PG lewe profil 900 2', 'PG lewe profil 3'], false);
});
// Wybór między wiatą 3x6 a 6x6 (wiata wielo stanowiskowa jeszcze do zrobienia)
eventHTMLElem('click', '1.f', true, function(event) {
  Wiata1 = 0;
  Wiata2 = 1;
  Wiata3 = 0;
  my_5_a = 1;
  PomB = 1;
  PomL = 0;
  PomP = 0;
  SB = 0;
  SL = 0;
  SP = 0;
  assignMat(['GROUP', 'Wielostanowiskowa'], 'Metal Gray');
  assignMat(['GROUP', 'Dwustanowiskowa'], 'Metal Gray');
  assignMat(['GROUP', 'Jednostanowiskowa'], 'Metal Gray');
  changeVis([null, null, 'Falista 6x6 6.1.a', 'Falista 6x6 6.1.b', 'Falista 6x6 6.1.c', 'Falista 6x6 6.1.d', 'Falista 6x6 6.1.e', 'Falista 6x6 6.1.h', 'Falista 6x6 6.1.f', 'Falista 6x6 6.1.g', 'Profil 6x6 tył', 'Profil 6x6 1 700', 'Profil 6x6 2 700', 'Profil 6x6 4 700', 'Profil 6x6 5 700', ['GROUP', 'PG tył'], null, null, null], true);
  changeVis([['GROUP', 'Jednostanowiskowa'], ['GROUP', 'Wielostanowiskowa'], ['GROUP', 'Horyzontal 6x6'], ['GROUP', 'Modern Plus 6x6'], ['GROUP', 'Zaluzja 6x6'], ['GROUP', 'Ściany 2'], 'Profil 6x6 2 900', 'Profil 6x6  3', 'Profil 6x6 4 900', 'Falista 6x6 6.1.a2', 'Falista 6x6 6.1.b2', 'Falista 6x6 6.1.c2', 'Falista 6x6 6.1.e2', 'Falista 6x6 6.1.f2', 'Falista 6x6 6.1.g2', 'Falista 6x6 6.1.y', 'Falista 6x6 6.1.z', 'Profil garaż lewy  2 900', ['GROUP', 'Ściany 1'], 'Profil garaż lewy  4 900', 'Profil garaż lewy  3', ['GROUP', 'Garaż lewy'], ['GROUP', 'PG lewe'], ['GROUP', 'Maskownica 2'], ['GROUP', 'Ściany 3'], ['GROUP', 'Dach 2'], ['GROUP', 'PG prawe'], ['GROUP', 'Garaż prawy']], false);
});

eventHTMLElem('input', 'slider', false, function(event) {
  setMorphFactor('Ceowniki 3x6', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Maskownica 3x6', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Profil Podluzny 3x6', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Profil Poprzeczny 3x6', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Narozniki 3x6', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Dach 3x6', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Profil 3x6 1 700', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Profil 3x6 2 700', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Profil 3x6 2 900', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Profil 3x6  3', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Profil 3x6 4 700', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Profil 3x6 4 900', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Profil 3x6 5 700', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Profil 3x6 dodatek', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Falista 3x6 6.1.a', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Falista 3x6 6.1.a2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Falista 3x6 6.1.b2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Falista 3x6 6.1.b', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Falista 3x6 6.1.c', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Falista 3x6 6.1.c2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Falista 3x6 6.1.d', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Falista 3x6 6.1.e2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Falista 3x6 6.1.e', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Falista 3x6 6.1.f', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Falista 3x6 6.1.f2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Falista 3x6 6.1.g', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Falista 3x6 6.1.g2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Falista 3x6 6.1.y', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Falista 3x6 6.1.z', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Horyzontal 3x6 6.1.a', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Horyzontal 3x6 6.1.a2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Horyzontal 3x6 6.1.b', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Horyzontal 3x6 6.1.b2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Horyzontal 3x6 6.1.c', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Horyzontal 3x6 6.1.c2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Horyzontal 3x6 6.1.d', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Horyzontal 3x6 6.1.e', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Horyzontal 3x6 6.1.e2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Horyzontal 3x6 6.1.f', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Horyzontal 3x6 6.1.f2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Horyzontal 3x6 6.1.g', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Horyzontal 3x6 6.1.g2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Horyzontal 3x6 6.1.y', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Horyzontal 3x6 6.1.z', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Modern Plus 3x6 6.1.a', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Modern Plus 3x6 6.1.a2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Modern Plus 3x6 6.1.b', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Modern Plus 3x6 6.1.b2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Modern Plus 3x6 6.1.c', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Modern Plus 3x6 6.1.c2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Modern Plus 3x6 6.1.d', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Modern Plus 3x6 6.1.e', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Modern Plus 3x6 6.1.e2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Modern Plus 3x6 6.1.f', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Modern Plus 3x6 6.1.f2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Modern Plus 3x6 6.1.g', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Modern Plus 3x6 6.1.g2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Modern Plus 3x6 6.1.y', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Modern Plus 3x6 6.1.z', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Zaluzja 3x6 6.1.a', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Zaluzja 3x6 6.1.a2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Zaluzja 3x6 6.1.b', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Zaluzja 3x6 6.1.b2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Zaluzja 3x6 6.1.c', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Zaluzja 3x6 6.1.c2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Zaluzja 3x6 6.1.d', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Zaluzja 3x6 6.1.e', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Zaluzja 3x6 6.1.e2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Zaluzja 3x6 6.1.f', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Zaluzja 3x6 6.1.f2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Zaluzja 3x6 6.1.g', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Zaluzja 3x6 6.1.g2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Zaluzja 3x6 6.1.y', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Zaluzja 3x6 6.1.z', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('ScianaB', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('ScianaL', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('ScianaP', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Ceowniki 6x6', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Maskownica 6x6', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Profil Podluzny 6x6', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Profil Poprzeczny 6x6', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Narozniki 6x6', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Dach 6x6', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Profil 6x6 tył', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Profil 6x6 1 700', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Profil 6x6 2 700', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Profil 6x6 2 900', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Profil 6x6  3', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Profil 6x6 4 700', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Profil 6x6 4 900', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Profil 6x6 5 700', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Profil 6x6 tył', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Falista 6x6 6.1.a', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Falista 6x6 6.1.a2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Falista 6x6 6.1.b', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Falista 6x6 6.1.b2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Falista 6x6 6.1.c', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Falista 6x6 6.1.c2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Falista 6x6 6.1.d', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Falista 6x6 6.1.e2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Falista 6x6 6.1.e', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Falista 6x6 6.1.f', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Falista 6x6 6.1.f2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Falista 6x6 6.1.g', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Falista 6x6 6.1.g2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Falista 6x6 6.1.h', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Falista 6x6 6.1.y', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Falista 6x6 6.1.z', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Horyzontal 6x6 6.1.a', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Horyzontal 6x6 6.1.a2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Horyzontal 6x6 6.1.b', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Horyzontal 6x6 6.1.b2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Horyzontal 6x6 6.1.c', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Horyzontal 6x6 6.1.c2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Horyzontal 6x6 6.1.d', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Horyzontal 6x6 6.1.e', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Horyzontal 6x6 6.1.e2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Horyzontal 6x6 6.1.f', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Horyzontal 6x6 6.1.f2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Horyzontal 6x6 6.1.g', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Horyzontal 6x6 6.1.g2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Horyzontal 6x6 6.1.h', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Horyzontal 6x6 6.1.y', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Horyzontal 6x6 6.1.z', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Modern Plus 6x6 6.1.a', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Modern Plus 6x6 6.1.a2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Modern Plus 6x6 6.1.b', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Modern Plus 6x6 6.1.b2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Modern Plus 6x6 6.1.c', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Modern Plus 6x6 6.1.c2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Modern Plus 6x6 6.1.d', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Modern Plus 6x6 6.1.e', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Modern Plus 6x6 6.1.e2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Modern Plus 6x6 6.1.f', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Modern Plus 6x6 6.1.f2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Modern Plus 6x6 6.1.g', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Modern Plus 6x6 6.1.g2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Modern Plus 6x6 6.1.h', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Modern Plus 6x6 6.1.y', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Modern Plus 6x6 6.1.z', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Zaluzja 6x6 6.1.a', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Zaluzja 6x6 6.1.a2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Zaluzja 6x6 6.1.b', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Zaluzja 6x6 6.1.b2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Zaluzja 6x6 6.1.c', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Zaluzja 6x6 6.1.c2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Zaluzja 6x6 6.1.d', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Zaluzja 6x6 6.1.e', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Zaluzja 6x6 6.1.e2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Zaluzja 6x6 6.1.f', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Zaluzja 6x6 6.1.f2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Zaluzja 6x6 6.1.g', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Zaluzja 6x6 6.1.g2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Zaluzja 6x6 6.1.h', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Zaluzja 6x6 6.1.y', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Zaluzja 6x6 6.1.z', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('ScianaB', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('ScianaL', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('ScianaP', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('PG prawe', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('PG prawe dach', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('PG prawe maskownica', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('PG prawe profil 3', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('PG prawe profil 700 1', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('PG prawe profil 700 2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('PG prawe profil 700 3', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('PG prawe profil 700 4', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('PG prawe profil 900 1', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('PG prawe profil 900 2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('PG tył', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('PG tył dach', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('PG tył maskownica', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('PG tył profil 1', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('PG tył profil 2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('PG tył profil 3', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('PG tył profil 4', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('PG tył profil 5', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('PG tył profil 6', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('PG lewe', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('PG lewe dach', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('PG lewe maskownica', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('PG lewe profil 3', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('PG lewe profil 700 1', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('PG lewe profil 700 2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('PG lewe profil 700 3', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('PG lewe profil 700 4', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('PG lewe profil 900 1', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('PG lewe profil 900 2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Drzwi lewe', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Panel 1 lewy ', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Panel 2 lewy ', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Panel 3 lewy ', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Panel 4 lewy ', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Panel 5 lewy ', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Panel 6 lewy ', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Panel 7 lewy ', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Profil garaż lewy  1 700', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Profil garaż lewy  2 700', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Profil garaż lewy  2 900', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Profil garaż lewy  3', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Profil garaż lewy  4 700', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Profil garaż lewy  4 900', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Profil garaż lewy  5 700', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Drzwi prawe', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Panel 1 prawy', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Panel 2 prawy', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Panel 3 prawy', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Panel 4 prawy', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Panel 5 prawy', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Panel 6 prawy', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Panel 7 prawy', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Profil garaż prawy 1 700', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Profil garaż prawy 2 700', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Profil garaż prawy 2 900', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Profil garaż prawy 3', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Profil garaż prawy 4 700', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Profil garaż prawy 4 900', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Profil garaż prawy 5 700', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Dach Wielostan', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Profil Wielostan 1 700', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Profil Wielostan 2 700', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Profil Wielostan 2 900', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Profil Wielostan 3', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Profil Wielostan 4 700', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Profil Wielostan 4 900', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Profil Wielostan dodatek', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Profil Wielostan 5 700', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Narozniki Wielostan', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Maskownica Wielostan', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Falista Wielostan 6.1.d', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Falista Wielostan 6.1.e', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Falista Wielostan 6.1.e2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Falista Wielostan 6.1.f', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Falista Wielostan 6.1.f2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Falista Wielostan 6.1.g', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Falista Wielostan 6.1.g2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Falista Wielostan 6.1.z', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Horyzontal Wielostan 6.1.d', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Horyzontal Wielostan 6.1.e', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Horyzontal Wielostan 6.1.e2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Horyzontal Wielostan 6.1.f', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Horyzontal Wielostan 6.1.f2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Horyzontal Wielostan 6.1.g', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Horyzontal Wielostan 6.1.g2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Horyzontal Wielostan 6.1.z', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Modern Plus Wielostan 6.1.d', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Modern Plus Wielostan 6.1.e', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Modern Plus Wielostan 6.1.e2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Modern Plus Wielostan 6.1.f', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Modern Plus Wielostan 6.1.f2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Modern Plus Wielostan 6.1.g', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Modern Plus Wielostan 6.1.g2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Modern Plus Wielostan 6.1.z', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Zaluzja Wielostan 6.1.d', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Zaluzja Wielostan 6.1.e', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Zaluzja Wielostan 6.1.e2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Zaluzja Wielostan 6.1.f', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Zaluzja Wielostan 6.1.f2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Zaluzja Wielostan 6.1.g', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Zaluzja Wielostan 6.1.g2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Zaluzja Wielostan 6.1.z', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Profil Podluzny Wielostan', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('Profil Poprzeczny Wielostan', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('ScianaB2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('ScianaB2Pom', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('ScianaB2PomL', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('ScianaB2PomP', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('ScianaB3', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('ScianaL2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('ScianaL2Pom', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('ScianaL2PomB', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('ScianaL3', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('ScianaP2', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('ScianaP2Pom', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('ScianaP2PomB', 'Width', getHTMLElemAttribute('value', 'slider', false));
  setMorphFactor('ScianaP3', 'Width', getHTMLElemAttribute('value', 'slider', false));
});
eventHTMLElem('input', 'slider2', false, function(event) {
  setMorphFactor('Ceowniki 3x6', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Maskownica 3x6', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Profil Podluzny 3x6', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Profil Poprzeczny 3x6', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Narozniki 3x6', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Dach 3x6', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Profil 3x6 1 700', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Profil 3x6 2 700', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Profil 3x6 2 900', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Profil 3x6  3', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Profil 3x6 4 700', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Profil 3x6 4 900', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Profil 3x6 5 700', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Profil 3x6 dodatek', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Falista 3x6 6.1.a', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Falista 3x6 6.1.a2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Falista 3x6 6.1.b2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Falista 3x6 6.1.b', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Falista 3x6 6.1.c', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Falista 3x6 6.1.c2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Falista 3x6 6.1.d', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Falista 3x6 6.1.e2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Falista 3x6 6.1.e', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Falista 3x6 6.1.f', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Falista 3x6 6.1.f2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Falista 3x6 6.1.g', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Falista 3x6 6.1.g2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Falista 3x6 6.1.y', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Falista 3x6 6.1.z', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Horyzontal 3x6 6.1.a', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Horyzontal 3x6 6.1.a2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Horyzontal 3x6 6.1.b', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Horyzontal 3x6 6.1.b2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Horyzontal 3x6 6.1.c', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Horyzontal 3x6 6.1.c2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Horyzontal 3x6 6.1.d', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Horyzontal 3x6 6.1.e', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Horyzontal 3x6 6.1.e2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Horyzontal 3x6 6.1.f', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Horyzontal 3x6 6.1.f2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Horyzontal 3x6 6.1.g', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Horyzontal 3x6 6.1.g2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Horyzontal 3x6 6.1.y', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Horyzontal 3x6 6.1.z', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Modern Plus 3x6 6.1.a', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Modern Plus 3x6 6.1.a2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Modern Plus 3x6 6.1.b', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Modern Plus 3x6 6.1.b2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Modern Plus 3x6 6.1.c', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Modern Plus 3x6 6.1.c2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Modern Plus 3x6 6.1.d', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Modern Plus 3x6 6.1.e', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Modern Plus 3x6 6.1.e2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Modern Plus 3x6 6.1.f', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Modern Plus 3x6 6.1.f2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Modern Plus 3x6 6.1.g', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Modern Plus 3x6 6.1.g2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Modern Plus 3x6 6.1.y', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Modern Plus 3x6 6.1.z', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Zaluzja 3x6 6.1.a', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Zaluzja 3x6 6.1.a2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Zaluzja 3x6 6.1.b', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Zaluzja 3x6 6.1.b2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Zaluzja 3x6 6.1.c', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Zaluzja 3x6 6.1.c2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Zaluzja 3x6 6.1.d', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Zaluzja 3x6 6.1.e', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Zaluzja 3x6 6.1.e2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Zaluzja 3x6 6.1.f', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Zaluzja 3x6 6.1.f2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Zaluzja 3x6 6.1.g', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Zaluzja 3x6 6.1.g2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Zaluzja 3x6 6.1.y', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Zaluzja 3x6 6.1.z', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('ScianaB', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('ScianaL', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('ScianaP', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Ceowniki 6x6', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Maskownica 6x6', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Profil Podluzny 6x6', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Profil Poprzeczny 6x6', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Narozniki 6x6', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Dach 6x6', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Profil 6x6 1 700', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Profil 6x6 2 700', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Profil 6x6 2 900', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Profil 6x6  3', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Profil 6x6 4 700', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Profil 6x6 4 900', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Profil 6x6 5 700', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Profil 6x6 tył', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Falista 6x6 6.1.a', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Falista 6x6 6.1.a2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Falista 6x6 6.1.b', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Falista 6x6 6.1.b2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Falista 6x6 6.1.c', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Falista 6x6 6.1.c2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Falista 6x6 6.1.d', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Falista 6x6 6.1.h', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Falista 6x6 6.1.e2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Falista 6x6 6.1.e', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Falista 6x6 6.1.f', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Falista 6x6 6.1.f2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Falista 6x6 6.1.g', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Falista 6x6 6.1.g2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Falista 6x6 6.1.y', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Falista 6x6 6.1.z', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Horyzontal 6x6 6.1.a', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Horyzontal 6x6 6.1.a2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Horyzontal 6x6 6.1.b', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Horyzontal 6x6 6.1.b2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Horyzontal 6x6 6.1.c', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Horyzontal 6x6 6.1.c2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Horyzontal 6x6 6.1.d', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Horyzontal 6x6 6.1.h', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Horyzontal 6x6 6.1.e', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Horyzontal 6x6 6.1.e2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Horyzontal 6x6 6.1.f', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Horyzontal 6x6 6.1.f2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Horyzontal 6x6 6.1.g', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Horyzontal 6x6 6.1.g2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Horyzontal 6x6 6.1.y', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Horyzontal 6x6 6.1.z', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Modern Plus 6x6 6.1.a', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Modern Plus 6x6 6.1.a2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Modern Plus 6x6 6.1.b', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Modern Plus 6x6 6.1.b2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Modern Plus 6x6 6.1.c', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Modern Plus 6x6 6.1.c2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Modern Plus 6x6 6.1.d', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Modern Plus 6x6 6.1.h', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Modern Plus 6x6 6.1.e', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Modern Plus 6x6 6.1.e2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Modern Plus 6x6 6.1.f', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Modern Plus 6x6 6.1.f2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Modern Plus 6x6 6.1.g', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Modern Plus 6x6 6.1.g2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Modern Plus 6x6 6.1.y', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Modern Plus 6x6 6.1.z', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Zaluzja 6x6 6.1.a', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Zaluzja 6x6 6.1.a2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Zaluzja 6x6 6.1.b', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Zaluzja 6x6 6.1.b2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Zaluzja 6x6 6.1.c', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Zaluzja 6x6 6.1.c2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Zaluzja 6x6 6.1.d', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Zaluzja 6x6 6.1.h', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Zaluzja 6x6 6.1.e', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Zaluzja 6x6 6.1.e2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Zaluzja 6x6 6.1.f', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Zaluzja 6x6 6.1.f2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Zaluzja 6x6 6.1.g', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Zaluzja 6x6 6.1.g2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Zaluzja 6x6 6.1.y', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Zaluzja 6x6 6.1.z', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('ScianaB', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('ScianaL', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('ScianaP', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('PG prawe', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('PG prawe dach', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('PG prawe maskownica', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('PG prawe profil 3', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('PG prawe profil 700 1', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('PG prawe profil 700 2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('PG prawe profil 700 3', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('PG prawe profil 700 4', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('PG prawe profil 900 1', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('PG prawe profil 900 2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('PG tył', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('PG tył dach', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('PG tył maskownica', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('PG tył profil 1', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('PG tył profil 2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('PG tył profil 3', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('PG tył profil 4', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('PG tył profil 5', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('PG tył profil 6', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('PG lewe', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('PG lewe dach', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('PG lewe maskownica', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('PG lewe profil 3', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('PG lewe profil 700 1', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('PG lewe profil 700 2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('PG lewe profil 700 3', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('PG lewe profil 700 4', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('PG lewe profil 900 1', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('PG lewe profil 900 2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Drzwi lewe', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Panel 1 lewy ', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Panel 2 lewy ', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Panel 3 lewy ', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Panel 4 lewy ', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Panel 5 lewy ', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Panel 6 lewy ', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Panel 7 lewy ', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Profil garaż lewy  1 700', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Profil garaż lewy  2 700', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Profil garaż lewy  2 900', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Profil garaż lewy  3', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Profil garaż lewy  4 700', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Profil garaż lewy  4 900', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Profil garaż lewy  5 700', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Drzwi prawe', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Panel 1 prawy', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Panel 2 prawy', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Panel 3 prawy', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Panel 4 prawy', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Panel 5 prawy', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Panel 6 prawy', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Panel 7 prawy', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Profil garaż prawy 1 700', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Profil garaż prawy 2 700', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Profil garaż prawy 2 900', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Profil garaż prawy 3', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Profil garaż prawy 4 700', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Profil garaż prawy 4 900', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Profil garaż prawy 5 700', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Dach Wielostan', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Profil Wielostan 1 700', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Profil Wielostan 2 700', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Profil Wielostan 2 900', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Profil Wielostan 3', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Profil Wielostan 4 700', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Profil Wielostan 4 900', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Profil Wielostan 5 700', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Profil Wielostan dodatek', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Narozniki Wielostan', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Maskownica Wielostan', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Falista Wielostan 6.1.d', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Falista Wielostan 6.1.e', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Falista Wielostan 6.1.e2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Falista Wielostan 6.1.f', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Falista Wielostan 6.1.f2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Falista Wielostan 6.1.g', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Falista Wielostan 6.1.g2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Falista Wielostan 6.1.z', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Horyzontal Wielostan 6.1.d', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Horyzontal Wielostan 6.1.e', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Horyzontal Wielostan 6.1.e2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Horyzontal Wielostan 6.1.f', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Horyzontal Wielostan 6.1.f2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Horyzontal Wielostan 6.1.g', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Horyzontal Wielostan 6.1.g2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Horyzontal Wielostan 6.1.z', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Modern Plus Wielostan 6.1.d', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Modern Plus Wielostan 6.1.e', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Modern Plus Wielostan 6.1.e2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Modern Plus Wielostan 6.1.f', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Modern Plus Wielostan 6.1.f2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Modern Plus Wielostan 6.1.g', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Modern Plus Wielostan 6.1.g2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Modern Plus Wielostan 6.1.z', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Zaluzja Wielostan 6.1.d', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Zaluzja Wielostan 6.1.e', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Zaluzja Wielostan 6.1.e2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Zaluzja Wielostan 6.1.f', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Zaluzja Wielostan 6.1.f2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Zaluzja Wielostan 6.1.g', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Zaluzja Wielostan 6.1.g2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Zaluzja Wielostan 6.1.z', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Profil Poprzeczny Wielostan', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('Profil Podluzny Wielostan', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('ScianaB2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('ScianaB2Pom', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('ScianaB2PomL', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('ScianaB2PomP', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('ScianaB3', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('ScianaL2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('ScianaL2Pom', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('ScianaL2PomB', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('ScianaL3', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('ScianaP2', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('ScianaP2Pom', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('ScianaP2PomB', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
  setMorphFactor('ScianaP3', 'Lenght', getHTMLElemAttribute('value', 'slider2', false));
});
eventHTMLElem('input', 'slider3', false, function(event) {
  setMorphFactor('Ceowniki 3x6', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Maskownica 3x6', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Profil Podluzny 3x6', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Profil Poprzeczny 3x6', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Narozniki 3x6', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Dach 3x6', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Profil 3x6 1 700', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Profil 3x6 2 700', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Profil 3x6 2 900', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Profil 3x6  3', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Profil 3x6 4 700', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Profil 3x6 4 900', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Profil 3x6 5 700', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Profil 3x6 dodatek', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Falista 3x6 6.1.a', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Falista 3x6 6.1.a2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Falista 3x6 6.1.b2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Falista 3x6 6.1.b', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Falista 3x6 6.1.c', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Falista 3x6 6.1.c2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Falista 3x6 6.1.d', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Falista 3x6 6.1.e2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Falista 3x6 6.1.e', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Falista 3x6 6.1.f', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Falista 3x6 6.1.f2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Falista 3x6 6.1.g', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Falista 3x6 6.1.g2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Falista 3x6 6.1.y', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Falista 3x6 6.1.z', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Horyzontal 3x6 6.1.a', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Horyzontal 3x6 6.1.a2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Horyzontal 3x6 6.1.b', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Horyzontal 3x6 6.1.b2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Horyzontal 3x6 6.1.c', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Horyzontal 3x6 6.1.c2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Horyzontal 3x6 6.1.d', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Horyzontal 3x6 6.1.e', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Horyzontal 3x6 6.1.e2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Horyzontal 3x6 6.1.f', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Horyzontal 3x6 6.1.f2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Horyzontal 3x6 6.1.g', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Horyzontal 3x6 6.1.g2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Horyzontal 3x6 6.1.y', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Horyzontal 3x6 6.1.z', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Modern Plus 3x6 6.1.a', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Modern Plus 3x6 6.1.a2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Modern Plus 3x6 6.1.b', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Modern Plus 3x6 6.1.b2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Modern Plus 3x6 6.1.c', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Modern Plus 3x6 6.1.c2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Modern Plus 3x6 6.1.d', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Modern Plus 3x6 6.1.e', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Modern Plus 3x6 6.1.e2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Modern Plus 3x6 6.1.f', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Modern Plus 3x6 6.1.f2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Modern Plus 3x6 6.1.g', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Modern Plus 3x6 6.1.g2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Modern Plus 3x6 6.1.y', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Modern Plus 3x6 6.1.z', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Zaluzja 3x6 6.1.a', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Zaluzja 3x6 6.1.a2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Zaluzja 3x6 6.1.b', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Zaluzja 3x6 6.1.b2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Zaluzja 3x6 6.1.c', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Zaluzja 3x6 6.1.c2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Zaluzja 3x6 6.1.d', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Zaluzja 3x6 6.1.e', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Zaluzja 3x6 6.1.e2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Zaluzja 3x6 6.1.f', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Zaluzja 3x6 6.1.f2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Zaluzja 3x6 6.1.g', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Zaluzja 3x6 6.1.g2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Zaluzja 3x6 6.1.y', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Zaluzja 3x6 6.1.z', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('ScianaB', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('ScianaL', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('ScianaP', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Ceowniki 6x6', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Maskownica 6x6', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Profil Podluzny 6x6', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Profil Poprzeczny 6x6', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Narozniki 6x6', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Dach 6x6', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Profil 6x6 1 700', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Profil 6x6 2 700', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Profil 6x6 2 900', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Profil 6x6  3', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Profil 6x6 4 700', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Profil 6x6 4 900', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Profil 6x6 5 700', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Profil 6x6 tył', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Falista 6x6 6.1.a', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Falista 6x6 6.1.a2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Falista 6x6 6.1.b', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Falista 6x6 6.1.b2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Falista 6x6 6.1.c', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Falista 6x6 6.1.c2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Falista 6x6 6.1.d', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Falista 6x6 6.1.h', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Falista 6x6 6.1.e2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Falista 6x6 6.1.e', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Falista 6x6 6.1.f', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Falista 6x6 6.1.f2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Falista 6x6 6.1.g', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Falista 6x6 6.1.g2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Falista 6x6 6.1.y', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Falista 6x6 6.1.z', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Horyzontal 6x6 6.1.a', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Horyzontal 6x6 6.1.a2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Horyzontal 6x6 6.1.b', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Horyzontal 6x6 6.1.b2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Horyzontal 6x6 6.1.c', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Horyzontal 6x6 6.1.c2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Horyzontal 6x6 6.1.d', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Horyzontal 6x6 6.1.h', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Horyzontal 6x6 6.1.e', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Horyzontal 6x6 6.1.e2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Horyzontal 6x6 6.1.f', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Horyzontal 6x6 6.1.f2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Horyzontal 6x6 6.1.g', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Horyzontal 6x6 6.1.g2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Horyzontal 6x6 6.1.y', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Horyzontal 6x6 6.1.z', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Modern Plus 6x6 6.1.a', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Modern Plus 6x6 6.1.a2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Modern Plus 6x6 6.1.b', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Modern Plus 6x6 6.1.b2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Modern Plus 6x6 6.1.c', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Modern Plus 6x6 6.1.c2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Modern Plus 6x6 6.1.d', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Modern Plus 6x6 6.1.h', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Modern Plus 6x6 6.1.e', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Modern Plus 6x6 6.1.e2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Modern Plus 6x6 6.1.f', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Modern Plus 6x6 6.1.f2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Modern Plus 6x6 6.1.g', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Modern Plus 6x6 6.1.g2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Modern Plus 6x6 6.1.y', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Modern Plus 6x6 6.1.z', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Zaluzja 6x6 6.1.a', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Zaluzja 6x6 6.1.a2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Zaluzja 6x6 6.1.b', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Zaluzja 6x6 6.1.b2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Zaluzja 6x6 6.1.c', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Zaluzja 6x6 6.1.c2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Zaluzja 6x6 6.1.d', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Zaluzja 6x6 6.1.h', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Zaluzja 6x6 6.1.e', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Zaluzja 6x6 6.1.e2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Zaluzja 6x6 6.1.f', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Zaluzja 6x6 6.1.f2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Zaluzja 6x6 6.1.g', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Zaluzja 6x6 6.1.g2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Zaluzja 6x6 6.1.y', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Zaluzja 6x6 6.1.z', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('ScianaB', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('ScianaL', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('ScianaP', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('PG prawe', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('PG prawe dach', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('PG prawe maskownica', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('PG prawe profil 3', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('PG prawe profil 700 1', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('PG prawe profil 700 2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('PG prawe profil 700 3', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('PG prawe profil 700 4', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('PG prawe profil 900 1', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('PG prawe profil 900 2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('PG tył', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('PG tył dach', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('PG tył maskownica', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('PG tył profil 1', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('PG tył profil 2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('PG tył profil 3', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('PG tył profil 4', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('PG tył profil 5', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('PG tył profil 6', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('PG lewe', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('PG lewe dach', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('PG lewe maskownica', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('PG lewe profil 3', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('PG lewe profil 700 1', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('PG lewe profil 700 2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('PG lewe profil 700 3', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('PG lewe profil 700 4', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('PG lewe profil 900 1', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('PG lewe profil 900 2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Drzwi lewe', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Panel 1 lewy ', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Panel 2 lewy ', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Panel 3 lewy ', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Panel 4 lewy ', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Panel 5 lewy ', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Panel 6 lewy ', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Panel 7 lewy ', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Profil garaż lewy  1 700', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Profil garaż lewy  2 700', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Profil garaż lewy  2 900', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Profil garaż lewy  3', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Profil garaż lewy  4 700', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Profil garaż lewy  4 900', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Profil garaż lewy  5 700', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Drzwi prawe', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Panel 1 prawy', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Panel 2 prawy', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Panel 3 prawy', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Panel 4 prawy', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Panel 5 prawy', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Panel 6 prawy', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Panel 7 prawy', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Profil garaż prawy 1 700', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Profil garaż prawy 2 700', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Profil garaż prawy 2 900', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Profil garaż prawy 3', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Profil garaż prawy 4 700', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Profil garaż prawy 4 900', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Profil garaż prawy 5 700', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Dach Wielostan', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Profil Wielostan 1 700', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Profil Wielostan 2 700', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Profil Wielostan 2 900', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Profil Wielostan 3', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Profil Wielostan 4 700', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Profil Wielostan 4 900', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Profil Wielostan 5 700', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Profil Wielostan dodatek', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Narozniki Wielostan', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Maskownica Wielostan', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Profil Podluzny Wielostan', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Profil Poprzeczny Wielostan', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Falista Wielostan 6.1.d', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Falista Wielostan 6.1.e', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Falista Wielostan 6.1.e2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Falista Wielostan 6.1.f', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Falista Wielostan 6.1.f2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Falista Wielostan 6.1.g', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Falista Wielostan 6.1.g2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Falista Wielostan 6.1.z', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Horyzontal Wielostan 6.1.d', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Horyzontal Wielostan 6.1.e', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Horyzontal Wielostan 6.1.e2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Horyzontal Wielostan 6.1.f', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Horyzontal Wielostan 6.1.f2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Horyzontal Wielostan 6.1.g', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Horyzontal Wielostan 6.1.g2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Horyzontal Wielostan 6.1.z', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Modern Plus Wielostan 6.1.d', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Modern Plus Wielostan 6.1.e', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Modern Plus Wielostan 6.1.e2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Modern Plus Wielostan 6.1.f', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Modern Plus Wielostan 6.1.f2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Modern Plus Wielostan 6.1.g', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Modern Plus Wielostan 6.1.g2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Modern Plus Wielostan 6.1.z', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Zaluzja Wielostan 6.1.d', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Zaluzja Wielostan 6.1.e', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Zaluzja Wielostan 6.1.e2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Zaluzja Wielostan 6.1.f', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Zaluzja Wielostan 6.1.f2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Zaluzja Wielostan 6.1.g', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Zaluzja Wielostan 6.1.g2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('Zaluzja Wielostan 6.1.z', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('ScianaB2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('ScianaB2Pom', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('ScianaB2PomL', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('ScianaB2PomP', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('ScianaB3', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('ScianaL2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('ScianaL2Pom', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('ScianaL2PomB', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('ScianaL3', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('ScianaP2', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('ScianaP2Pom', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('ScianaP2PomB', 'Height', getHTMLElemAttribute('value', 'slider3', false));
  setMorphFactor('ScianaP3', 'Height', getHTMLElemAttribute('value', 'slider3', false));
});
eventHTMLElem('input', 'slider4', true, function(event) {
  setMorphFactor('PG tył dach', 'Lenght2', getHTMLElemAttribute('value', 'slider4', false));
  setMorphFactor('PG tył maskownica', 'Lenght2', getHTMLElemAttribute('value', 'slider4', false));
  setMorphFactor('Maskownica 3x6', 'Lenght2', getHTMLElemAttribute('value', 'slider4', false));
  setMorphFactor('Dach 3x6', 'Lenght2', getHTMLElemAttribute('value', 'slider4', false));
  setMorphFactor('Narozniki 3x6', 'Lenght2', getHTMLElemAttribute('value', 'slider4', false));
  setMorphFactor('Maskownica 6x6', 'Lenght2', getHTMLElemAttribute('value', 'slider4', false));
  setMorphFactor('Dach 6x6', 'Lenght2', getHTMLElemAttribute('value', 'slider4', false));
  setMorphFactor('Narozniki 6x6', 'Lenght2', getHTMLElemAttribute('value', 'slider4', false));
  setMorphFactor('Narozniki Wielostan', 'Lenght2', getHTMLElemAttribute('value', 'slider4', false));
  setMorphFactor('Dach Wielostan', 'Lenght2', getHTMLElemAttribute('value', 'slider4', false));
  setMorphFactor('Maskownica Wielostan', 'Lenght2', getHTMLElemAttribute('value', 'slider4', false));
});

eventHTMLElem('input', 'slider2', true, function(event) {
  if (Wiata1 == 1) {
    if (getHTMLElemAttribute('value', 'slider2', true) < '0.599') {
      changeVis('Profil 3x6 2 700', true);
      changeVis('Profil 3x6 2 900', false);
      changeVis('Profil 6x6 2 900', false);
      changeVis('Profil 6x6 2 700', false);
    }
    if (getHTMLElemAttribute('value', 'slider2', true) > '0.599') {
      changeVis('Profil 3x6 2 900', true);
      changeVis('Profil 3x6 2 700', false);
      changeVis('Profil 6x6 2 700', false);
      changeVis('Profil 6x6 2 900', false);
    }
    if (getHTMLElemAttribute('value', 'slider2', true) < '0.599') {
      changeVis('Profil 3x6 4 700', true);
      changeVis('Profil 3x6 4 900', false);
      changeVis('Profil 6x6 4 900', false);
      changeVis('Profil 6x6 4 700', false);
    }
    if (getHTMLElemAttribute('value', 'slider2', true) > '0.599') {
      changeVis('Profil 3x6 4 900', true);
      changeVis('Profil 3x6 4 700', false);
      changeVis('Profil 6x6 4 700', false);
      changeVis('Profil 6x6 4 900', false);
    }
    if (getHTMLElemAttribute('value', 'slider2', true) > '0.599') {
      changeVis('Profil 3x6  3', true);
      changeVis('Profil 6x6  3', false);
    }
    if (getHTMLElemAttribute('value', 'slider2', true) < '0.599') {
      changeVis('Profil 3x6  3', false);
      changeVis('Profil 6x6  3', false);
    }
    if (my_5_a == 1 || isObjectVisible(['GROUP', 'Falista 3x6'])) {
      if (getHTMLElemAttribute('value', 'slider2', true) < '0.599') {
        _3C = 1;
        _3E = 0;
        changeVis('Profil 3x6 dodatek', true);
        changeVis('Falista 3x6 6.1.a', true);
        changeVis('Falista 3x6 6.1.a2', false);
        changeVis('Falista 3x6 6.1.b', true);
        changeVis('Falista 3x6 6.1.b2', false);
        changeVis('Falista 3x6 6.1.y', false);
        changeVis('Falista 3x6 6.1.c', true);
        changeVis('Falista 3x6 6.1.c2', false);
        changeVis('Falista 3x6 6.1.d', true);
        changeVis('Falista 3x6 6.1.e', true);
        changeVis('Falista 3x6 6.1.e2', false);
        changeVis('Falista 3x6 6.1.f', true);
        changeVis('Falista 3x6 6.1.f2', false);
        changeVis('Falista 3x6 6.1.z', false);
        changeVis('Falista 3x6 6.1.g', true);
        changeVis('Falista 3x6 6.1.g2', false);
        changeVis(['GROUP', 'Horyzontal 3x6'], false);
        changeVis(['GROUP', 'Modern Plus 3x6'], false);
        changeVis(['GROUP', 'Zaluzja 3x6'], false);
        changeVis(['GROUP', 'Falista 6x6'], false);
        changeVis(['GROUP', 'Horyzontal 6x6'], false);
        changeVis(['GROUP', 'Modern Plus 6x6'], false);
        changeVis(['GROUP', 'Zaluzja 6x6'], false);
      }
      if (getHTMLElemAttribute('value', 'slider2', true) > '0.599') {
        _3C = 0;
        _3E = 1;
        changeVis('Profil 3x6 dodatek', true);
        changeVis('Falista 3x6 6.1.a2', true);
        changeVis('Falista 3x6 6.1.a', false);
        changeVis('Falista 3x6 6.1.b2', true);
        changeVis('Falista 3x6 6.1.b', false);
        changeVis('Falista 3x6 6.1.y', true);
        changeVis('Falista 3x6 6.1.c2', true);
        changeVis('Falista 3x6 6.1.c', false);
        changeVis('Falista 3x6 6.1.d', true);
        changeVis('Falista 3x6 6.1.e2', true);
        changeVis('Falista 3x6 6.1.e', false);
        changeVis('Falista 3x6 6.1.f2', true);
        changeVis('Falista 3x6 6.1.f', false);
        changeVis('Falista 3x6 6.1.z', true);
        changeVis('Falista 3x6 6.1.g2', true);
        changeVis('Falista 3x6 6.1.g', false);
        changeVis(['GROUP', 'Horyzontal 3x6'], false);
        changeVis(['GROUP', 'Modern Plus 3x6'], false);
        changeVis(['GROUP', 'Zaluzja 3x6'], false);
        changeVis(['GROUP', 'Falista 6x6'], false);
        changeVis(['GROUP', 'Horyzontal 6x6'], false);
        changeVis(['GROUP', 'Modern Plus 6x6'], false);
        changeVis(['GROUP', 'Zaluzja 6x6'], false);
      }
    }
    if (my_5_b == 1) {
      if (getHTMLElemAttribute('value', 'slider2', true) < '0.599') {
        _3C = 1;
        _3E = 0;
        changeVis('Profil 3x6 dodatek', true);
        changeVis('Horyzontal 3x6 6.1.a', true);
        changeVis('Horyzontal 3x6 6.1.a2', false);
        changeVis('Horyzontal 3x6 6.1.b', true);
        changeVis('Horyzontal 3x6 6.1.b2', false);
        changeVis('Horyzontal 3x6 6.1.y', false);
        changeVis('Horyzontal 3x6 6.1.c', true);
        changeVis('Horyzontal 3x6 6.1.c2', false);
        changeVis('Horyzontal 3x6 6.1.d', true);
        changeVis('Horyzontal 3x6 6.1.e', true);
        changeVis('Horyzontal 3x6 6.1.e2', false);
        changeVis('Horyzontal 3x6 6.1.f', true);
        changeVis('Horyzontal 3x6 6.1.f2', false);
        changeVis('Horyzontal 3x6 6.1.z', false);
        changeVis('Horyzontal 3x6 6.1.g', true);
        changeVis('Horyzontal 3x6 6.1.g2', false);
        changeVis(['GROUP', 'Falista 3x6'], false);
        changeVis(['GROUP', 'Modern Plus 3x6'], false);
        changeVis(['GROUP', 'Zaluzja 3x6'], false);
        changeVis(['GROUP', 'Falista 6x6'], false);
        changeVis(['GROUP', 'Horyzontal 6x6'], false);
        changeVis(['GROUP', 'Modern Plus 6x6'], false);
        changeVis(['GROUP', 'Zaluzja 6x6'], false);
      }
      if (getHTMLElemAttribute('value', 'slider2', true) > '0.599') {
        _3C = 0;
        _3E = 1;
        changeVis('Profil 3x6 dodatek', true);
        changeVis('Horyzontal 3x6 6.1.a2', true);
        changeVis('Horyzontal 3x6 6.1.a', false);
        changeVis('Horyzontal 3x6 6.1.b2', true);
        changeVis('Horyzontal 3x6 6.1.b', false);
        changeVis('Horyzontal 3x6 6.1.y', true);
        changeVis('Horyzontal 3x6 6.1.c2', true);
        changeVis('Horyzontal 3x6 6.1.c', false);
        changeVis('Horyzontal 3x6 6.1.d', true);
        changeVis('Horyzontal 3x6 6.1.e2', true);
        changeVis('Horyzontal 3x6 6.1.e', false);
        changeVis('Horyzontal 3x6 6.1.f2', true);
        changeVis('Horyzontal 3x6 6.1.f', false);
        changeVis('Horyzontal 3x6 6.1.z', true);
        changeVis('Horyzontal 3x6 6.1.g2', true);
        changeVis('Horyzontal 3x6 6.1.g', false);
        changeVis(['GROUP', 'Falista 3x6'], false);
        changeVis(['GROUP', 'Modern Plus 3x6'], false);
        changeVis(['GROUP', 'Zaluzja 3x6'], false);
        changeVis(['GROUP', 'Falista 6x6'], false);
        changeVis(['GROUP', 'Horyzontal 6x6'], false);
        changeVis(['GROUP', 'Modern Plus 6x6'], false);
        changeVis(['GROUP', 'Zaluzja 6x6'], false);
      }
    }
    if (my_5_c == 1) {
      if (getHTMLElemAttribute('value', 'slider2', true) < '0.599') {
        _3C = 1;
        _3E = 0;
        changeVis('Profil 3x6 dodatek', true);
        changeVis('Modern Plus 3x6 6.1.a', true);
        changeVis('Modern Plus 3x6 6.1.a2', false);
        changeVis('Modern Plus 3x6 6.1.b', true);
        changeVis('Modern Plus 3x6 6.1.b2', false);
        changeVis('Modern Plus 3x6 6.1.y', false);
        changeVis('Modern Plus 3x6 6.1.c', true);
        changeVis('Modern Plus 3x6 6.1.c2', false);
        changeVis('Modern Plus 3x6 6.1.d', true);
        changeVis('Modern Plus 3x6 6.1.e', true);
        changeVis('Modern Plus 3x6 6.1.e2', false);
        changeVis('Modern Plus 3x6 6.1.f', true);
        changeVis('Modern Plus 3x6 6.1.f2', false);
        changeVis('Modern Plus 3x6 6.1.z', false);
        changeVis('Modern Plus 3x6 6.1.g', true);
        changeVis('Modern Plus 3x6 6.1.g2', false);
        changeVis(['GROUP', 'Falista 3x6'], false);
        changeVis(['GROUP', 'Horyzontal 3x6'], false);
        changeVis(['GROUP', 'Zaluzja 3x6'], false);
        changeVis(['GROUP', 'Falista 6x6'], false);
        changeVis(['GROUP', 'Horyzontal 6x6'], false);
        changeVis(['GROUP', 'Modern Plus 6x6'], false);
        changeVis(['GROUP', 'Zaluzja 6x6'], false);
      }
      if (getHTMLElemAttribute('value', 'slider2', true) > '0.599') {
        _3C = 0;
        _3E = 1;
        changeVis('Profil 3x6 dodatek', true);
        changeVis('Modern Plus 3x6 6.1.a2', true);
        changeVis('Modern Plus 3x6 6.1.a', false);
        changeVis('Modern Plus 3x6 6.1.b2', true);
        changeVis('Modern Plus 3x6 6.1.b', false);
        changeVis('Modern Plus 3x6 6.1.y', true);
        changeVis('Modern Plus 3x6 6.1.c2', true);
        changeVis('Modern Plus 3x6 6.1.c', false);
        changeVis('Modern Plus 3x6 6.1.d', true);
        changeVis('Modern Plus 3x6 6.1.e2', true);
        changeVis('Modern Plus 3x6 6.1.e', false);
        changeVis('Modern Plus 3x6 6.1.f2', true);
        changeVis('Modern Plus 3x6 6.1.f', false);
        changeVis('Modern Plus 3x6 6.1.z', true);
        changeVis('Modern Plus 3x6 6.1.g2', true);
        changeVis('Modern Plus 3x6 6.1.g', false);
        changeVis(['GROUP', 'Falista 3x6'], false);
        changeVis(['GROUP', 'Horyzontal 3x6'], false);
        changeVis(['GROUP', 'Zaluzja 3x6'], false);
        changeVis(['GROUP', 'Falista 6x6'], false);
        changeVis(['GROUP', 'Horyzontal 6x6'], false);
        changeVis(['GROUP', 'Modern Plus 6x6'], false);
        changeVis(['GROUP', 'Zaluzja 6x6'], false);
      }
    }
    if (my_5_d == 1) {
      if (getHTMLElemAttribute('value', 'slider2', true) < '0.599') {
        _3C = 1;
        _3E = 0;
        changeVis('Profil 3x6 dodatek', true);
        changeVis('Zaluzja 3x6 6.1.a', true);
        changeVis('Zaluzja 3x6 6.1.a2', false);
        changeVis('Zaluzja 3x6 6.1.b', true);
        changeVis('Zaluzja 3x6 6.1.b2', false);
        changeVis('Zaluzja 3x6 6.1.y', false);
        changeVis('Zaluzja 3x6 6.1.c', true);
        changeVis('Zaluzja 3x6 6.1.c2', false);
        changeVis('Zaluzja 3x6 6.1.d', true);
        changeVis('Zaluzja 3x6 6.1.e', true);
        changeVis('Zaluzja 3x6 6.1.e2', false);
        changeVis('Zaluzja 3x6 6.1.f', true);
        changeVis('Zaluzja 3x6 6.1.f2', false);
        changeVis('Zaluzja 3x6 6.1.z', false);
        changeVis('Zaluzja 3x6 6.1.g', true);
        changeVis('Zaluzja 3x6 6.1.g2', false);
        changeVis(['GROUP', 'Falista 3x6'], false);
        changeVis(['GROUP', 'Horyzontal 3x6'], false);
        changeVis(['GROUP', 'Modern Plus 3x6'], false);
        changeVis(['GROUP', 'Falista 6x6'], false);
        changeVis(['GROUP', 'Horyzontal 6x6'], false);
        changeVis(['GROUP', 'Modern Plus 6x6'], false);
        changeVis(['GROUP', 'Zaluzja 6x6'], false);
      }
      if (getHTMLElemAttribute('value', 'slider2', true) > '0.599') {
        _3C = 0;
        _3E = 1;
        changeVis('Profil 3x6 dodatek', true);
        changeVis('Zaluzja 3x6 6.1.a2', true);
        changeVis('Zaluzja 3x6 6.1.a', false);
        changeVis('Zaluzja 3x6 6.1.b2', true);
        changeVis('Zaluzja 3x6 6.1.b', false);
        changeVis('Zaluzja 3x6 6.1.y', true);
        changeVis('Zaluzja 3x6 6.1.c2', true);
        changeVis('Zaluzja 3x6 6.1.c', false);
        changeVis('Zaluzja 3x6 6.1.d', true);
        changeVis('Zaluzja 3x6 6.1.e2', true);
        changeVis('Zaluzja 3x6 6.1.e', false);
        changeVis('Zaluzja 3x6 6.1.f2', true);
        changeVis('Zaluzja 3x6 6.1.f', false);
        changeVis('Zaluzja 3x6 6.1.z', true);
        changeVis('Zaluzja 3x6 6.1.g2', true);
        changeVis('Zaluzja 3x6 6.1.g', false);
        changeVis(['GROUP', 'Falista 3x6'], false);
        changeVis(['GROUP', 'Horyzontal 3x6'], false);
        changeVis(['GROUP', 'Modern Plus 3x6'], false);
        changeVis(['GROUP', 'Falista 6x6'], false);
        changeVis(['GROUP', 'Horyzontal 6x6'], false);
        changeVis(['GROUP', 'Modern Plus 6x6'], false);
        changeVis(['GROUP', 'Zaluzja 6x6'], false);
      }
    }
  }
});

eventHTMLElem('input', 'slider2', true, function(event) {
  if (Wiata2 == 1) {
    if (getHTMLElemAttribute('value', 'slider2', true) < '0.599') {
      changeVis('Profil 6x6 2 700', true);
      changeVis('Profil 6x6 2 900', false);
      changeVis('Profil 3x6 2 900', false);
      changeVis('Profil 3x6 2 700', false);
    }
    if (getHTMLElemAttribute('value', 'slider2', true) > '0.599') {
      changeVis('Profil 6x6 2 900', true);
      changeVis('Profil 6x6 2 700', false);
      changeVis('Profil 3x6 2 700', false);
      changeVis('Profil 3x6 2 900', false);
    }
    if (getHTMLElemAttribute('value', 'slider2', true) < '0.599') {
      changeVis('Profil 6x6 4 700', true);
      changeVis('Profil 6x6 4 900', false);
      changeVis('Profil 3x6 4 900', false);
      changeVis('Profil 3x6 4 700', false);
    }
    if (getHTMLElemAttribute('value', 'slider2', true) > '0.599') {
      changeVis('Profil 6x6 4 900', true);
      changeVis('Profil 6x6 4 700', false);
      changeVis('Profil 3x6 4 700', false);
      changeVis('Profil 3x6 4 900', false);
    }
    if (getHTMLElemAttribute('value', 'slider2', true) > '0.599') {
      changeVis('Profil 6x6  3', true);
      changeVis('Profil 3x6  3', false);
    }
    if (getHTMLElemAttribute('value', 'slider2', true) < '0.599') {
      changeVis('Profil 6x6  3', false);
      changeVis('Profil 3x6  3', false);
    }
    if (my_5_a == 1 || isObjectVisible(['GROUP', 'Falista 6x6'])) {
      if (getHTMLElemAttribute('value', 'slider2', true) < '0.599') {
        _3C = 1;
        _3E = 0;
        changeVis('Falista 6x6 6.1.a', true);
        changeVis('Falista 6x6 6.1.a2', false);
        changeVis('Falista 6x6 6.1.b', true);
        changeVis('Falista 6x6 6.1.b2', false);
        changeVis('Falista 6x6 6.1.y', false);
        changeVis('Falista 6x6 6.1.c', true);
        changeVis('Falista 6x6 6.1.c2', false);
        changeVis('Falista 6x6 6.1.d', true);
        changeVis('Falista 6x6 6.1.h', true);
        changeVis('Falista 6x6 6.1.e', true);
        changeVis('Falista 6x6 6.1.e2', false);
        changeVis('Falista 6x6 6.1.f', true);
        changeVis('Falista 6x6 6.1.f2', false);
        changeVis('Falista 6x6 6.1.z', false);
        changeVis('Falista 6x6 6.1.g', true);
        changeVis('Falista 6x6 6.1.g2', false);
        changeVis(['GROUP', 'Horyzontal 6x6'], false);
        changeVis(['GROUP', 'Modern Plus 6x6'], false);
        changeVis(['GROUP', 'Zaluzja 6x6'], false);
        changeVis(['GROUP', 'Falista 3x6'], false);
        changeVis(['GROUP', 'Horyzontal 3x6'], false);
        changeVis(['GROUP', 'Modern Plus 3x6'], false);
        changeVis(['GROUP', 'Zaluzja 3x6'], false);
      }
      if (getHTMLElemAttribute('value', 'slider2', true) > '0.599') {
        _3C = 0;
        _3E = 1;
        changeVis('Falista 6x6 6.1.a2', true);
        changeVis('Falista 6x6 6.1.a', false);
        changeVis('Falista 6x6 6.1.b2', true);
        changeVis('Falista 6x6 6.1.b', false);
        changeVis('Falista 6x6 6.1.y', true);
        changeVis('Falista 6x6 6.1.c2', true);
        changeVis('Falista 6x6 6.1.c', false);
        changeVis('Falista 6x6 6.1.d', true);
        changeVis('Falista 6x6 6.1.h', true);
        changeVis('Falista 6x6 6.1.e2', true);
        changeVis('Falista 6x6 6.1.e', false);
        changeVis('Falista 6x6 6.1.f2', true);
        changeVis('Falista 6x6 6.1.f', false);
        changeVis('Falista 6x6 6.1.z', true);
        changeVis('Falista 6x6 6.1.g2', true);
        changeVis('Falista 6x6 6.1.g', false);
        changeVis(['GROUP', 'Horyzontal 6x6'], false);
        changeVis(['GROUP', 'Modern Plus 6x6'], false);
        changeVis(['GROUP', 'Zaluzja 6x6'], false);
        changeVis(['GROUP', 'Falista 3x6'], false);
        changeVis(['GROUP', 'Horyzontal 3x6'], false);
        changeVis(['GROUP', 'Modern Plus 3x6'], false);
        changeVis(['GROUP', 'Zaluzja 3x6'], false);
      }
    }
    if (my_5_b == 1 || isObjectVisible(['GROUP', 'Horyzontal 6x6'])) {
      if (getHTMLElemAttribute('value', 'slider2', true) < '0.599') {
        _3C = 1;
        _3E = 0;
        changeVis('Horyzontal 6x6 6.1.a', true);
        changeVis('Horyzontal 6x6 6.1.a2', false);
        changeVis('Horyzontal 6x6 6.1.b', true);
        changeVis('Horyzontal 6x6 6.1.b2', false);
        changeVis('Horyzontal 6x6 6.1.y', false);
        changeVis('Horyzontal 6x6 6.1.c', true);
        changeVis('Horyzontal 6x6 6.1.c2', false);
        changeVis('Horyzontal 6x6 6.1.d', true);
        changeVis('Horyzontal 6x6 6.1.h', true);
        changeVis('Horyzontal 6x6 6.1.e', true);
        changeVis('Horyzontal 6x6 6.1.e2', false);
        changeVis('Horyzontal 6x6 6.1.f', true);
        changeVis('Horyzontal 6x6 6.1.f2', false);
        changeVis('Horyzontal 6x6 6.1.z', false);
        changeVis('Horyzontal 6x6 6.1.g', true);
        changeVis('Horyzontal 6x6 6.1.g2', false);
        changeVis(['GROUP', 'Falista 6x6'], false);
        changeVis(['GROUP', 'Modern Plus 6x6'], false);
        changeVis(['GROUP', 'Zaluzja 6x6'], false);
        changeVis(['GROUP', 'Falista 3x6'], false);
        changeVis(['GROUP', 'Horyzontal 3x6'], false);
        changeVis(['GROUP', 'Modern Plus 3x6'], false);
        changeVis(['GROUP', 'Zaluzja 3x6'], false);
      }
      if (getHTMLElemAttribute('value', 'slider2', true) > '0.599') {
        _3C = 0;
        _3E = 1;
        changeVis('Horyzontal 6x6 6.1.a2', true);
        changeVis('Horyzontal 6x6 6.1.a', false);
        changeVis('Horyzontal 6x6 6.1.b2', true);
        changeVis('Horyzontal 6x6 6.1.b', false);
        changeVis('Horyzontal 6x6 6.1.y', true);
        changeVis('Horyzontal 6x6 6.1.c2', true);
        changeVis('Horyzontal 6x6 6.1.c', false);
        changeVis('Horyzontal 6x6 6.1.d', true);
        changeVis('Horyzontal 6x6 6.1.h', true);
        changeVis('Horyzontal 6x6 6.1.e2', true);
        changeVis('Horyzontal 6x6 6.1.e', false);
        changeVis('Horyzontal 6x6 6.1.f2', true);
        changeVis('Horyzontal 6x6 6.1.f', false);
        changeVis('Horyzontal 6x6 6.1.z', true);
        changeVis('Horyzontal 6x6 6.1.g2', true);
        changeVis('Horyzontal 6x6 6.1.g', false);
        changeVis(['GROUP', 'Falista 6x6'], false);
        changeVis(['GROUP', 'Modern Plus 6x6'], false);
        changeVis(['GROUP', 'Zaluzja 6x6'], false);
        changeVis(['GROUP', 'Falista 3x6'], false);
        changeVis(['GROUP', 'Horyzontal 3x6'], false);
        changeVis(['GROUP', 'Modern Plus 3x6'], false);
        changeVis(['GROUP', 'Zaluzja 3x6'], false);
      }
    }
    if (my_5_c == 1 || isObjectVisible(['GROUP', 'Modern Plus 6x6'])) {
      if (getHTMLElemAttribute('value', 'slider2', true) < '0.599') {
        _3C = 1;
        _3E = 0;
        changeVis('Modern Plus 6x6 6.1.a', true);
        changeVis('Modern Plus 6x6 6.1.a2', false);
        changeVis('Modern Plus 6x6 6.1.b', true);
        changeVis('Modern Plus 6x6 6.1.b2', false);
        changeVis('Modern Plus 6x6 6.1.y', false);
        changeVis('Modern Plus 6x6 6.1.c', true);
        changeVis('Modern Plus 6x6 6.1.c2', false);
        changeVis('Modern Plus 6x6 6.1.d', true);
        changeVis('Modern Plus 6x6 6.1.h', true);
        changeVis('Modern Plus 6x6 6.1.e', true);
        changeVis('Modern Plus 6x6 6.1.e2', false);
        changeVis('Modern Plus 6x6 6.1.f', true);
        changeVis('Modern Plus 6x6 6.1.f2', false);
        changeVis('Modern Plus 6x6 6.1.z', false);
        changeVis('Modern Plus 6x6 6.1.g', true);
        changeVis('Modern Plus 6x6 6.1.g2', false);
        changeVis(['GROUP', 'Horyzontal 6x6'], false);
        changeVis(['GROUP', 'Falista 6x6'], false);
        changeVis(['GROUP', 'Zaluzja 6x6'], false);
        changeVis(['GROUP', 'Falista 3x6'], false);
        changeVis(['GROUP', 'Horyzontal 3x6'], false);
        changeVis(['GROUP', 'Modern Plus 3x6'], false);
        changeVis(['GROUP', 'Zaluzja 3x6'], false);
      }
      if (getHTMLElemAttribute('value', 'slider2', true) > '0.599') {
        _3C = 0;
        _3E = 1;
        changeVis('Modern Plus 6x6 6.1.a2', true);
        changeVis('Modern Plus 6x6 6.1.a', false);
        changeVis('Modern Plus 6x6 6.1.b2', true);
        changeVis('Modern Plus 6x6 6.1.b', false);
        changeVis('Modern Plus 6x6 6.1.y', true);
        changeVis('Modern Plus 6x6 6.1.c2', true);
        changeVis('Modern Plus 6x6 6.1.c', false);
        changeVis('Modern Plus 6x6 6.1.d', true);
        changeVis('Modern Plus 6x6 6.1.h', true);
        changeVis('Modern Plus 6x6 6.1.e2', true);
        changeVis('Modern Plus 6x6 6.1.e', false);
        changeVis('Modern Plus 6x6 6.1.f2', true);
        changeVis('Modern Plus 6x6 6.1.f', false);
        changeVis('Modern Plus 6x6 6.1.z', true);
        changeVis('Modern Plus 6x6 6.1.g2', true);
        changeVis('Modern Plus 6x6 6.1.g', false);
        changeVis(['GROUP', 'Horyzontal 6x6'], false);
        changeVis(['GROUP', 'Falista 6x6'], false);
        changeVis(['GROUP', 'Zaluzja 6x6'], false);
        changeVis(['GROUP', 'Falista 3x6'], false);
        changeVis(['GROUP', 'Horyzontal 3x6'], false);
        changeVis(['GROUP', 'Modern Plus 3x6'], false);
        changeVis(['GROUP', 'Zaluzja 3x6'], false);
      }
    }
    if (my_5_d == 1 || isObjectVisible(['GROUP', 'Zaluzja 6x6'])) {
      if (getHTMLElemAttribute('value', 'slider2', true) < '0.599') {
        _3C = 1;
        _3E = 0;
        changeVis('Zaluzja 6x6 6.1.a', true);
        changeVis('Zaluzja 6x6 6.1.a2', false);
        changeVis('Zaluzja 6x6 6.1.b', true);
        changeVis('Zaluzja 6x6 6.1.b2', false);
        changeVis('Zaluzja 6x6 6.1.y', false);
        changeVis('Zaluzja 6x6 6.1.c', true);
        changeVis('Zaluzja 6x6 6.1.c2', false);
        changeVis('Zaluzja 6x6 6.1.d', true);
        changeVis('Zaluzja 6x6 6.1.h', true);
        changeVis('Zaluzja 6x6 6.1.e', true);
        changeVis('Zaluzja 6x6 6.1.e2', false);
        changeVis('Zaluzja 6x6 6.1.f', true);
        changeVis('Zaluzja 6x6 6.1.f2', false);
        changeVis('Zaluzja 6x6 6.1.z', false);
        changeVis('Zaluzja 6x6 6.1.g', true);
        changeVis('Zaluzja 6x6 6.1.g2', false);
        changeVis(['GROUP', 'Horyzontal 6x6'], false);
        changeVis(['GROUP', 'Modern Plus 6x6'], false);
        changeVis(['GROUP', 'Falista 6x6'], false);
        changeVis(['GROUP', 'Falista 3x6'], false);
        changeVis(['GROUP', 'Horyzontal 3x6'], false);
        changeVis(['GROUP', 'Modern Plus 3x6'], false);
        changeVis(['GROUP', 'Zaluzja 3x6'], false);
      }
      if (getHTMLElemAttribute('value', 'slider2', true) > '0.599') {
        _3C = 0;
        _3E = 1;
        changeVis('Zaluzja 6x6 6.1.a2', true);
        changeVis('Zaluzja 6x6 6.1.a', false);
        changeVis('Zaluzja 6x6 6.1.b2', true);
        changeVis('Zaluzja 6x6 6.1.b', false);
        changeVis('Zaluzja 6x6 6.1.y', true);
        changeVis('Zaluzja 6x6 6.1.c2', true);
        changeVis('Zaluzja 6x6 6.1.c', false);
        changeVis('Zaluzja 6x6 6.1.d', true);
        changeVis('Zaluzja 6x6 6.1.h', true);
        changeVis('Zaluzja 6x6 6.1.e2', true);
        changeVis('Zaluzja 6x6 6.1.e', false);
        changeVis('Zaluzja 6x6 6.1.f2', true);
        changeVis('Zaluzja 6x6 6.1.f', false);
        changeVis('Zaluzja 6x6 6.1.z', true);
        changeVis('Zaluzja 6x6 6.1.g2', true);
        changeVis('Zaluzja 6x6 6.1.g', false);
        changeVis(['GROUP', 'Horyzontal 6x6'], false);
        changeVis(['GROUP', 'Modern Plus 6x6'], false);
        changeVis(['GROUP', 'Falista 6x6'], false);
        changeVis(['GROUP', 'Falista 3x6'], false);
        changeVis(['GROUP', 'Horyzontal 3x6'], false);
        changeVis(['GROUP', 'Modern Plus 3x6'], false);
        changeVis(['GROUP', 'Zaluzja 3x6'], false);
      }
    }
  }
});

setScreenScale(window.devicePixelRatio);
my_5_a = 1;
_3C = 1;
Wiata1 = 1;
Wiata2 = 0;
Wiata3 = 0;
assignMat(['GROUP', 'Jednostanowiskowa'], 'Metal Gray');
changeVis([['GROUP', 'Dach 1'], ['GROUP', 'Maskownica 1'], 'Falista 3x6 6.1.a', 'Falista 3x6 6.1.b', 'Falista 3x6 6.1.c', 'Falista 3x6 6.1.d', 'Falista 3x6 6.1.e', 'Falista 3x6 6.1.f', 'Falista 3x6 6.1.g', 'Profil 3x6 dodatek', 'Profil 3x6 1 700', 'Profil 3x6 2 700', 'Profil 3x6 4 700', 'Profil 3x6 5 700'], true);
changeVis([['GROUP', 'Dwustanowiskowa'], ['GROUP', 'Wielostanowiskowa'], ['GROUP', 'Horyzontal 3x6'], ['GROUP', 'Modern Plus 3x6'], ['GROUP', 'Zaluzja 3x6'], ['GROUP', 'Ściany 1'], 'Profil 3x6 2 900', 'Profil 3x6  3', 'Profil 3x6 4 900', 'Falista 3x6 6.1.a2', 'Falista 3x6 6.1.b2', 'Falista 3x6 6.1.c2', 'Falista 3x6 6.1.e2', 'Falista 3x6 6.1.f2', 'Falista 3x6 6.1.g2', 'Falista 3x6 6.1.y', 'Falista 3x6 6.1.z'], false);

eventHTMLElem('input', 'slider2', true, function(event) {
  if (Wiata3 == 1) {
    if (getHTMLElemAttribute('value', 'slider2', true) < '0.599') {
      changeVis('Profil Wielostan 2 700', true);
      changeVis('Profil 6x6 2 700', true);
      changeVis('Profil Wielostan 2 900', false);
      changeVis('Profil 6x6 2 900', false);
      changeVis('Profil 3x6 2 900', false);
      changeVis('Profil 3x6 2 700', false);
    }
    if (getHTMLElemAttribute('value', 'slider2', true) > '0.599') {
      changeVis('Profil Wielostan 2 900', true);
      changeVis('Profil 6x6 2 900', true);
      changeVis('Profil Wielostan 2 700', false);
      changeVis('Profil 6x6 2 700', false);
      changeVis('Profil 3x6 2 700', false);
      changeVis('Profil 3x6 2 900', false);
    }
    if (getHTMLElemAttribute('value', 'slider2', true) < '0.599') {
      changeVis('Profil Wielostan 4 700', true);
      changeVis('Profil 6x6 4 700', true);
      changeVis('Profil Wielostan 4 900', false);
      changeVis('Profil 6x6 4 900', false);
      changeVis('Profil 3x6 4 900', false);
      changeVis('Profil 3x6 4 700', false);
    }
    if (getHTMLElemAttribute('value', 'slider2', true) > '0.599') {
      changeVis('Profil Wielostan 4 900', true);
      changeVis('Profil 6x6 4 900', true);
      changeVis('Profil Wielostan 4 700', false);
      changeVis('Profil 6x6 4 700', false);
      changeVis('Profil 3x6 4 700', false);
      changeVis('Profil 3x6 4 900', false);
    }
    if (getHTMLElemAttribute('value', 'slider2', true) > '0.599') {
      changeVis('Profil Wielostan 3', true);
      changeVis('Profil 6x6  3', true);
      changeVis('Profil 3x6  3', false);
    }
    if (getHTMLElemAttribute('value', 'slider2', true) < '0.599') {
      changeVis('Profil Wielostan 3', false);
      changeVis('Profil 6x6  3', false);
      changeVis('Profil 3x6  3', false);
    }
    if (my_5_a == 1 || isObjectVisible(['GROUP', 'Falista Wielostan'])) {
      if (getHTMLElemAttribute('value', 'slider2', true) < '0.599') {
        _3C = 1;
        _3E = 0;
        changeVis('Falista 6x6 6.1.a', true);
        changeVis('Falista 6x6 6.1.a2', false);
        changeVis('Falista 6x6 6.1.b', true);
        changeVis('Falista 6x6 6.1.b2', false);
        changeVis('Falista 6x6 6.1.y', false);
        changeVis('Falista 6x6 6.1.c', true);
        changeVis('Falista 6x6 6.1.c2', false);
        changeVis('Falista 6x6 6.1.d', true);
        changeVis('Falista 6x6 6.1.h', true);
        changeVis('Falista Wielostan 6.1.d', true);
        changeVis('Falista Wielostan 6.1.e', true);
        changeVis('Falista Wielostan 6.1.e2', false);
        changeVis('Falista Wielostan 6.1.f', true);
        changeVis('Falista Wielostan 6.1.f2', false);
        changeVis('Falista Wielostan 6.1.z', false);
        changeVis('Falista Wielostan 6.1.g', true);
        changeVis('Falista Wielostan 6.1.g2', false);
        changeVis(['GROUP', 'Horyzontal Wielostan'], false);
        changeVis(['GROUP', 'Modern Plus Wielostan'], false);
        changeVis(['GROUP', 'Zaluzja Wielostan'], false);
        changeVis(['GROUP', 'Horyzontal 6x6'], false);
        changeVis(['GROUP', 'Modern Plus 6x6'], false);
        changeVis(['GROUP', 'Zaluzja 6x6'], false);
        changeVis(['GROUP', 'Falista 3x6'], false);
        changeVis(['GROUP', 'Horyzontal 3x6'], false);
        changeVis(['GROUP', 'Modern Plus 3x6'], false);
        changeVis(['GROUP', 'Zaluzja 3x6'], false);
      }
      if (getHTMLElemAttribute('value', 'slider2', true) > '0.599') {
        _3C = 0;
        _3E = 1;
        changeVis('Falista 6x6 6.1.a2', true);
        changeVis('Falista 6x6 6.1.a', false);
        changeVis('Falista 6x6 6.1.b2', true);
        changeVis('Falista 6x6 6.1.b', false);
        changeVis('Falista 6x6 6.1.y', true);
        changeVis('Falista 6x6 6.1.c2', true);
        changeVis('Falista 6x6 6.1.c', false);
        changeVis('Falista 6x6 6.1.d', true);
        changeVis('Falista 6x6 6.1.h', true);
        changeVis('Falista Wielostan 6.1.e2', true);
        changeVis('Falista Wielostan 6.1.d', true);
        changeVis('Falista Wielostan 6.1.e', false);
        changeVis('Falista Wielostan 6.1.f2', true);
        changeVis('Falista Wielostan 6.1.f', false);
        changeVis('Falista Wielostan 6.1.z', true);
        changeVis('Falista Wielostan 6.1.g2', true);
        changeVis('Falista Wielostan 6.1.g', false);
        changeVis(['GROUP', 'Horyzontal Wielostan'], false);
        changeVis(['GROUP', 'Modern Plus Wielostan'], false);
        changeVis(['GROUP', 'Zaluzja Wielostan'], false);
        changeVis(['GROUP', 'Horyzontal 6x6'], false);
        changeVis(['GROUP', 'Modern Plus 6x6'], false);
        changeVis(['GROUP', 'Zaluzja 6x6'], false);
        changeVis(['GROUP', 'Falista 3x6'], false);
        changeVis(['GROUP', 'Horyzontal 3x6'], false);
        changeVis(['GROUP', 'Modern Plus 3x6'], false);
        changeVis(['GROUP', 'Zaluzja 3x6'], false);
      }
    }
    if (my_5_b == 1 || isObjectVisible(['GROUP', 'Horyzontal Wielostan'])) {
      if (getHTMLElemAttribute('value', 'slider2', true) < '0.599') {
        _3C = 1;
        _3E = 0;
        changeVis('Horyzontal 6x6 6.1.a', true);
        changeVis('Horyzontal 6x6 6.1.a2', false);
        changeVis('Horyzontal 6x6 6.1.b', true);
        changeVis('Horyzontal 6x6 6.1.b2', false);
        changeVis('Horyzontal 6x6 6.1.y', false);
        changeVis('Horyzontal 6x6 6.1.c', true);
        changeVis('Horyzontal 6x6 6.1.c2', false);
        changeVis('Horyzontal 6x6 6.1.d', true);
        changeVis('Horyzontal 6x6 6.1.h', true);
        changeVis('Horyzontal Wielostan 6.1.d', true);
        changeVis('Horyzontal Wielostan 6.1.e', true);
        changeVis('Horyzontal Wielostan 6.1.e2', false);
        changeVis('Horyzontal Wielostan 6.1.f', true);
        changeVis('Horyzontal Wielostan 6.1.f2', false);
        changeVis('Horyzontal Wielostan 6.1.z', false);
        changeVis('Horyzontal Wielostan 6.1.g', true);
        changeVis('Horyzontal Wielostan 6.1.g2', false);
        changeVis(['GROUP', 'Falista Wielostan'], false);
        changeVis(['GROUP', 'Modern Plus Wielostan'], false);
        changeVis(['GROUP', 'Zaluzja Wielostan'], false);
        changeVis(['GROUP', 'Falista 6x6'], false);
        changeVis(['GROUP', 'Modern Plus 6x6'], false);
        changeVis(['GROUP', 'Zaluzja 6x6'], false);
        changeVis(['GROUP', 'Falista 3x6'], false);
        changeVis(['GROUP', 'Horyzontal 3x6'], false);
        changeVis(['GROUP', 'Modern Plus 3x6'], false);
        changeVis(['GROUP', 'Zaluzja 3x6'], false);
      }
      if (getHTMLElemAttribute('value', 'slider2', true) > '0.599') {
        _3C = 0;
        _3E = 1;
        changeVis('Horyzontal 6x6 6.1.a2', true);
        changeVis('Horyzontal 6x6 6.1.a', false);
        changeVis('Horyzontal 6x6 6.1.b2', true);
        changeVis('Horyzontal 6x6 6.1.b', false);
        changeVis('Horyzontal 6x6 6.1.y', true);
        changeVis('Horyzontal 6x6 6.1.c2', true);
        changeVis('Horyzontal 6x6 6.1.c', false);
        changeVis('Horyzontal 6x6 6.1.d', true);
        changeVis('Horyzontal 6x6 6.1.h', true);
        changeVis('Horyzontal Wielostan 6.1.d', true);
        changeVis('Horyzontal Wielostan 6.1.e2', true);
        changeVis('Horyzontal Wielostan 6.1.e', false);
        changeVis('Horyzontal Wielostan 6.1.f2', true);
        changeVis('Horyzontal Wielostan 6.1.f', false);
        changeVis('Horyzontal Wielostan 6.1.z', true);
        changeVis('Horyzontal Wielostan 6.1.g2', true);
        changeVis('Horyzontal Wielostan 6.1.g', false);
        changeVis(['GROUP', 'Falista Wielostan'], false);
        changeVis(['GROUP', 'Modern Plus Wielostan'], false);
        changeVis(['GROUP', 'Zaluzja Wielostan'], false);
        changeVis(['GROUP', 'Falista 6x6'], false);
        changeVis(['GROUP', 'Modern Plus 6x6'], false);
        changeVis(['GROUP', 'Zaluzja 6x6'], false);
        changeVis(['GROUP', 'Falista 3x6'], false);
        changeVis(['GROUP', 'Horyzontal 3x6'], false);
        changeVis(['GROUP', 'Modern Plus 3x6'], false);
        changeVis(['GROUP', 'Zaluzja 3x6'], false);
      }
    }
    if (my_5_c == 1 || isObjectVisible(['GROUP', 'Modern Plus Wielostan'])) {
      if (getHTMLElemAttribute('value', 'slider2', true) < '0.599') {
        _3C = 1;
        _3E = 0;
        changeVis('Modern Plus 6x6 6.1.a', true);
        changeVis('Modern Plus 6x6 6.1.a2', false);
        changeVis('Modern Plus 6x6 6.1.b', true);
        changeVis('Modern Plus 6x6 6.1.b2', false);
        changeVis('Modern Plus 6x6 6.1.y', false);
        changeVis('Modern Plus 6x6 6.1.c', true);
        changeVis('Modern Plus 6x6 6.1.c2', false);
        changeVis('Modern Plus 6x6 6.1.d', true);
        changeVis('Modern Plus 6x6 6.1.h', true);
        changeVis('Modern Plus Wielostan 6.1.d', true);
        changeVis('Modern Plus Wielostan 6.1.e', true);
        changeVis('Modern Plus Wielostan 6.1.e2', false);
        changeVis('Modern Plus Wielostan 6.1.f', true);
        changeVis('Modern Plus Wielostan 6.1.f2', false);
        changeVis('Modern Plus Wielostan 6.1.z', false);
        changeVis('Modern Plus Wielostan 6.1.g', true);
        changeVis('Modern Plus Wielostan 6.1.g2', false);
        changeVis(['GROUP', 'Falista Wielostan'], false);
        changeVis(['GROUP', 'Zaluzja Wielostan'], false);
        changeVis(['GROUP', 'Horyzontal Wielostan'], false);
        changeVis(['GROUP', 'Horyzontal 6x6'], false);
        changeVis(['GROUP', 'Falista 6x6'], false);
        changeVis(['GROUP', 'Zaluzja 6x6'], false);
        changeVis(['GROUP', 'Falista 3x6'], false);
        changeVis(['GROUP', 'Horyzontal 3x6'], false);
        changeVis(['GROUP', 'Modern Plus 3x6'], false);
        changeVis(['GROUP', 'Zaluzja 3x6'], false);
      }
      if (getHTMLElemAttribute('value', 'slider2', true) > '0.599') {
        _3C = 0;
        _3E = 1;
        changeVis('Modern Plus 6x6 6.1.a2', true);
        changeVis('Modern Plus 6x6 6.1.a', false);
        changeVis('Modern Plus 6x6 6.1.b2', true);
        changeVis('Modern Plus 6x6 6.1.b', false);
        changeVis('Modern Plus 6x6 6.1.y', true);
        changeVis('Modern Plus 6x6 6.1.c2', true);
        changeVis('Modern Plus 6x6 6.1.c', false);
        changeVis('Modern Plus 6x6 6.1.d', true);
        changeVis('Modern Plus 6x6 6.1.h', true);
        changeVis('Modern Plus Wielostan 6.1.d', true);
        changeVis('Modern Plus Wielostan 6.1.e2', true);
        changeVis('Modern Plus Wielostan 6.1.e', false);
        changeVis('Modern Plus Wielostan 6.1.f2', true);
        changeVis('Modern Plus Wielostan 6.1.f', false);
        changeVis('Modern Plus Wielostan 6.1.z', true);
        changeVis('Modern Plus Wielostan 6.1.g2', true);
        changeVis('Modern Plus Wielostan 6.1.g', false);
        changeVis(['GROUP', 'Falista Wielostan'], false);
        changeVis(['GROUP', 'Zaluzja Wielostan'], false);
        changeVis(['GROUP', 'Horyzontal Wielostan'], false);
        changeVis(['GROUP', 'Horyzontal 6x6'], false);
        changeVis(['GROUP', 'Falista 6x6'], false);
        changeVis(['GROUP', 'Zaluzja 6x6'], false);
        changeVis(['GROUP', 'Falista 3x6'], false);
        changeVis(['GROUP', 'Horyzontal 3x6'], false);
        changeVis(['GROUP', 'Modern Plus 3x6'], false);
        changeVis(['GROUP', 'Zaluzja 3x6'], false);
      }
    }
    if (my_5_d == 1 || isObjectVisible(['GROUP', 'Zaluzja Wielostan'])) {
      if (getHTMLElemAttribute('value', 'slider2', true) < '0.599') {
        _3C = 1;
        _3E = 0;
        changeVis('Zaluzja 6x6 6.1.a', true);
        changeVis('Zaluzja 6x6 6.1.a2', false);
        changeVis('Zaluzja 6x6 6.1.b', true);
        changeVis('Zaluzja 6x6 6.1.b2', false);
        changeVis('Zaluzja 6x6 6.1.y', false);
        changeVis('Zaluzja 6x6 6.1.c', true);
        changeVis('Zaluzja 6x6 6.1.c2', false);
        changeVis('Zaluzja 6x6 6.1.d', true);
        changeVis('Zaluzja 6x6 6.1.h', true);
        changeVis('Zaluzja Wielostan 6.1.d', true);
        changeVis('Zaluzja Wielostan 6.1.e', true);
        changeVis('Zaluzja Wielostan 6.1.e2', false);
        changeVis('Zaluzja Wielostan 6.1.f', true);
        changeVis('Zaluzja Wielostan 6.1.f2', false);
        changeVis('Zaluzja Wielostan 6.1.z', false);
        changeVis('Zaluzja Wielostan 6.1.g', true);
        changeVis('Zaluzja Wielostan 6.1.g2', false);
        changeVis(['GROUP', 'Falista Wielostan'], false);
        changeVis(['GROUP', 'Modern Plus Wielostan'], false);
        changeVis(['GROUP', 'Horyzontal Wielostan'], false);
        changeVis(['GROUP', 'Horyzontal 6x6'], false);
        changeVis(['GROUP', 'Modern Plus 6x6'], false);
        changeVis(['GROUP', 'Falista 6x6'], false);
        changeVis(['GROUP', 'Falista 3x6'], false);
        changeVis(['GROUP', 'Horyzontal 3x6'], false);
        changeVis(['GROUP', 'Modern Plus 3x6'], false);
        changeVis(['GROUP', 'Zaluzja 3x6'], false);
      }
      if (getHTMLElemAttribute('value', 'slider2', true) > '0.599') {
        _3C = 0;
        _3E = 1;
        changeVis('Zaluzja 6x6 6.1.a2', true);
        changeVis('Zaluzja 6x6 6.1.a', false);
        changeVis('Zaluzja 6x6 6.1.b2', true);
        changeVis('Zaluzja 6x6 6.1.b', false);
        changeVis('Zaluzja 6x6 6.1.y', true);
        changeVis('Zaluzja 6x6 6.1.c2', true);
        changeVis('Zaluzja 6x6 6.1.c', false);
        changeVis('Zaluzja 6x6 6.1.d', true);
        changeVis('Zaluzja 6x6 6.1.h', true);
        changeVis('Zaluzja Wielostan 6.1.d', true);
        changeVis('Zaluzja Wielostan 6.1.e2', true);
        changeVis('Zaluzja Wielostan 6.1.e', false);
        changeVis('Zaluzja Wielostan 6.1.f2', true);
        changeVis('Zaluzja Wielostan 6.1.f', false);
        changeVis('Zaluzja Wielostan 6.1.z', true);
        changeVis('Zaluzja Wielostan 6.1.g2', true);
        changeVis('Zaluzja Wielostan 6.1.g', false);
        changeVis(['GROUP', 'Falista Wielostan'], false);
        changeVis(['GROUP', 'Modern Plus Wielostan'], false);
        changeVis(['GROUP', 'Horyzontal Wielostan'], false);
        changeVis(['GROUP', 'Horyzontal 6x6'], false);
        changeVis(['GROUP', 'Modern Plus 6x6'], false);
        changeVis(['GROUP', 'Falista 6x6'], false);
        changeVis(['GROUP', 'Falista 3x6'], false);
        changeVis(['GROUP', 'Horyzontal 3x6'], false);
        changeVis(['GROUP', 'Modern Plus 3x6'], false);
        changeVis(['GROUP', 'Zaluzja 3x6'], false);
      }
    }
  }
});

eventHTMLElem('click', '5.a', true, function(event) {
  my_61e = 0;
  my_61d = 0;
  my_5_b = 0;
  my_5_c = 0;
  my_5_d = 0;
  if (Wiata1 == 1 && _3C == 1) {
    my_5_a = 1;
    if (isObjectVisible(['GROUP', 'Falista 3x6'])) {
      changeVis(['GROUP', 'Horyzontal 3x6'], false);
      changeVis(['GROUP', 'Modern Plus 3x6'], false);
      changeVis(['GROUP', 'Zaluzja 3x6'], false);
    } else {
      changeVis('Falista 3x6 6.1.a', true);
      changeVis('Falista 3x6 6.1.b', true);
      changeVis('Falista 3x6 6.1.c', true);
      changeVis('Falista 3x6 6.1.d', true);
      changeVis('Falista 3x6 6.1.e', true);
      changeVis('Falista 3x6 6.1.f', true);
      changeVis('Falista 3x6 6.1.g', true);
      changeVis(['GROUP', 'Horyzontal 3x6'], false);
      changeVis(['GROUP', 'Modern Plus 3x6'], false);
      changeVis(['GROUP', 'Zaluzja 3x6'], false);
    }
  } else if (Wiata1 == 1 && _3E == 1) {
    my_5_a = 1;
    if (isObjectVisible(['GROUP', 'Falista 3x6'])) {
      changeVis(['GROUP', 'Horyzontal 3x6'], false);
      changeVis(['GROUP', 'Modern Plus 3x6'], false);
      changeVis(['GROUP', 'Zaluzja 3x6'], false);
    } else {
      changeVis('Falista 3x6 6.1.a2', true);
      changeVis('Falista 3x6 6.1.b2', true);
      changeVis('Falista 3x6 6.1.c2', true);
      changeVis('Falista 3x6 6.1.d', true);
      changeVis('Falista 3x6 6.1.e2', true);
      changeVis('Falista 3x6 6.1.f2', true);
      changeVis('Falista 3x6 6.1.g2', true);
      changeVis('Falista 3x6 6.1.y', true);
      changeVis('Falista 3x6 6.1.z', true);
      changeVis(['GROUP', 'Horyzontal 3x6'], false);
      changeVis(['GROUP', 'Modern Plus 3x6'], false);
      changeVis(['GROUP', 'Zaluzja 3x6'], false);
    }
  } else if (Wiata2 == 1 && _3C == 1) {
    my_5_a = 1;
    if (isObjectVisible(['GROUP', 'Falista 6x6'])) {
      changeVis(['GROUP', 'Horyzontal 6x6'], false);
      changeVis(['GROUP', 'Modern Plus 6x6'], false);
      changeVis(['GROUP', 'Zaluzja 6x6'], false);
    } else {
      changeVis('Profil 6x6 tył', true);
      changeVis('Falista 6x6 6.1.a', true);
      changeVis('Falista 6x6 6.1.b', true);
      changeVis('Falista 6x6 6.1.c', true);
      changeVis('Falista 6x6 6.1.d', true);
      changeVis('Falista 6x6 6.1.h', true);
      changeVis('Falista 6x6 6.1.e', true);
      changeVis('Falista 6x6 6.1.f', true);
      changeVis('Falista 6x6 6.1.g', true);
      changeVis(['GROUP', 'Horyzontal 6x6'], false);
      changeVis(['GROUP', 'Modern Plus 6x6'], false);
      changeVis(['GROUP', 'Zaluzja 6x6'], false);
    }
  } else if (Wiata2 == 1 && _3E == 1) {
    my_5_a = 1;
    if (isObjectVisible(['GROUP', 'Falista 6x6'])) {
      changeVis(['GROUP', 'Horyzontal 6x6'], false);
      changeVis(['GROUP', 'Modern Plus 6x6'], false);
      changeVis(['GROUP', 'Zaluzja 6x6'], false);
    } else {
      changeVis('Profil 6x6 tył', true);
      changeVis('Falista 6x6 6.1.a2', true);
      changeVis('Falista 6x6 6.1.b2', true);
      changeVis('Falista 6x6 6.1.c2', true);
      changeVis('Falista 6x6 6.1.d', true);
      changeVis('Falista 6x6 6.1.h', true);
      changeVis('Falista 6x6 6.1.e2', true);
      changeVis('Falista 6x6 6.1.f2', true);
      changeVis('Falista 6x6 6.1.g2', true);
      changeVis('Falista 6x6 6.1.y', true);
      changeVis('Falista 6x6 6.1.z', true);
      changeVis(['GROUP', 'Horyzontal 6x6'], false);
      changeVis(['GROUP', 'Modern Plus 6x6'], false);
      changeVis(['GROUP', 'Zaluzja 6x6'], false);
    }
  } else if (Wiata3 == 1 && _3C == 1) {
    my_5_a = 1;
    if (isObjectVisible(['GROUP', 'Falista Wielostan'])) {
      changeVis(['GROUP', 'Horyzontal Wielostan'], false);
      changeVis(['GROUP', 'Modern Plus Wielostan'], false);
      changeVis(['GROUP', 'Zaluzja Wielostan'], false);
      changeVis(['GROUP', 'Horyzontal 6x6'], false);
      changeVis(['GROUP', 'Modern Plus 6x6'], false);
      changeVis(['GROUP', 'Zaluzja 6x6'], false);
    } else {
      changeVis('Falista 6x6 6.1.a', true);
      changeVis('Falista 6x6 6.1.b', true);
      changeVis('Falista 6x6 6.1.c', true);
      changeVis('Falista 6x6 6.1.d', true);
      changeVis('Falista 6x6 6.1.h', true);
      changeVis('Falista Wielostan 6.1.d', true);
      changeVis('Falista Wielostan 6.1.e', true);
      changeVis('Falista Wielostan 6.1.f', true);
      changeVis('Falista Wielostan 6.1.g', true);
      changeVis(['GROUP', 'Horyzontal Wielostan'], false);
      changeVis(['GROUP', 'Modern Plus Wielostan'], false);
      changeVis(['GROUP', 'Zaluzja Wielostan'], false);
      changeVis(['GROUP', 'Horyzontal 6x6'], false);
      changeVis(['GROUP', 'Modern Plus 6x6'], false);
      changeVis(['GROUP', 'Zaluzja 6x6'], false);
    }
  } else if (Wiata3 == 1 && _3E == 1) {
    my_5_a = 1;
    if (isObjectVisible(['GROUP', 'Falista Wielostan'])) {
      changeVis(['GROUP', 'Horyzontal Wielostan'], false);
      changeVis(['GROUP', 'Modern Plus Wielostan'], false);
      changeVis(['GROUP', 'Zaluzja Wielostan'], false);
      changeVis(['GROUP', 'Horyzontal 6x6'], false);
      changeVis(['GROUP', 'Modern Plus 6x6'], false);
      changeVis(['GROUP', 'Zaluzja 6x6'], false);
    } else {
      changeVis('Falista 6x6 6.1.a2', true);
      changeVis('Falista 6x6 6.1.b2', true);
      changeVis('Falista 6x6 6.1.c2', true);
      changeVis('Falista 6x6 6.1.d', true);
      changeVis('Falista 6x6 6.1.h', true);
      changeVis('Falista 6x6 6.1.y', true);
      changeVis('Falista Wielostan 6.1.d', true);
      changeVis('Falista Wielostan 6.1.e2', true);
      changeVis('Falista Wielostan 6.1.f2', true);
      changeVis('Falista Wielostan 6.1.g2', true);
      changeVis('Falista Wielostan 6.1.z', true);
      changeVis(['GROUP', 'Horyzontal Wielostan'], false);
      changeVis(['GROUP', 'Modern Plus Wielostan'], false);
      changeVis(['GROUP', 'Zaluzja Wielostan'], false);
      changeVis(['GROUP', 'Horyzontal 6x6'], false);
      changeVis(['GROUP', 'Modern Plus 6x6'], false);
      changeVis(['GROUP', 'Zaluzja 6x6'], false);
    }
  }
});
eventHTMLElem('click', '5.b', true, function(event) {
  my_61e = 0;
  my_61d = 0;
  my_5_a = 0;
  my_5_b = 1;
  my_5_c = 0;
  my_5_d = 0;
  if (Wiata1 == 1 && _3C == 1) {
    if (isObjectVisible(['GROUP', 'Horyzontal 3x6'])) {
      changeVis(['GROUP', 'Falista 3x6'], false);
      changeVis(['GROUP', 'Modern Plus 3x6'], false);
      changeVis(['GROUP', 'Zaluzja 3x6'], false);
    } else {
      changeVis('Horyzontal 3x6 6.1.a', true);
      changeVis('Horyzontal 3x6 6.1.b', true);
      changeVis('Horyzontal 3x6 6.1.c', true);
      changeVis('Horyzontal 3x6 6.1.d', true);
      changeVis('Horyzontal 3x6 6.1.e', true);
      changeVis('Horyzontal 3x6 6.1.f', true);
      changeVis('Horyzontal 3x6 6.1.g', true);
      changeVis(['GROUP', 'Modern Plus 3x6'], false);
      changeVis(['GROUP', 'Falista 3x6'], false);
      changeVis(['GROUP', 'Zaluzja 3x6'], false);
    }
  } else if (Wiata1 == 1 && _3E == 1) {
    if (isObjectVisible(['GROUP', 'Horyzontal 3x6'])) {
      changeVis(['GROUP', 'Falista 3x6'], false);
      changeVis(['GROUP', 'Modern Plus 3x6'], false);
      changeVis(['GROUP', 'Zaluzja 3x6'], false);
    } else {
      changeVis('Horyzontal 3x6 6.1.a2', true);
      changeVis('Horyzontal 3x6 6.1.b2', true);
      changeVis('Horyzontal 3x6 6.1.c2', true);
      changeVis('Horyzontal 3x6 6.1.d', true);
      changeVis('Horyzontal 3x6 6.1.e2', true);
      changeVis('Horyzontal 3x6 6.1.f2', true);
      changeVis('Horyzontal 3x6 6.1.g2', true);
      changeVis('Horyzontal 3x6 6.1.y', true);
      changeVis('Horyzontal 3x6 6.1.z', true);
      changeVis(['GROUP', 'Modern Plus 3x6'], false);
      changeVis(['GROUP', 'Falista 3x6'], false);
      changeVis(['GROUP', 'Zaluzja 3x6'], false);
    }
  } else if (Wiata2 == 1 && _3C == 1) {
    if (isObjectVisible(['GROUP', 'Horyzontal 6x6'])) {
      changeVis(['GROUP', 'Falista 6x6'], false);
      changeVis(['GROUP', 'Modern Plus 6x6'], false);
      changeVis(['GROUP', 'Zaluzja 6x6'], false);
    } else {
      changeVis('Profil 6x6 tył', true);
      changeVis('Horyzontal 6x6 6.1.a', true);
      changeVis('Horyzontal 6x6 6.1.b', true);
      changeVis('Horyzontal 6x6 6.1.c', true);
      changeVis('Horyzontal 6x6 6.1.d', true);
      changeVis('Horyzontal 6x6 6.1.h', true);
      changeVis('Horyzontal 6x6 6.1.e', true);
      changeVis('Horyzontal 6x6 6.1.f', true);
      changeVis('Horyzontal 6x6 6.1.g', true);
      changeVis(['GROUP', 'Modern Plus 6x6'], false);
      changeVis(['GROUP', 'Falista 6x6'], false);
      changeVis(['GROUP', 'Zaluzja 6x6'], false);
    }
  } else if (Wiata2 == 1 && _3E == 1) {
    if (isObjectVisible(['GROUP', 'Horyzontal 6x6'])) {
      changeVis(['GROUP', 'Falista 6x6'], false);
      changeVis(['GROUP', 'Modern Plus 6x6'], false);
      changeVis(['GROUP', 'Zaluzja 6x6'], false);
    } else {
      changeVis('Profil 6x6 tył', true);
      changeVis('Horyzontal 6x6 6.1.a2', true);
      changeVis('Horyzontal 6x6 6.1.b2', true);
      changeVis('Horyzontal 6x6 6.1.c2', true);
      changeVis('Horyzontal 6x6 6.1.d', true);
      changeVis('Horyzontal 6x6 6.1.h', true);
      changeVis('Horyzontal 6x6 6.1.e2', true);
      changeVis('Horyzontal 6x6 6.1.f2', true);
      changeVis('Horyzontal 6x6 6.1.g2', true);
      changeVis('Horyzontal 6x6 6.1.y', true);
      changeVis('Horyzontal 6x6 6.1.z', true);
      changeVis(['GROUP', 'Modern Plus 6x6'], false);
      changeVis(['GROUP', 'Falista 6x6'], false);
      changeVis(['GROUP', 'Zaluzja 6x6'], false);
    }
  } else if (Wiata3 == 1 && _3C == 1) {
    if (isObjectVisible(['GROUP', 'Horyzontal Wielostan'])) {
      changeVis(['GROUP', 'Falista Wielostan'], false);
      changeVis(['GROUP', 'Modern Plus Wielostan'], false);
      changeVis(['GROUP', 'Zaluzja Wielostan'], false);
      changeVis(['GROUP', 'Falista 6x6'], false);
      changeVis(['GROUP', 'Modern Plus 6x6'], false);
      changeVis(['GROUP', 'Zaluzja 6x6'], false);
    } else {
      changeVis('Horyzontal 6x6 6.1.a', true);
      changeVis('Horyzontal 6x6 6.1.b', true);
      changeVis('Horyzontal 6x6 6.1.c', true);
      changeVis('Horyzontal 6x6 6.1.d', true);
      changeVis('Horyzontal 6x6 6.1.h', true);
      changeVis('Horyzontal Wielostan 6.1.d', true);
      changeVis('Horyzontal Wielostan 6.1.e', true);
      changeVis('Horyzontal Wielostan 6.1.f', true);
      changeVis('Horyzontal Wielostan 6.1.g', true);
      changeVis(['GROUP', 'Falista Wielostan'], false);
      changeVis(['GROUP', 'Modern Plus Wielostan'], false);
      changeVis(['GROUP', 'Zaluzja Wielostan'], false);
      changeVis(['GROUP', 'Falista 6x6'], false);
      changeVis(['GROUP', 'Modern Plus 6x6'], false);
      changeVis(['GROUP', 'Zaluzja 6x6'], false);
    }
  } else if (Wiata3 == 1 && _3E == 1) {
    if (isObjectVisible(['GROUP', 'Horyzontal Wielostan'])) {
      changeVis(['GROUP', 'Falista Wielostan'], false);
      changeVis(['GROUP', 'Modern Plus Wielostan'], false);
      changeVis(['GROUP', 'Zaluzja Wielostan'], false);
      changeVis(['GROUP', 'Falista 6x6'], false);
      changeVis(['GROUP', 'Modern Plus 6x6'], false);
      changeVis(['GROUP', 'Zaluzja 6x6'], false);
    } else {
      changeVis('Horyzontal 6x6 6.1.a2', true);
      changeVis('Horyzontal 6x6 6.1.b2', true);
      changeVis('Horyzontal 6x6 6.1.c2', true);
      changeVis('Horyzontal 6x6 6.1.d', true);
      changeVis('Horyzontal 6x6 6.1.h', true);
      changeVis('Horyzontal 6x6 6.1.y', true);
      changeVis('Horyzontal Wielostan 6.1.d', true);
      changeVis('Horyzontal Wielostan 6.1.e2', true);
      changeVis('Horyzontal Wielostan 6.1.f2', true);
      changeVis('Horyzontal Wielostan 6.1.g2', true);
      changeVis('Horyzontal Wielostan 6.1.z', true);
      changeVis(['GROUP', 'Falista Wielostan'], false);
      changeVis(['GROUP', 'Modern Plus Wielostan'], false);
      changeVis(['GROUP', 'Zaluzja Wielostan'], false);
      changeVis(['GROUP', 'Falista 6x6'], false);
      changeVis(['GROUP', 'Modern Plus 6x6'], false);
      changeVis(['GROUP', 'Zaluzja 6x6'], false);
    }
  }
});
eventHTMLElem('click', '5.c', true, function(event) {
  my_61e = 0;
  my_61d = 0;
  my_5_a = 0;
  my_5_b = 0;
  my_5_c = 1;
  my_5_d = 0;
  if (Wiata1 == 1 && _3C == 1) {
    if (isObjectVisible(['GROUP', 'Modern Plus 3x6'])) {
      changeVis(['GROUP', 'Horyzontal 3x6'], false);
      changeVis(['GROUP', 'Falista 3x6'], false);
      changeVis(['GROUP', 'Zaluzja 3x6'], false);
    } else {
      changeVis('Modern Plus 3x6 6.1.a', true);
      changeVis('Modern Plus 3x6 6.1.b', true);
      changeVis('Modern Plus 3x6 6.1.c', true);
      changeVis('Modern Plus 3x6 6.1.d', true);
      changeVis('Modern Plus 3x6 6.1.e', true);
      changeVis('Modern Plus 3x6 6.1.f', true);
      changeVis('Modern Plus 3x6 6.1.g', true);
      changeVis(['GROUP', 'Horyzontal 3x6'], false);
      changeVis(['GROUP', 'Falista 3x6'], false);
      changeVis(['GROUP', 'Zaluzja 3x6'], false);
    }
  } else if (Wiata1 == 1 && _3E == 1) {
    if (isObjectVisible(['GROUP', 'Modern Plus 3x6'])) {
      changeVis(['GROUP', 'Horyzontal 3x6'], false);
      changeVis(['GROUP', 'Falista 3x6'], false);
      changeVis(['GROUP', 'Zaluzja 3x6'], false);
    } else {
      changeVis('Modern Plus 3x6 6.1.a2', true);
      changeVis('Modern Plus 3x6 6.1.b2', true);
      changeVis('Modern Plus 3x6 6.1.c2', true);
      changeVis('Modern Plus 3x6 6.1.d', true);
      changeVis('Modern Plus 3x6 6.1.e2', true);
      changeVis('Modern Plus 3x6 6.1.f2', true);
      changeVis('Modern Plus 3x6 6.1.g2', true);
      changeVis('Modern Plus 3x6 6.1.y', true);
      changeVis('Modern Plus 3x6 6.1.z', true);
      changeVis(['GROUP', 'Horyzontal 3x6'], false);
      changeVis(['GROUP', 'Falista 3x6'], false);
      changeVis(['GROUP', 'Zaluzja 3x6'], false);
    }
  } else if (Wiata2 == 1 && _3C == 1) {
    if (isObjectVisible(['GROUP', 'Modern Plus 6x6'])) {
      changeVis(['GROUP', 'Horyzontal 6x6'], false);
      changeVis(['GROUP', 'Falista 6x6'], false);
      changeVis(['GROUP', 'Zaluzja 6x6'], false);
    } else {
      changeVis('Profil 6x6 tył', true);
      changeVis('Modern Plus 6x6 6.1.a', true);
      changeVis('Modern Plus 6x6 6.1.b', true);
      changeVis('Modern Plus 6x6 6.1.c', true);
      changeVis('Modern Plus 6x6 6.1.d', true);
      changeVis('Modern Plus 6x6 6.1.h', true);
      changeVis('Modern Plus 6x6 6.1.e', true);
      changeVis('Modern Plus 6x6 6.1.f', true);
      changeVis('Modern Plus 6x6 6.1.g', true);
      changeVis(['GROUP', 'Horyzontal 6x6'], false);
      changeVis(['GROUP', 'Falista 6x6'], false);
      changeVis(['GROUP', 'Zaluzja 6x6'], false);
    }
  } else if (Wiata2 == 1 && _3E == 1) {
    if (isObjectVisible(['GROUP', 'Modern Plus 6x6'])) {
      changeVis(['GROUP', 'Horyzontal 6x6'], false);
      changeVis(['GROUP', 'Falista 6x6'], false);
      changeVis(['GROUP', 'Zaluzja 6x6'], false);
    } else {
      changeVis('Profil 6x6 tył', true);
      changeVis('Modern Plus 6x6 6.1.a2', true);
      changeVis('Modern Plus 6x6 6.1.b2', true);
      changeVis('Modern Plus 6x6 6.1.c2', true);
      changeVis('Modern Plus 6x6 6.1.d', true);
      changeVis('Modern Plus 6x6 6.1.h', true);
      changeVis('Modern Plus 6x6 6.1.e2', true);
      changeVis('Modern Plus 6x6 6.1.f2', true);
      changeVis('Modern Plus 6x6 6.1.g2', true);
      changeVis('Modern Plus 6x6 6.1.y', true);
      changeVis('Modern Plus 6x6 6.1.z', true);
      changeVis(['GROUP', 'Horyzontal 6x6'], false);
      changeVis(['GROUP', 'Falista 6x6'], false);
      changeVis(['GROUP', 'Zaluzja 6x6'], false);
    }
  } else if (Wiata3 == 1 && _3C == 1) {
    if (isObjectVisible(['GROUP', 'Modern Plus Wielostan'])) {
      changeVis(['GROUP', 'Falista Wielostan'], false);
      changeVis(['GROUP', 'Horyzontal Wielostan'], false);
      changeVis(['GROUP', 'Zaluzja Wielostan'], false);
      changeVis(['GROUP', 'Falista 6x6'], false);
      changeVis(['GROUP', 'Horyzontal 6x6'], false);
      changeVis(['GROUP', 'Zaluzja 6x6'], false);
    } else {
      changeVis('Modern Plus 6x6 6.1.a', true);
      changeVis('Modern Plus 6x6 6.1.b', true);
      changeVis('Modern Plus 6x6 6.1.c', true);
      changeVis('Modern Plus 6x6 6.1.d', true);
      changeVis('Modern Plus 6x6 6.1.h', true);
      changeVis('Modern Plus Wielostan 6.1.d', true);
      changeVis('Modern Plus Wielostan 6.1.e', true);
      changeVis('Modern Plus Wielostan 6.1.f', true);
      changeVis('Modern Plus Wielostan 6.1.g', true);
      changeVis(['GROUP', 'Falista Wielostan'], false);
      changeVis(['GROUP', 'Horyzontal Wielostan'], false);
      changeVis(['GROUP', 'Zaluzja Wielostan'], false);
      changeVis(['GROUP', 'Falista 6x6'], false);
      changeVis(['GROUP', 'Horyzontal 6x6'], false);
      changeVis(['GROUP', 'Zaluzja 6x6'], false);
    }
  } else if (Wiata3 == 1 && _3E == 1) {
    if (isObjectVisible(['GROUP', 'Modern Plus Wielostan'])) {
      changeVis(['GROUP', 'Falista Wielostan'], false);
      changeVis(['GROUP', 'Horyzontal Wielostan'], false);
      changeVis(['GROUP', 'Zaluzja Wielostan'], false);
      changeVis(['GROUP', 'Falista 6x6'], false);
      changeVis(['GROUP', 'Horyzontal 6x6'], false);
      changeVis(['GROUP', 'Zaluzja 6x6'], false);
    } else {
      changeVis('Modern Plus 6x6 6.1.a2', true);
      changeVis('Modern Plus 6x6 6.1.b2', true);
      changeVis('Modern Plus 6x6 6.1.c2', true);
      changeVis('Modern Plus 6x6 6.1.d', true);
      changeVis('Modern Plus 6x6 6.1.h', true);
      changeVis('Modern Plus 6x6 6.1.y', true);
      changeVis('Modern Plus Wielostan 6.1.d', true);
      changeVis('Modern Plus Wielostan 6.1.e2', true);
      changeVis('Modern Plus Wielostan 6.1.f2', true);
      changeVis('Modern Plus Wielostan 6.1.g2', true);
      changeVis('Modern Plus Wielostan 6.1.z', true);
      changeVis(['GROUP', 'Falista Wielostan'], false);
      changeVis(['GROUP', 'Horyzontal Wielostan'], false);
      changeVis(['GROUP', 'Zaluzja Wielostan'], false);
      changeVis(['GROUP', 'Falista 6x6'], false);
      changeVis(['GROUP', 'Horyzontal 6x6'], false);
      changeVis(['GROUP', 'Zaluzja 6x6'], false);
    }
  }
});
eventHTMLElem('click', '5.d', true, function(event) {
  my_61e = 0;
  my_61d = 0;
  my_5_a = 0;
  my_5_b = 0;
  my_5_c = 0;
  my_5_d = 1;
  if (Wiata1 == 1 && _3C == 1) {
    if (isObjectVisible(['GROUP', 'Zaluzja 3x6'])) {
      changeVis(['GROUP', 'Horyzontal 3x6'], false);
      changeVis(['GROUP', 'Modern Plus 3x6'], false);
      changeVis(['GROUP', 'Falista 3x6'], false);
    } else {
      changeVis('Zaluzja 3x6 6.1.a', true);
      changeVis('Zaluzja 3x6 6.1.b', true);
      changeVis('Zaluzja 3x6 6.1.c', true);
      changeVis('Zaluzja 3x6 6.1.d', true);
      changeVis('Zaluzja 3x6 6.1.e', true);
      changeVis('Zaluzja 3x6 6.1.f', true);
      changeVis('Zaluzja 3x6 6.1.g', true);
      changeVis(['GROUP', 'Horyzontal 3x6'], false);
      changeVis(['GROUP', 'Modern Plus 3x6'], false);
      changeVis(['GROUP', 'Falista 3x6'], false);
    }
  } else if (Wiata1 == 1 && _3E == 1) {
    if (isObjectVisible(['GROUP', 'Zaluzja 3x6'])) {
      changeVis(['GROUP', 'Horyzontal 3x6'], false);
      changeVis(['GROUP', 'Modern Plus 3x6'], false);
      changeVis(['GROUP', 'Falista 3x6'], false);
    } else {
      changeVis('Zaluzja 3x6 6.1.a2', true);
      changeVis('Zaluzja 3x6 6.1.b2', true);
      changeVis('Zaluzja 3x6 6.1.c2', true);
      changeVis('Zaluzja 3x6 6.1.d', true);
      changeVis('Zaluzja 3x6 6.1.e2', true);
      changeVis('Zaluzja 3x6 6.1.f2', true);
      changeVis('Zaluzja 3x6 6.1.g2', true);
      changeVis('Zaluzja 3x6 6.1.y', true);
      changeVis('Zaluzja 3x6 6.1.z', true);
      changeVis(['GROUP', 'Horyzontal 3x6'], false);
      changeVis(['GROUP', 'Modern Plus 3x6'], false);
      changeVis(['GROUP', 'Falista 3x6'], false);
    }
  } else if (Wiata2 == 1 && _3C == 1) {
    if (isObjectVisible(['GROUP', 'Zaluzja 6x6'])) {
      changeVis(['GROUP', 'Horyzontal 6x6'], false);
      changeVis(['GROUP', 'Modern Plus 6x6'], false);
      changeVis(['GROUP', 'Falista 6x6'], false);
    } else {
      changeVis('Profil 6x6 tył', true);
      changeVis('Zaluzja 6x6 6.1.a', true);
      changeVis('Zaluzja 6x6 6.1.b', true);
      changeVis('Zaluzja 6x6 6.1.c', true);
      changeVis('Zaluzja 6x6 6.1.d', true);
      changeVis('Zaluzja 6x6 6.1.h', true);
      changeVis('Zaluzja 6x6 6.1.e', true);
      changeVis('Zaluzja 6x6 6.1.f', true);
      changeVis('Zaluzja 6x6 6.1.g', true);
      changeVis(['GROUP', 'Horyzontal 6x6'], false);
      changeVis(['GROUP', 'Modern Plus 6x6'], false);
      changeVis(['GROUP', 'Falista 6x6'], false);
    }
  } else if (Wiata2 == 1 && _3E == 1) {
    if (isObjectVisible(['GROUP', 'Zaluzja 6x6'])) {
      changeVis(['GROUP', 'Horyzontal 6x6'], false);
      changeVis(['GROUP', 'Modern Plus 6x6'], false);
      changeVis(['GROUP', 'Falista 6x6'], false);
    } else {
      changeVis('Profil 6x6 tył', true);
      changeVis('Zaluzja 6x6 6.1.a2', true);
      changeVis('Zaluzja 6x6 6.1.b2', true);
      changeVis('Zaluzja 6x6 6.1.c2', true);
      changeVis('Zaluzja 6x6 6.1.d', true);
      changeVis('Zaluzja 6x6 6.1.h', true);
      changeVis('Zaluzja 6x6 6.1.e2', true);
      changeVis('Zaluzja 6x6 6.1.f2', true);
      changeVis('Zaluzja 6x6 6.1.g2', true);
      changeVis('Zaluzja 6x6 6.1.y', true);
      changeVis('Zaluzja 6x6 6.1.z', true);
      changeVis(['GROUP', 'Horyzontal 6x6'], false);
      changeVis(['GROUP', 'Modern Plus 6x6'], false);
      changeVis(['GROUP', 'Falista 6x6'], false);
    }
  } else if (Wiata3 == 1 && _3C == 1) {
    if (isObjectVisible(['GROUP', 'Zaluzja Wielostan'])) {
      changeVis(['GROUP', 'Falista Wielostan'], false);
      changeVis(['GROUP', 'Horyzontal Wielostan'], false);
      changeVis(['GROUP', 'Modern Plus Wielostan'], false);
      changeVis(['GROUP', 'Falista 6x6'], false);
      changeVis(['GROUP', 'Horyzontal 6x6'], false);
      changeVis(['GROUP', 'Modern Plus 6x6'], false);
    } else {
      changeVis('Zaluzja 6x6 6.1.a', true);
      changeVis('Zaluzja 6x6 6.1.b', true);
      changeVis('Zaluzja 6x6 6.1.c', true);
      changeVis('Zaluzja 6x6 6.1.d', true);
      changeVis('Zaluzja 6x6 6.1.h', true);
      changeVis('Zaluzja Wielostan 6.1.d', true);
      changeVis('Zaluzja Wielostan 6.1.e', true);
      changeVis('Zaluzja Wielostan 6.1.f', true);
      changeVis('Zaluzja Wielostan 6.1.g', true);
      changeVis(['GROUP', 'Falista Wielostan'], false);
      changeVis(['GROUP', 'Horyzontal Wielostan'], false);
      changeVis(['GROUP', 'Modern Plus Wielostan'], false);
      changeVis(['GROUP', 'Falista 6x6'], false);
      changeVis(['GROUP', 'Horyzontal 6x6'], false);
      changeVis(['GROUP', 'Modern Plus 6x6'], false);
    }
  } else if (Wiata3 == 1 && _3E == 1) {
    if (isObjectVisible(['GROUP', 'Zaluzja Wielostan'])) {
      changeVis(['GROUP', 'Modern Plus Wielostan'], false);
      changeVis(['GROUP', 'Horyzontal Wielostan'], false);
      changeVis(['GROUP', 'Falista Wielostan'], false);
      changeVis(['GROUP', 'Falista 6x6'], false);
      changeVis(['GROUP', 'Horyzontal 6x6'], false);
      changeVis(['GROUP', 'Modern Plus 6x6'], false);
    } else {
      changeVis('Zaluzja 6x6 6.1.a2', true);
      changeVis('Zaluzja 6x6 6.1.b2', true);
      changeVis('Zaluzja 6x6 6.1.c2', true);
      changeVis('Zaluzja 6x6 6.1.d', true);
      changeVis('Zaluzja 6x6 6.1.h', true);
      changeVis('Zaluzja 6x6 6.1.y', true);
      changeVis('Zaluzja Wielostan 6.1.d', true);
      changeVis('Zaluzja Wielostan 6.1.e2', true);
      changeVis('Zaluzja Wielostan 6.1.f2', true);
      changeVis('Zaluzja Wielostan 6.1.g2', true);
      changeVis('Zaluzja Wielostan 6.1.z', true);
      changeVis(['GROUP', 'Falista Wielostan'], false);
      changeVis(['GROUP', 'Horyzontal Wielostan'], false);
      changeVis(['GROUP', 'Modern Plus Wielostan'], false);
      changeVis(['GROUP', 'Falista 6x6'], false);
      changeVis(['GROUP', 'Horyzontal 6x6'], false);
      changeVis(['GROUP', 'Modern Plus 6x6'], false);
    }
  }
});

my_61d = 0;
my_61e = 0;

eventHTMLElem('click', '6.1.a', true, function(event) {
  if (Wiata1 == 1) {
    if (my_5_a == 1 && _3C == 1) {
      if (isObjectVisible('Falista 3x6 6.1.a')) {
        changeVis('Falista 3x6 6.1.a', false);
        changeVis('Falista 3x6 6.1.b2', false);
        changeVis('Falista 3x6 6.1.a2', false);
        changeVis('Horyzontal 3x6 6.1.a', false);
        changeVis('Horyzontal 3x6 6.1.a2', false);
        changeVis('Horyzontal 3x6 6.1.b2', false);
        changeVis('Modern Plus 3x6 6.1.a', false);
        changeVis('Modern Plus 3x6 6.1.a2', false);
        changeVis('Modern Plus 3x6 6.1.b2', false);
        changeVis('Zaluzja 3x6 6.1.a', false);
        changeVis('Zaluzja 3x6 6.1.a2', false);
        changeVis('Zaluzja 3x6 6.1.b2', false);
      } else {
        changeVis('Falista 3x6 6.1.a', true);
      }
    } else if (my_5_a == 1 && _3E == 1) {
      if (isObjectVisible('Falista 3x6 6.1.a2')) {
        changeVis('Falista 3x6 6.1.a', false);
        changeVis('Falista 3x6 6.1.b', false);
        changeVis('Falista 3x6 6.1.a2', false);
        changeVis('Horyzontal 3x6 6.1.a', false);
        changeVis('Horyzontal 3x6 6.1.a2', false);
        changeVis('Horyzontal 3x6 6.1.b', false);
        changeVis('Modern Plus 3x6 6.1.a', false);
        changeVis('Modern Plus 3x6 6.1.a2', false);
        changeVis('Modern Plus 3x6 6.1.b', false);
        changeVis('Zaluzja 3x6 6.1.a', false);
        changeVis('Zaluzja 3x6 6.1.a2', false);
        changeVis('Zaluzja 3x6 6.1.b', false);
      } else {
        changeVis('Falista 3x6 6.1.a2', true);
      }
    }
  } else if (Wiata2 == 1) {
    if (my_5_a == 1 && _3C == 1) {
      if (isObjectVisible('Falista 6x6 6.1.a')) {
        changeVis('Falista 6x6 6.1.a', false);
        changeVis('Falista 6x6 6.1.b2', false);
        changeVis('Falista 6x6 6.1.a2', false);
        changeVis('Horyzontal 6x6 6.1.a', false);
        changeVis('Horyzontal 6x6 6.1.a2', false);
        changeVis('Horyzontal 6x6 6.1.b2', false);
        changeVis('Modern Plus 6x6 6.1.a', false);
        changeVis('Modern Plus 6x6 6.1.a2', false);
        changeVis('Modern Plus 6x6 6.1.b2', false);
        changeVis('Zaluzja 6x6 6.1.a', false);
        changeVis('Zaluzja 6x6 6.1.a2', false);
        changeVis('Zaluzja 6x6 6.1.b2', false);
      } else {
        changeVis('Falista 6x6 6.1.a', true);
      }
    } else if (my_5_a == 1 && _3E == 1) {
      if (isObjectVisible('Falista 6x6 6.1.a2')) {
        changeVis('Falista 6x6 6.1.a', false);
        changeVis('Falista 6x6 6.1.b', false);
        changeVis('Falista 6x6 6.1.a2', false);
        changeVis('Horyzontal 6x6 6.1.a', false);
        changeVis('Horyzontal 6x6 6.1.a2', false);
        changeVis('Horyzontal 6x6 6.1.b', false);
        changeVis('Modern Plus 6x6 6.1.a', false);
        changeVis('Modern Plus 6x6 6.1.a2', false);
        changeVis('Modern Plus 6x6 6.1.b', false);
        changeVis('Zaluzja 6x6 6.1.a', false);
        changeVis('Zaluzja 6x6 6.1.a2', false);
        changeVis('Zaluzja 6x6 6.1.b', false);
      } else {
        changeVis('Falista 6x6 6.1.a2', true);
      }
    }
  } else if (Wiata3 == 1) {
    if (my_5_a == 1 && _3C == 1) {
      if (isObjectVisible('Falista 6x6 6.1.a')) {
        changeVis('Falista 6x6 6.1.a', false);
        changeVis('Falista 6x6 6.1.b2', false);
        changeVis('Falista 6x6 6.1.a2', false);
        changeVis('Horyzontal 6x6 6.1.a', false);
        changeVis('Horyzontal 6x6 6.1.a2', false);
        changeVis('Horyzontal 6x6 6.1.b2', false);
        changeVis('Modern Plus 6x6 6.1.a', false);
        changeVis('Modern Plus 6x6 6.1.a2', false);
        changeVis('Modern Plus 6x6 6.1.b2', false);
        changeVis('Zaluzja 6x6 6.1.a', false);
        changeVis('Zaluzja 6x6 6.1.a2', false);
        changeVis('Zaluzja 6x6 6.1.b2', false);
      } else {
        changeVis('Falista 6x6 6.1.a', true);
      }
    } else if (my_5_a == 1 && _3E == 1) {
      if (isObjectVisible('Falista 6x6 6.1.a2')) {
        changeVis('Falista 6x6 6.1.a', false);
        changeVis('Falista 6x6 6.1.b', false);
        changeVis('Falista 6x6 6.1.a2', false);
        changeVis('Horyzontal 6x6 6.1.a', false);
        changeVis('Horyzontal 6x6 6.1.a2', false);
        changeVis('Horyzontal 6x6 6.1.b', false);
        changeVis('Modern Plus 6x6 6.1.a', false);
        changeVis('Modern Plus 6x6 6.1.a2', false);
        changeVis('Modern Plus 6x6 6.1.b', false);
        changeVis('Zaluzja 6x6 6.1.a', false);
        changeVis('Zaluzja 6x6 6.1.a2', false);
        changeVis('Zaluzja 6x6 6.1.b', false);
      } else {
        changeVis('Falista 6x6 6.1.a2', true);
      }
    }
  }
});
eventHTMLElem('click', '6.1.a', true, function(event) {
  if (Wiata1 == 1) {
    if (my_5_b == 1 && _3C == 1) {
      if (isObjectVisible('Horyzontal 3x6 6.1.a')) {
        changeVis('Falista 3x6 6.1.a', false);
        changeVis('Falista 3x6 6.1.b2', false);
        changeVis('Falista 3x6 6.1.a2', false);
        changeVis('Horyzontal 3x6 6.1.a', false);
        changeVis('Horyzontal 3x6 6.1.a2', false);
        changeVis('Horyzontal 3x6 6.1.b2', false);
        changeVis('Modern Plus 3x6 6.1.a', false);
        changeVis('Modern Plus 3x6 6.1.a2', false);
        changeVis('Modern Plus 3x6 6.1.b2', false);
        changeVis('Zaluzja 3x6 6.1.a', false);
        changeVis('Zaluzja 3x6 6.1.a2', false);
        changeVis('Zaluzja 3x6 6.1.b2', false);
      } else {
        changeVis('Horyzontal 3x6 6.1.a', true);
      }
    } else if (my_5_b == 1 && _3E == 1) {
      if (isObjectVisible('Horyzontal 3x6 6.1.a2')) {
        changeVis('Falista 3x6 6.1.a', false);
        changeVis('Falista 3x6 6.1.b', false);
        changeVis('Falista 3x6 6.1.a2', false);
        changeVis('Horyzontal 3x6 6.1.a', false);
        changeVis('Horyzontal 3x6 6.1.a2', false);
        changeVis('Horyzontal 3x6 6.1.b', false);
        changeVis('Modern Plus 3x6 6.1.a', false);
        changeVis('Modern Plus 3x6 6.1.a2', false);
        changeVis('Modern Plus 3x6 6.1.b', false);
        changeVis('Zaluzja 3x6 6.1.a', false);
        changeVis('Zaluzja 3x6 6.1.a2', false);
        changeVis('Zaluzja 3x6 6.1.b', false);
      } else {
        changeVis('Horyzontal 3x6 6.1.a2', true);
      }
    }
  } else if (Wiata2 == 1) {
    if (my_5_b == 1 && _3C == 1) {
      if (isObjectVisible('Horyzontal 6x6 6.1.a')) {
        changeVis('Falista 6x6 6.1.a', false);
        changeVis('Falista 6x6 6.1.b2', false);
        changeVis('Falista 6x6 6.1.a2', false);
        changeVis('Horyzontal 6x6 6.1.a', false);
        changeVis('Horyzontal 6x6 6.1.a2', false);
        changeVis('Horyzontal 6x6 6.1.b2', false);
        changeVis('Modern Plus 6x6 6.1.a', false);
        changeVis('Modern Plus 6x6 6.1.a2', false);
        changeVis('Modern Plus 6x6 6.1.b2', false);
        changeVis('Zaluzja 6x6 6.1.a', false);
        changeVis('Zaluzja 6x6 6.1.a2', false);
        changeVis('Zaluzja 6x6 6.1.b2', false);
      } else {
        changeVis('Horyzontal 6x6 6.1.a', true);
      }
    } else if (my_5_b == 1 && _3E == 1) {
      if (isObjectVisible('Horyzontal 6x6 6.1.a2')) {
        changeVis('Falista 6x6 6.1.a', false);
        changeVis('Falista 6x6 6.1.b', false);
        changeVis('Falista 6x6 6.1.a2', false);
        changeVis('Horyzontal 6x6 6.1.a', false);
        changeVis('Horyzontal 6x6 6.1.a2', false);
        changeVis('Horyzontal 6x6 6.1.b', false);
        changeVis('Modern Plus 6x6 6.1.a', false);
        changeVis('Modern Plus 6x6 6.1.a2', false);
        changeVis('Modern Plus 6x6 6.1.b', false);
        changeVis('Zaluzja 6x6 6.1.a', false);
        changeVis('Zaluzja 6x6 6.1.a2', false);
        changeVis('Zaluzja 6x6 6.1.b', false);
      } else {
        changeVis('Horyzontal 6x6 6.1.a2', true);
      }
    }
  } else if (Wiata3 == 1) {
    if (my_5_b == 1 && _3C == 1) {
      if (isObjectVisible('Horyzontal 6x6 6.1.a')) {
        changeVis('Falista 6x6 6.1.a', false);
        changeVis('Falista 6x6 6.1.b2', false);
        changeVis('Falista 6x6 6.1.a2', false);
        changeVis('Horyzontal 6x6 6.1.a', false);
        changeVis('Horyzontal 6x6 6.1.a2', false);
        changeVis('Horyzontal 6x6 6.1.b2', false);
        changeVis('Modern Plus 6x6 6.1.a', false);
        changeVis('Modern Plus 6x6 6.1.a2', false);
        changeVis('Modern Plus 6x6 6.1.b2', false);
        changeVis('Zaluzja 6x6 6.1.a', false);
        changeVis('Zaluzja 6x6 6.1.a2', false);
        changeVis('Zaluzja 6x6 6.1.b2', false);
      } else {
        changeVis('Horyzontal 6x6 6.1.a', true);
      }
    } else if (my_5_b == 1 && _3E == 1) {
      if (isObjectVisible('Horyzontal 6x6 6.1.a2')) {
        changeVis('Falista 6x6 6.1.a', false);
        changeVis('Falista 6x6 6.1.b', false);
        changeVis('Falista 6x6 6.1.a2', false);
        changeVis('Horyzontal 6x6 6.1.a', false);
        changeVis('Horyzontal 6x6 6.1.a2', false);
        changeVis('Horyzontal 6x6 6.1.b', false);
        changeVis('Modern Plus 6x6 6.1.a', false);
        changeVis('Modern Plus 6x6 6.1.a2', false);
        changeVis('Modern Plus 6x6 6.1.b', false);
        changeVis('Zaluzja 6x6 6.1.a', false);
        changeVis('Zaluzja 6x6 6.1.a2', false);
        changeVis('Zaluzja 6x6 6.1.b', false);
      } else {
        changeVis('Horyzontal 6x6 6.1.a2', true);
      }
    }
  }
});
eventHTMLElem('click', '6.1.a', true, function(event) {
  if (Wiata1 == 1) {
    if (my_5_c == 1 && _3C == 1) {
      if (isObjectVisible('Modern Plus 3x6 6.1.a')) {
        changeVis('Falista 3x6 6.1.a', false);
        changeVis('Falista 3x6 6.1.b2', false);
        changeVis('Falista 3x6 6.1.a2', false);
        changeVis('Horyzontal 3x6 6.1.a', false);
        changeVis('Horyzontal 3x6 6.1.a2', false);
        changeVis('Horyzontal 3x6 6.1.b2', false);
        changeVis('Modern Plus 3x6 6.1.a', false);
        changeVis('Modern Plus 3x6 6.1.a2', false);
        changeVis('Modern Plus 3x6 6.1.b2', false);
        changeVis('Zaluzja 3x6 6.1.a', false);
        changeVis('Zaluzja 3x6 6.1.a2', false);
        changeVis('Zaluzja 3x6 6.1.b2', false);
      } else {
        changeVis('Modern Plus 3x6 6.1.a', true);
      }
    } else if (my_5_c == 1 && _3E == 1) {
      if (isObjectVisible('Modern Plus 3x6 6.1.a2')) {
        changeVis('Falista 3x6 6.1.a', false);
        changeVis('Falista 3x6 6.1.b', false);
        changeVis('Falista 3x6 6.1.a2', false);
        changeVis('Horyzontal 3x6 6.1.a', false);
        changeVis('Horyzontal 3x6 6.1.a2', false);
        changeVis('Horyzontal 3x6 6.1.b', false);
        changeVis('Modern Plus 3x6 6.1.a', false);
        changeVis('Modern Plus 3x6 6.1.a2', false);
        changeVis('Modern Plus 3x6 6.1.b', false);
        changeVis('Zaluzja 3x6 6.1.a', false);
        changeVis('Zaluzja 3x6 6.1.a2', false);
        changeVis('Zaluzja 3x6 6.1.b', false);
      } else {
        changeVis('Modern Plus 3x6 6.1.a2', true);
      }
    }
  } else if (Wiata2 == 1) {
    if (my_5_c == 1 && _3C == 1) {
      if (isObjectVisible('Modern Plus 6x6 6.1.a')) {
        changeVis('Falista 6x6 6.1.a', false);
        changeVis('Falista 6x6 6.1.b2', false);
        changeVis('Falista 6x6 6.1.a2', false);
        changeVis('Horyzontal 6x6 6.1.a', false);
        changeVis('Horyzontal 6x6 6.1.a2', false);
        changeVis('Horyzontal 6x6 6.1.b2', false);
        changeVis('Modern Plus 6x6 6.1.a', false);
        changeVis('Modern Plus 6x6 6.1.a2', false);
        changeVis('Modern Plus 6x6 6.1.b2', false);
        changeVis('Zaluzja 6x6 6.1.a', false);
        changeVis('Zaluzja 6x6 6.1.a2', false);
        changeVis('Zaluzja 6x6 6.1.b2', false);
      } else {
        changeVis('Modern Plus 6x6 6.1.a', true);
      }
    } else if (my_5_c == 1 && _3E == 1) {
      if (isObjectVisible('Modern Plus 6x6 6.1.a2')) {
        changeVis('Falista 6x6 6.1.a', false);
        changeVis('Falista 6x6 6.1.b', false);
        changeVis('Falista 6x6 6.1.a2', false);
        changeVis('Horyzontal 6x6 6.1.a', false);
        changeVis('Horyzontal 6x6 6.1.a2', false);
        changeVis('Horyzontal 6x6 6.1.b', false);
        changeVis('Modern Plus 6x6 6.1.a', false);
        changeVis('Modern Plus 6x6 6.1.a2', false);
        changeVis('Modern Plus 6x6 6.1.b', false);
        changeVis('Zaluzja 6x6 6.1.a', false);
        changeVis('Zaluzja 6x6 6.1.a2', false);
        changeVis('Zaluzja 6x6 6.1.b', false);
      } else {
        changeVis('Modern Plus 6x6 6.1.a2', true);
      }
    }
  } else if (Wiata3 == 1) {
    if (my_5_c == 1 && _3C == 1) {
      if (isObjectVisible('Modern Plus 6x6 6.1.a')) {
        changeVis('Falista 6x6 6.1.a', false);
        changeVis('Falista 6x6 6.1.b2', false);
        changeVis('Falista 6x6 6.1.a2', false);
        changeVis('Horyzontal 6x6 6.1.a', false);
        changeVis('Horyzontal 6x6 6.1.a2', false);
        changeVis('Horyzontal 6x6 6.1.b2', false);
        changeVis('Modern Plus 6x6 6.1.a', false);
        changeVis('Modern Plus 6x6 6.1.a2', false);
        changeVis('Modern Plus 6x6 6.1.b2', false);
        changeVis('Zaluzja 6x6 6.1.a', false);
        changeVis('Zaluzja 6x6 6.1.a2', false);
        changeVis('Zaluzja 6x6 6.1.b2', false);
      } else {
        changeVis('Modern Plus 6x6 6.1.a', true);
      }
    } else if (my_5_c == 1 && _3E == 1) {
      if (isObjectVisible('Modern Plus 6x6 6.1.a2')) {
        changeVis('Falista 6x6 6.1.a', false);
        changeVis('Falista 6x6 6.1.b', false);
        changeVis('Falista 6x6 6.1.a2', false);
        changeVis('Horyzontal 6x6 6.1.a', false);
        changeVis('Horyzontal 6x6 6.1.a2', false);
        changeVis('Horyzontal 6x6 6.1.b', false);
        changeVis('Modern Plus 6x6 6.1.a', false);
        changeVis('Modern Plus 6x6 6.1.a2', false);
        changeVis('Modern Plus 6x6 6.1.b', false);
        changeVis('Zaluzja 6x6 6.1.a', false);
        changeVis('Zaluzja 6x6 6.1.a2', false);
        changeVis('Zaluzja 6x6 6.1.b', false);
      } else {
        changeVis('Modern Plus 6x6 6.1.a2', true);
      }
    }
  }
});
eventHTMLElem('click', '6.1.a', true, function(event) {
  if (Wiata1 == 1) {
    if (my_5_d == 1 && _3C == 1) {
      if (isObjectVisible('Zaluzja 3x6 6.1.a')) {
        changeVis('Falista 3x6 6.1.a', false);
        changeVis('Falista 3x6 6.1.b2', false);
        changeVis('Falista 3x6 6.1.a2', false);
        changeVis('Horyzontal 3x6 6.1.a', false);
        changeVis('Horyzontal 3x6 6.1.a2', false);
        changeVis('Horyzontal 3x6 6.1.b2', false);
        changeVis('Modern Plus 3x6 6.1.a', false);
        changeVis('Modern Plus 3x6 6.1.a2', false);
        changeVis('Modern Plus 3x6 6.1.b2', false);
        changeVis('Zaluzja 3x6 6.1.a', false);
        changeVis('Zaluzja 3x6 6.1.a2', false);
        changeVis('Zaluzja 3x6 6.1.b2', false);
      } else {
        changeVis('Zaluzja 3x6 6.1.a', true);
      }
    } else if (my_5_d == 1 && _3E == 1) {
      if (isObjectVisible('Zaluzja 3x6 6.1.a2')) {
        changeVis('Falista 3x6 6.1.a', false);
        changeVis('Falista 3x6 6.1.b', false);
        changeVis('Falista 3x6 6.1.a2', false);
        changeVis('Horyzontal 3x6 6.1.a', false);
        changeVis('Horyzontal 3x6 6.1.a2', false);
        changeVis('Horyzontal 3x6 6.1.b', false);
        changeVis('Modern Plus 3x6 6.1.a', false);
        changeVis('Modern Plus 3x6 6.1.a2', false);
        changeVis('Modern Plus 3x6 6.1.b', false);
        changeVis('Zaluzja 3x6 6.1.a', false);
        changeVis('Zaluzja 3x6 6.1.a2', false);
        changeVis('Zaluzja 3x6 6.1.b', false);
      } else {
        changeVis('Zaluzja 3x6 6.1.a2', true);
      }
    }
  } else if (Wiata2 == 1) {
    if (my_5_d == 1 && _3C == 1) {
      if (isObjectVisible('Zaluzja 6x6 6.1.a')) {
        changeVis('Falista 6x6 6.1.a', false);
        changeVis('Falista 6x6 6.1.b2', false);
        changeVis('Falista 6x6 6.1.a2', false);
        changeVis('Horyzontal 6x6 6.1.a', false);
        changeVis('Horyzontal 6x6 6.1.a2', false);
        changeVis('Horyzontal 6x6 6.1.b2', false);
        changeVis('Modern Plus 6x6 6.1.a', false);
        changeVis('Modern Plus 6x6 6.1.a2', false);
        changeVis('Modern Plus 6x6 6.1.b2', false);
        changeVis('Zaluzja 6x6 6.1.a', false);
        changeVis('Zaluzja 6x6 6.1.a2', false);
        changeVis('Zaluzja 6x6 6.1.b2', false);
      } else {
        changeVis('Zaluzja 6x6 6.1.a', true);
      }
    } else if (my_5_d == 1 && _3E == 1) {
      if (isObjectVisible('Zaluzja 6x6 6.1.a2')) {
        changeVis('Falista 6x6 6.1.a', false);
        changeVis('Falista 6x6 6.1.b', false);
        changeVis('Falista 6x6 6.1.a2', false);
        changeVis('Horyzontal 6x6 6.1.a', false);
        changeVis('Horyzontal 6x6 6.1.a2', false);
        changeVis('Horyzontal 6x6 6.1.b', false);
        changeVis('Modern Plus 6x6 6.1.a', false);
        changeVis('Modern Plus 6x6 6.1.a2', false);
        changeVis('Modern Plus 6x6 6.1.b', false);
        changeVis('Zaluzja 6x6 6.1.a', false);
        changeVis('Zaluzja 6x6 6.1.a2', false);
        changeVis('Zaluzja 6x6 6.1.b', false);
      } else {
        changeVis('Zaluzja 6x6 6.1.a2', true);
      }
    }
  } else if (Wiata3 == 1) {
    if (my_5_d == 1 && _3C == 1) {
      if (isObjectVisible('Zaluzja 6x6 6.1.a')) {
        changeVis('Falista 6x6 6.1.a', false);
        changeVis('Falista 6x6 6.1.b2', false);
        changeVis('Falista 6x6 6.1.a2', false);
        changeVis('Horyzontal 6x6 6.1.a', false);
        changeVis('Horyzontal 6x6 6.1.a2', false);
        changeVis('Horyzontal 6x6 6.1.b2', false);
        changeVis('Modern Plus 6x6 6.1.a', false);
        changeVis('Modern Plus 6x6 6.1.a2', false);
        changeVis('Modern Plus 6x6 6.1.b2', false);
        changeVis('Zaluzja 6x6 6.1.a', false);
        changeVis('Zaluzja 6x6 6.1.a2', false);
        changeVis('Zaluzja 6x6 6.1.b2', false);
      } else {
        changeVis('Zaluzja 6x6 6.1.a', true);
      }
    } else if (my_5_d == 1 && _3E == 1) {
      if (isObjectVisible('Zaluzja 6x6 6.1.a2')) {
        changeVis('Falista 6x6 6.1.a', false);
        changeVis('Falista 6x6 6.1.b', false);
        changeVis('Falista 6x6 6.1.a2', false);
        changeVis('Horyzontal 6x6 6.1.a', false);
        changeVis('Horyzontal 6x6 6.1.a2', false);
        changeVis('Horyzontal 6x6 6.1.b', false);
        changeVis('Modern Plus 6x6 6.1.a', false);
        changeVis('Modern Plus 6x6 6.1.a2', false);
        changeVis('Modern Plus 6x6 6.1.b', false);
        changeVis('Zaluzja 6x6 6.1.a', false);
        changeVis('Zaluzja 6x6 6.1.a2', false);
        changeVis('Zaluzja 6x6 6.1.b', false);
      } else {
        changeVis('Zaluzja 6x6 6.1.a2', true);
      }
    }
  }
});

eventHTMLElem('click', '6.1.b', true, function(event) {
  if (Wiata1 == 1) {
    if (my_5_a == 1 && _3C == 1) {
      if (isObjectVisible('Falista 3x6 6.1.b')) {
        changeVis('Falista 3x6 6.1.b', false);
        changeVis('Falista 3x6 6.1.b2', false);
        changeVis('Falista 3x6 6.1.y', false);
        changeVis('Horyzontal 3x6 6.1.b', false);
        changeVis('Horyzontal 3x6 6.1.y', false);
        changeVis('Horyzontal 3x6 6.1.b2', false);
        changeVis('Modern Plus 3x6 6.1.b', false);
        changeVis('Modern Plus 3x6 6.1.y', false);
        changeVis('Modern Plus 3x6 6.1.b2', false);
        changeVis('Zaluzja 3x6 6.1.b', false);
        changeVis('Zaluzja 3x6 6.1.y', false);
        changeVis('Zaluzja 3x6 6.1.b2', false);
      } else {
        changeVis('Falista 3x6 6.1.b', true);
      }
    } else if (my_5_a == 1 && _3E == 1) {
      if (isObjectVisible('Falista 3x6 6.1.b2')) {
        changeVis('Falista 3x6 6.1.b', false);
        changeVis('Falista 3x6 6.1.b2', false);
        changeVis('Falista 3x6 6.1.c', false);
        changeVis('Horyzontal 3x6 6.1.b', false);
        changeVis('Horyzontal 3x6 6.1.c', false);
        changeVis('Horyzontal 3x6 6.1.b2', false);
        changeVis('Modern Plus 3x6 6.1.b', false);
        changeVis('Modern Plus 3x6 6.1.c', false);
        changeVis('Modern Plus 3x6 6.1.b2', false);
        changeVis('Zaluzja 3x6 6.1.b', false);
        changeVis('Zaluzja 3x6 6.1.c', false);
        changeVis('Zaluzja 3x6 6.1.b2', false);
      } else {
        changeVis('Falista 3x6 6.1.b2', true);
      }
    }
  } else if (Wiata2 == 1) {
    if (my_5_a == 1 && _3C == 1) {
      if (isObjectVisible('Falista 6x6 6.1.b')) {
        changeVis('Falista 6x6 6.1.b', false);
        changeVis('Falista 6x6 6.1.b2', false);
        changeVis('Falista 6x6 6.1.y', false);
        changeVis('Horyzontal 6x6 6.1.b', false);
        changeVis('Horyzontal 6x6 6.1.y', false);
        changeVis('Horyzontal 6x6 6.1.b2', false);
        changeVis('Modern Plus 6x6 6.1.b', false);
        changeVis('Modern Plus 6x6 6.1.y', false);
        changeVis('Modern Plus 6x6 6.1.b2', false);
        changeVis('Zaluzja 6x6 6.1.b', false);
        changeVis('Zaluzja 6x6 6.1.y', false);
        changeVis('Zaluzja 6x6 6.1.b2', false);
      } else {
        changeVis('Falista 6x6 6.1.b', true);
      }
    } else if (my_5_a == 1 && _3E == 1) {
      if (isObjectVisible('Falista 6x6 6.1.b2')) {
        changeVis('Falista 6x6 6.1.b', false);
        changeVis('Falista 6x6 6.1.b2', false);
        changeVis('Falista 6x6 6.1.c', false);
        changeVis('Horyzontal 6x6 6.1.b', false);
        changeVis('Horyzontal 6x6 6.1.c', false);
        changeVis('Horyzontal 6x6 6.1.b2', false);
        changeVis('Modern Plus 6x6 6.1.b', false);
        changeVis('Modern Plus 6x6 6.1.c', false);
        changeVis('Modern Plus 6x6 6.1.b2', false);
        changeVis('Zaluzja 6x6 6.1.b', false);
        changeVis('Zaluzja 6x6 6.1.c', false);
        changeVis('Zaluzja 6x6 6.1.b2', false);
      } else {
        changeVis('Falista 6x6 6.1.b2', true);
      }
    }
  } else if (Wiata3 == 1) {
    if (my_5_a == 1 && _3C == 1) {
      if (isObjectVisible('Falista 6x6 6.1.b')) {
        changeVis('Falista 6x6 6.1.b', false);
        changeVis('Falista 6x6 6.1.b2', false);
        changeVis('Falista 6x6 6.1.y', false);
        changeVis('Horyzontal 6x6 6.1.b', false);
        changeVis('Horyzontal 6x6 6.1.y', false);
        changeVis('Horyzontal 6x6 6.1.b2', false);
        changeVis('Modern Plus 6x6 6.1.b', false);
        changeVis('Modern Plus 6x6 6.1.y', false);
        changeVis('Modern Plus 6x6 6.1.b2', false);
        changeVis('Zaluzja 6x6 6.1.b', false);
        changeVis('Zaluzja 6x6 6.1.y', false);
        changeVis('Zaluzja 6x6 6.1.b2', false);
      } else {
        changeVis('Falista 6x6 6.1.b', true);
      }
    } else if (my_5_a == 1 && _3E == 1) {
      if (isObjectVisible('Falista 6x6 6.1.b2')) {
        changeVis('Falista 6x6 6.1.b', false);
        changeVis('Falista 6x6 6.1.b2', false);
        changeVis('Falista 6x6 6.1.c', false);
        changeVis('Horyzontal 6x6 6.1.b', false);
        changeVis('Horyzontal 6x6 6.1.c', false);
        changeVis('Horyzontal 6x6 6.1.b2', false);
        changeVis('Modern Plus 6x6 6.1.b', false);
        changeVis('Modern Plus 6x6 6.1.c', false);
        changeVis('Modern Plus 6x6 6.1.b2', false);
        changeVis('Zaluzja 6x6 6.1.b', false);
        changeVis('Zaluzja 6x6 6.1.c', false);
        changeVis('Zaluzja 6x6 6.1.b2', false);
      } else {
        changeVis('Falista 6x6 6.1.b2', true);
      }
    }
  }
});
eventHTMLElem('click', '6.1.b', true, function(event) {
  if (Wiata1 == 1) {
    if (my_5_b == 1 && _3C == 1) {
      if (isObjectVisible('Horyzontal 3x6 6.1.b')) {
        changeVis('Falista 3x6 6.1.b', false);
        changeVis('Falista 3x6 6.1.b2', false);
        changeVis('Falista 3x6 6.1.y', false);
        changeVis('Horyzontal 3x6 6.1.b', false);
        changeVis('Horyzontal 3x6 6.1.y', false);
        changeVis('Horyzontal 3x6 6.1.b2', false);
        changeVis('Modern Plus 3x6 6.1.b', false);
        changeVis('Modern Plus 3x6 6.1.y', false);
        changeVis('Modern Plus 3x6 6.1.b2', false);
        changeVis('Zaluzja 3x6 6.1.b', false);
        changeVis('Zaluzja 3x6 6.1.y', false);
        changeVis('Zaluzja 3x6 6.1.b2', false);
      } else {
        changeVis('Horyzontal 3x6 6.1.b', true);
      }
    } else if (my_5_b == 1 && _3E == 1) {
      if (isObjectVisible('Horyzontal 3x6 6.1.b2')) {
        changeVis('Falista 3x6 6.1.b', false);
        changeVis('Falista 3x6 6.1.b2', false);
        changeVis('Falista 3x6 6.1.c', false);
        changeVis('Horyzontal 3x6 6.1.b', false);
        changeVis('Horyzontal 3x6 6.1.c', false);
        changeVis('Horyzontal 3x6 6.1.b2', false);
        changeVis('Modern Plus 3x6 6.1.b', false);
        changeVis('Modern Plus 3x6 6.1.c', false);
        changeVis('Modern Plus 3x6 6.1.b2', false);
        changeVis('Zaluzja 3x6 6.1.b', false);
        changeVis('Zaluzja 3x6 6.1.c', false);
        changeVis('Zaluzja 3x6 6.1.b2', false);
      } else {
        changeVis('Horyzontal 3x6 6.1.b2', true);
      }
    }
  } else if (Wiata2 == 1) {
    if (my_5_b == 1 && _3C == 1) {
      if (isObjectVisible('Horyzontal 6x6 6.1.b')) {
        changeVis('Falista 6x6 6.1.b', false);
        changeVis('Falista 6x6 6.1.b2', false);
        changeVis('Falista 6x6 6.1.y', false);
        changeVis('Horyzontal 6x6 6.1.b', false);
        changeVis('Horyzontal 6x6 6.1.y', false);
        changeVis('Horyzontal 6x6 6.1.b2', false);
        changeVis('Modern Plus 6x6 6.1.b', false);
        changeVis('Modern Plus 6x6 6.1.y', false);
        changeVis('Modern Plus 6x6 6.1.b2', false);
        changeVis('Zaluzja 6x6 6.1.b', false);
        changeVis('Zaluzja 6x6 6.1.y', false);
        changeVis('Zaluzja 6x6 6.1.b2', false);
      } else {
        changeVis('Horyzontal 6x6 6.1.b', true);
      }
    } else if (my_5_b == 1 && _3E == 1) {
      if (isObjectVisible('Horyzontal 6x6 6.1.b2')) {
        changeVis('Falista 6x6 6.1.b', false);
        changeVis('Falista 6x6 6.1.b2', false);
        changeVis('Falista 6x6 6.1.c', false);
        changeVis('Horyzontal 6x6 6.1.b', false);
        changeVis('Horyzontal 6x6 6.1.c', false);
        changeVis('Horyzontal 6x6 6.1.b2', false);
        changeVis('Modern Plus 6x6 6.1.b', false);
        changeVis('Modern Plus 6x6 6.1.c', false);
        changeVis('Modern Plus 6x6 6.1.b2', false);
        changeVis('Zaluzja 6x6 6.1.b', false);
        changeVis('Zaluzja 6x6 6.1.c', false);
        changeVis('Zaluzja 6x6 6.1.b2', false);
      } else {
        changeVis('Horyzontal 6x6 6.1.b2', true);
      }
    }
  } else if (Wiata3 == 1) {
    if (my_5_b == 1 && _3C == 1) {
      if (isObjectVisible('Horyzontal 6x6 6.1.b')) {
        changeVis('Falista 6x6 6.1.b', false);
        changeVis('Falista 6x6 6.1.b2', false);
        changeVis('Falista 6x6 6.1.y', false);
        changeVis('Horyzontal 6x6 6.1.b', false);
        changeVis('Horyzontal 6x6 6.1.y', false);
        changeVis('Horyzontal 6x6 6.1.b2', false);
        changeVis('Modern Plus 6x6 6.1.b', false);
        changeVis('Modern Plus 6x6 6.1.y', false);
        changeVis('Modern Plus 6x6 6.1.b2', false);
        changeVis('Zaluzja 6x6 6.1.b', false);
        changeVis('Zaluzja 6x6 6.1.y', false);
        changeVis('Zaluzja 6x6 6.1.b2', false);
      } else {
        changeVis('Horyzontal 6x6 6.1.b', true);
      }
    } else if (my_5_b == 1 && _3E == 1) {
      if (isObjectVisible('Horyzontal 6x6 6.1.b2')) {
        changeVis('Falista 6x6 6.1.b', false);
        changeVis('Falista 6x6 6.1.b2', false);
        changeVis('Falista 6x6 6.1.c', false);
        changeVis('Horyzontal 6x6 6.1.b', false);
        changeVis('Horyzontal 6x6 6.1.c', false);
        changeVis('Horyzontal 6x6 6.1.b2', false);
        changeVis('Modern Plus 6x6 6.1.b', false);
        changeVis('Modern Plus 6x6 6.1.c', false);
        changeVis('Modern Plus 6x6 6.1.b2', false);
        changeVis('Zaluzja 6x6 6.1.b', false);
        changeVis('Zaluzja 6x6 6.1.c', false);
        changeVis('Zaluzja 6x6 6.1.b2', false);
      } else {
        changeVis('Horyzontal 6x6 6.1.b2', true);
      }
    }
  }
});
eventHTMLElem('click', '6.1.b', true, function(event) {
  if (Wiata1 == 1) {
    if (my_5_c == 1 && _3C == 1) {
      if (isObjectVisible('Modern Plus 3x6 6.1.b')) {
        changeVis('Falista 3x6 6.1.b', false);
        changeVis('Falista 3x6 6.1.b2', false);
        changeVis('Falista 3x6 6.1.y', false);
        changeVis('Horyzontal 3x6 6.1.b', false);
        changeVis('Horyzontal 3x6 6.1.y', false);
        changeVis('Horyzontal 3x6 6.1.b2', false);
        changeVis('Modern Plus 3x6 6.1.b', false);
        changeVis('Modern Plus 3x6 6.1.y', false);
        changeVis('Modern Plus 3x6 6.1.b2', false);
        changeVis('Zaluzja 3x6 6.1.b', false);
        changeVis('Zaluzja 3x6 6.1.y', false);
        changeVis('Zaluzja 3x6 6.1.b2', false);
      } else {
        changeVis('Modern Plus 3x6 6.1.b', true);
      }
    } else if (my_5_c == 1 && _3E == 1) {
      if (isObjectVisible('Modern Plus 3x6 6.1.b2')) {
        changeVis('Falista 3x6 6.1.b', false);
        changeVis('Falista 3x6 6.1.b2', false);
        changeVis('Falista 3x6 6.1.c', false);
        changeVis('Horyzontal 3x6 6.1.b', false);
        changeVis('Horyzontal 3x6 6.1.c', false);
        changeVis('Horyzontal 3x6 6.1.b2', false);
        changeVis('Modern Plus 3x6 6.1.b', false);
        changeVis('Modern Plus 3x6 6.1.c', false);
        changeVis('Modern Plus 3x6 6.1.b2', false);
        changeVis('Zaluzja 3x6 6.1.b', false);
        changeVis('Zaluzja 3x6 6.1.c', false);
        changeVis('Zaluzja 3x6 6.1.b2', false);
      } else {
        changeVis('Modern Plus 3x6 6.1.b2', true);
      }
    }
  } else if (Wiata2 == 1) {
    if (my_5_c == 1 && _3C == 1) {
      if (isObjectVisible('Modern Plus 6x6 6.1.b')) {
        changeVis('Falista 6x6 6.1.b', false);
        changeVis('Falista 6x6 6.1.b2', false);
        changeVis('Falista 6x6 6.1.y', false);
        changeVis('Horyzontal 6x6 6.1.b', false);
        changeVis('Horyzontal 6x6 6.1.y', false);
        changeVis('Horyzontal 6x6 6.1.b2', false);
        changeVis('Modern Plus 6x6 6.1.b', false);
        changeVis('Modern Plus 6x6 6.1.y', false);
        changeVis('Modern Plus 6x6 6.1.b2', false);
        changeVis('Zaluzja 6x6 6.1.b', false);
        changeVis('Zaluzja 6x6 6.1.y', false);
        changeVis('Zaluzja 6x6 6.1.b2', false);
      } else {
        changeVis('Modern Plus 6x6 6.1.b', true);
      }
    } else if (my_5_c == 1 && _3E == 1) {
      if (isObjectVisible('Modern Plus 6x6 6.1.b2')) {
        changeVis('Falista 6x6 6.1.b', false);
        changeVis('Falista 6x6 6.1.b2', false);
        changeVis('Falista 6x6 6.1.c', false);
        changeVis('Horyzontal 6x6 6.1.b', false);
        changeVis('Horyzontal 6x6 6.1.c', false);
        changeVis('Horyzontal 6x6 6.1.b2', false);
        changeVis('Modern Plus 6x6 6.1.b', false);
        changeVis('Modern Plus 6x6 6.1.c', false);
        changeVis('Modern Plus 6x6 6.1.b2', false);
        changeVis('Zaluzja 6x6 6.1.b', false);
        changeVis('Zaluzja 6x6 6.1.c', false);
        changeVis('Zaluzja 6x6 6.1.b2', false);
      } else {
        changeVis('Modern Plus 6x6 6.1.b2', true);
      }
    }
  } else if (Wiata3 == 1) {
    if (my_5_c == 1 && _3C == 1) {
      if (isObjectVisible('Modern Plus 6x6 6.1.b')) {
        changeVis('Falista 6x6 6.1.b', false);
        changeVis('Falista 6x6 6.1.b2', false);
        changeVis('Falista 6x6 6.1.y', false);
        changeVis('Horyzontal 6x6 6.1.b', false);
        changeVis('Horyzontal 6x6 6.1.y', false);
        changeVis('Horyzontal 6x6 6.1.b2', false);
        changeVis('Modern Plus 6x6 6.1.b', false);
        changeVis('Modern Plus 6x6 6.1.y', false);
        changeVis('Modern Plus 6x6 6.1.b2', false);
        changeVis('Zaluzja 6x6 6.1.b', false);
        changeVis('Zaluzja 6x6 6.1.y', false);
        changeVis('Zaluzja 6x6 6.1.b2', false);
      } else {
        changeVis('Modern Plus 6x6 6.1.b', true);
      }
    } else if (my_5_c == 1 && _3E == 1) {
      if (isObjectVisible('Modern Plus 6x6 6.1.b2')) {
        changeVis('Falista 6x6 6.1.b', false);
        changeVis('Falista 6x6 6.1.b2', false);
        changeVis('Falista 6x6 6.1.c', false);
        changeVis('Horyzontal 6x6 6.1.b', false);
        changeVis('Horyzontal 6x6 6.1.c', false);
        changeVis('Horyzontal 6x6 6.1.b2', false);
        changeVis('Modern Plus 6x6 6.1.b', false);
        changeVis('Modern Plus 6x6 6.1.c', false);
        changeVis('Modern Plus 6x6 6.1.b2', false);
        changeVis('Zaluzja 6x6 6.1.b', false);
        changeVis('Zaluzja 6x6 6.1.c', false);
        changeVis('Zaluzja 6x6 6.1.b2', false);
      } else {
        changeVis('Modern Plus 6x6 6.1.b2', true);
      }
    }
  }
});
eventHTMLElem('click', '6.1.b', true, function(event) {
  if (Wiata1 == 1) {
    if (my_5_d == 1 && _3C == 1) {
      if (isObjectVisible('Zaluzja 3x6 6.1.b')) {
        changeVis('Falista 3x6 6.1.b', false);
        changeVis('Falista 3x6 6.1.b2', false);
        changeVis('Falista 3x6 6.1.y', false);
        changeVis('Horyzontal 3x6 6.1.b', false);
        changeVis('Horyzontal 3x6 6.1.y', false);
        changeVis('Horyzontal 3x6 6.1.b2', false);
        changeVis('Modern Plus 3x6 6.1.b', false);
        changeVis('Modern Plus 3x6 6.1.y', false);
        changeVis('Modern Plus 3x6 6.1.b2', false);
        changeVis('Zaluzja 3x6 6.1.b', false);
        changeVis('Zaluzja 3x6 6.1.y', false);
        changeVis('Zaluzja 3x6 6.1.b2', false);
      } else {
        changeVis('Zaluzja 3x6 6.1.b', true);
      }
    } else if (my_5_d == 1 && _3E == 1) {
      if (isObjectVisible('Zaluzja 3x6 6.1.b2')) {
        changeVis('Falista 3x6 6.1.b', false);
        changeVis('Falista 3x6 6.1.b2', false);
        changeVis('Falista 3x6 6.1.c', false);
        changeVis('Horyzontal 3x6 6.1.b', false);
        changeVis('Horyzontal 3x6 6.1.c', false);
        changeVis('Horyzontal 3x6 6.1.b2', false);
        changeVis('Modern Plus 3x6 6.1.b', false);
        changeVis('Modern Plus 3x6 6.1.c', false);
        changeVis('Modern Plus 3x6 6.1.b2', false);
        changeVis('Zaluzja 3x6 6.1.b', false);
        changeVis('Zaluzja 3x6 6.1.c', false);
        changeVis('Zaluzja 3x6 6.1.b2', false);
      } else {
        changeVis('Zaluzja 3x6 6.1.b2', true);
      }
    }
  } else if (Wiata2 == 1) {
    if (my_5_d == 1 && _3C == 1) {
      if (isObjectVisible('Zaluzja 6x6 6.1.b')) {
        changeVis('Falista 6x6 6.1.b', false);
        changeVis('Falista 6x6 6.1.b2', false);
        changeVis('Falista 6x6 6.1.y', false);
        changeVis('Horyzontal 6x6 6.1.b', false);
        changeVis('Horyzontal 6x6 6.1.y', false);
        changeVis('Horyzontal 6x6 6.1.b2', false);
        changeVis('Modern Plus 6x6 6.1.b', false);
        changeVis('Modern Plus 6x6 6.1.y', false);
        changeVis('Modern Plus 6x6 6.1.b2', false);
        changeVis('Zaluzja 6x6 6.1.b', false);
        changeVis('Zaluzja 6x6 6.1.y', false);
        changeVis('Zaluzja 6x6 6.1.b2', false);
      } else {
        changeVis('Zaluzja 6x6 6.1.b', true);
      }
    } else if (my_5_d == 1 && _3E == 1) {
      if (isObjectVisible('Zaluzja 6x6 6.1.b2')) {
        changeVis('Falista 6x6 6.1.b', false);
        changeVis('Falista 6x6 6.1.b2', false);
        changeVis('Falista 6x6 6.1.c', false);
        changeVis('Horyzontal 6x6 6.1.b', false);
        changeVis('Horyzontal 6x6 6.1.c', false);
        changeVis('Horyzontal 6x6 6.1.b2', false);
        changeVis('Modern Plus 6x6 6.1.b', false);
        changeVis('Modern Plus 6x6 6.1.c', false);
        changeVis('Modern Plus 6x6 6.1.b2', false);
        changeVis('Zaluzja 6x6 6.1.b', false);
        changeVis('Zaluzja 6x6 6.1.c', false);
        changeVis('Zaluzja 6x6 6.1.b2', false);
      } else {
        changeVis('Zaluzja 6x6 6.1.b2', true);
      }
    }
  } else if (Wiata3 == 1) {
    if (my_5_d == 1 && _3C == 1) {
      if (isObjectVisible('Zaluzja 6x6 6.1.b')) {
        changeVis('Falista 6x6 6.1.b', false);
        changeVis('Falista 6x6 6.1.b2', false);
        changeVis('Falista 6x6 6.1.y', false);
        changeVis('Horyzontal 6x6 6.1.b', false);
        changeVis('Horyzontal 6x6 6.1.y', false);
        changeVis('Horyzontal 6x6 6.1.b2', false);
        changeVis('Modern Plus 6x6 6.1.b', false);
        changeVis('Modern Plus 6x6 6.1.y', false);
        changeVis('Modern Plus 6x6 6.1.b2', false);
        changeVis('Zaluzja 6x6 6.1.b', false);
        changeVis('Zaluzja 6x6 6.1.y', false);
        changeVis('Zaluzja 6x6 6.1.b2', false);
      } else {
        changeVis('Zaluzja 6x6 6.1.b', true);
      }
    } else if (my_5_d == 1 && _3E == 1) {
      if (isObjectVisible('Zaluzja 6x6 6.1.b2')) {
        changeVis('Falista 6x6 6.1.b', false);
        changeVis('Falista 6x6 6.1.b2', false);
        changeVis('Falista 6x6 6.1.c', false);
        changeVis('Horyzontal 6x6 6.1.b', false);
        changeVis('Horyzontal 6x6 6.1.c', false);
        changeVis('Horyzontal 6x6 6.1.b2', false);
        changeVis('Modern Plus 6x6 6.1.b', false);
        changeVis('Modern Plus 6x6 6.1.c', false);
        changeVis('Modern Plus 6x6 6.1.b2', false);
        changeVis('Zaluzja 6x6 6.1.b', false);
        changeVis('Zaluzja 6x6 6.1.c', false);
        changeVis('Zaluzja 6x6 6.1.b2', false);
      } else {
        changeVis('Zaluzja 6x6 6.1.b2', true);
      }
    }
  }
});

eventHTMLElem('click', '6.1.c', true, function(event) {
  if (Wiata1 == 1) {
    if (my_5_a == 1 && _3C == 1) {
      if (isObjectVisible('Falista 3x6 6.1.c')) {
        changeVis('Falista 3x6 6.1.c', false);
        changeVis('Falista 3x6 6.1.c2', false);
        changeVis('Falista 3x6 6.1.y', false);
        changeVis('Horyzontal 3x6 6.1.c', false);
        changeVis('Horyzontal 3x6 6.1.y', false);
        changeVis('Horyzontal 3x6 6.1.c2', false);
        changeVis('Modern Plus 3x6 6.1.c', false);
        changeVis('Modern Plus 3x6 6.1.y', false);
        changeVis('Modern Plus 3x6 6.1.c2', false);
        changeVis('Zaluzja 3x6 6.1.c', false);
        changeVis('Zaluzja 3x6 6.1.y', false);
        changeVis('Zaluzja 3x6 6.1.c2', false);
      } else {
        changeVis('Falista 3x6 6.1.c', true);
      }
    } else if (my_5_a == 1 && _3E == 1) {
      if (isObjectVisible('Falista 3x6 6.1.c2')) {
        changeVis('Falista 3x6 6.1.c', false);
        changeVis('Falista 3x6 6.1.c2', false);
        changeVis('Horyzontal 3x6 6.1.c', false);
        changeVis('Horyzontal 3x6 6.1.c2', false);
        changeVis('Modern Plus 3x6 6.1.c', false);
        changeVis('Modern Plus 3x6 6.1.c2', false);
        changeVis('Zaluzja 3x6 6.1.c', false);
        changeVis('Zaluzja 3x6 6.1.c2', false);
      } else {
        changeVis('Falista 3x6 6.1.c2', true);
      }
    }
  } else if (Wiata2 == 1) {
    if (my_5_a == 1 && _3C == 1) {
      if (isObjectVisible('Falista 6x6 6.1.c')) {
        changeVis('Falista 6x6 6.1.c', false);
        changeVis('Falista 6x6 6.1.c2', false);
        changeVis('Falista 6x6 6.1.y', false);
        changeVis('Horyzontal 6x6 6.1.c', false);
        changeVis('Horyzontal 6x6 6.1.y', false);
        changeVis('Horyzontal 6x6 6.1.c2', false);
        changeVis('Modern Plus 6x6 6.1.c', false);
        changeVis('Modern Plus 6x6 6.1.y', false);
        changeVis('Modern Plus 6x6 6.1.c2', false);
        changeVis('Zaluzja 6x6 6.1.c', false);
        changeVis('Zaluzja 6x6 6.1.y', false);
        changeVis('Zaluzja 6x6 6.1.c2', false);
      } else {
        changeVis('Falista 6x6 6.1.c', true);
      }
    } else if (my_5_a == 1 && _3E == 1) {
      if (isObjectVisible('Falista 6x6 6.1.c2')) {
        changeVis('Falista 6x6 6.1.c', false);
        changeVis('Falista 6x6 6.1.c2', false);
        changeVis('Horyzontal 6x6 6.1.c', false);
        changeVis('Horyzontal 6x6 6.1.c2', false);
        changeVis('Modern Plus 6x6 6.1.c', false);
        changeVis('Modern Plus 6x6 6.1.c2', false);
        changeVis('Zaluzja 6x6 6.1.c', false);
        changeVis('Zaluzja 6x6 6.1.c2', false);
      } else {
        changeVis('Falista 6x6 6.1.c2', true);
      }
    }
  } else if (Wiata3 == 1) {
    if (my_5_a == 1 && _3C == 1) {
      if (isObjectVisible('Falista 6x6 6.1.c')) {
        changeVis('Falista 6x6 6.1.c', false);
        changeVis('Falista 6x6 6.1.c2', false);
        changeVis('Falista 6x6 6.1.y', false);
        changeVis('Horyzontal 6x6 6.1.c', false);
        changeVis('Horyzontal 6x6 6.1.y', false);
        changeVis('Horyzontal 6x6 6.1.c2', false);
        changeVis('Modern Plus 6x6 6.1.c', false);
        changeVis('Modern Plus 6x6 6.1.y', false);
        changeVis('Modern Plus 6x6 6.1.c2', false);
        changeVis('Zaluzja 6x6 6.1.c', false);
        changeVis('Zaluzja 6x6 6.1.y', false);
        changeVis('Zaluzja 6x6 6.1.c2', false);
      } else {
        changeVis('Falista 6x6 6.1.c', true);
      }
    } else if (my_5_a == 1 && _3E == 1) {
      if (isObjectVisible('Falista 6x6 6.1.c2')) {
        changeVis('Falista 6x6 6.1.c', false);
        changeVis('Falista 6x6 6.1.c2', false);
        changeVis('Horyzontal 6x6 6.1.c', false);
        changeVis('Horyzontal 6x6 6.1.c2', false);
        changeVis('Modern Plus 6x6 6.1.c', false);
        changeVis('Modern Plus 6x6 6.1.c2', false);
        changeVis('Zaluzja 6x6 6.1.c', false);
        changeVis('Zaluzja 6x6 6.1.c2', false);
      } else {
        changeVis('Falista 6x6 6.1.c2', true);
      }
    }
  }
});
eventHTMLElem('click', '6.1.c', true, function(event) {
  if (Wiata1 == 1) {
    if (my_5_b == 1 && _3C == 1) {
      if (isObjectVisible('Horyzontal 3x6 6.1.c')) {
        changeVis('Falista 3x6 6.1.c', false);
        changeVis('Falista 3x6 6.1.c2', false);
        changeVis('Falista 3x6 6.1.y', false);
        changeVis('Horyzontal 3x6 6.1.c', false);
        changeVis('Horyzontal 3x6 6.1.y', false);
        changeVis('Horyzontal 3x6 6.1.c2', false);
        changeVis('Modern Plus 3x6 6.1.c', false);
        changeVis('Modern Plus 3x6 6.1.y', false);
        changeVis('Modern Plus 3x6 6.1.c2', false);
        changeVis('Zaluzja 3x6 6.1.c', false);
        changeVis('Zaluzja 3x6 6.1.y', false);
        changeVis('Zaluzja 3x6 6.1.c2', false);
      } else {
        changeVis('Horyzontal 3x6 6.1.c', true);
      }
    } else if (my_5_b == 1 && _3E == 1) {
      if (isObjectVisible('Horyzontal 3x6 6.1.c2')) {
        changeVis('Falista 3x6 6.1.c', false);
        changeVis('Falista 3x6 6.1.c2', false);
        changeVis('Horyzontal 3x6 6.1.c', false);
        changeVis('Horyzontal 3x6 6.1.c2', false);
        changeVis('Modern Plus 3x6 6.1.c', false);
        changeVis('Modern Plus 3x6 6.1.c2', false);
        changeVis('Zaluzja 3x6 6.1.c', false);
        changeVis('Zaluzja 3x6 6.1.c2', false);
      } else {
        changeVis('Horyzontal 3x6 6.1.c2', true);
      }
    }
  } else if (Wiata2 == 1) {
    if (my_5_b == 1 && _3C == 1) {
      if (isObjectVisible('Horyzontal 6x6 6.1.c')) {
        changeVis('Falista 6x6 6.1.c', false);
        changeVis('Falista 6x6 6.1.c2', false);
        changeVis('Falista 6x6 6.1.y', false);
        changeVis('Horyzontal 6x6 6.1.c', false);
        changeVis('Horyzontal 6x6 6.1.y', false);
        changeVis('Horyzontal 6x6 6.1.c2', false);
        changeVis('Modern Plus 6x6 6.1.c', false);
        changeVis('Modern Plus 6x6 6.1.y', false);
        changeVis('Modern Plus 6x6 6.1.c2', false);
        changeVis('Zaluzja 6x6 6.1.c', false);
        changeVis('Zaluzja 6x6 6.1.y', false);
        changeVis('Zaluzja 6x6 6.1.c2', false);
      } else {
        changeVis('Horyzontal 6x6 6.1.c', true);
      }
    } else if (my_5_b == 1 && _3E == 1) {
      if (isObjectVisible('Horyzontal 6x6 6.1.c2')) {
        changeVis('Falista 6x6 6.1.c', false);
        changeVis('Falista 6x6 6.1.c2', false);
        changeVis('Horyzontal 6x6 6.1.c', false);
        changeVis('Horyzontal 6x6 6.1.c2', false);
        changeVis('Modern Plus 6x6 6.1.c', false);
        changeVis('Modern Plus 6x6 6.1.c2', false);
        changeVis('Zaluzja 6x6 6.1.c', false);
        changeVis('Zaluzja 6x6 6.1.c2', false);
      } else {
        changeVis('Horyzontal 6x6 6.1.c2', true);
      }
    }
  } else if (Wiata3 == 1) {
    if (my_5_b == 1 && _3C == 1) {
      if (isObjectVisible('Horyzontal 6x6 6.1.c')) {
        changeVis('Falista 6x6 6.1.c', false);
        changeVis('Falista 6x6 6.1.c2', false);
        changeVis('Falista 6x6 6.1.y', false);
        changeVis('Horyzontal 6x6 6.1.c', false);
        changeVis('Horyzontal 6x6 6.1.y', false);
        changeVis('Horyzontal 6x6 6.1.c2', false);
        changeVis('Modern Plus 6x6 6.1.c', false);
        changeVis('Modern Plus 6x6 6.1.y', false);
        changeVis('Modern Plus 6x6 6.1.c2', false);
        changeVis('Zaluzja 6x6 6.1.c', false);
        changeVis('Zaluzja 6x6 6.1.y', false);
        changeVis('Zaluzja 6x6 6.1.c2', false);
      } else {
        changeVis('Horyzontal 6x6 6.1.c', true);
      }
    } else if (my_5_b == 1 && _3E == 1) {
      if (isObjectVisible('Horyzontal 6x6 6.1.c2')) {
        changeVis('Falista 6x6 6.1.c', false);
        changeVis('Falista 6x6 6.1.c2', false);
        changeVis('Horyzontal 6x6 6.1.c', false);
        changeVis('Horyzontal 6x6 6.1.c2', false);
        changeVis('Modern Plus 6x6 6.1.c', false);
        changeVis('Modern Plus 6x6 6.1.c2', false);
        changeVis('Zaluzja 6x6 6.1.c', false);
        changeVis('Zaluzja 6x6 6.1.c2', false);
      } else {
        changeVis('Horyzontal 6x6 6.1.c2', true);
      }
    }
  }
});
eventHTMLElem('click', '6.1.c', true, function(event) {
  if (Wiata1 == 1) {
    if (my_5_c == 1 && _3C == 1) {
      if (isObjectVisible('Modern Plus 3x6 6.1.c')) {
        changeVis('Falista 3x6 6.1.c', false);
        changeVis('Falista 3x6 6.1.c2', false);
        changeVis('Falista 3x6 6.1.y', false);
        changeVis('Horyzontal 3x6 6.1.c', false);
        changeVis('Horyzontal 3x6 6.1.y', false);
        changeVis('Horyzontal 3x6 6.1.c2', false);
        changeVis('Modern Plus 3x6 6.1.c', false);
        changeVis('Modern Plus 3x6 6.1.y', false);
        changeVis('Modern Plus 3x6 6.1.c2', false);
        changeVis('Zaluzja 3x6 6.1.c', false);
        changeVis('Zaluzja 3x6 6.1.y', false);
        changeVis('Zaluzja 3x6 6.1.c2', false);
      } else {
        changeVis('Modern Plus 3x6 6.1.c', true);
      }
    } else if (my_5_c == 1 && _3E == 1) {
      if (isObjectVisible('Modern Plus 3x6 6.1.c2')) {
        changeVis('Falista 3x6 6.1.c', false);
        changeVis('Falista 3x6 6.1.c2', false);
        changeVis('Horyzontal 3x6 6.1.c', false);
        changeVis('Horyzontal 3x6 6.1.c2', false);
        changeVis('Modern Plus 3x6 6.1.c', false);
        changeVis('Modern Plus 3x6 6.1.c2', false);
        changeVis('Zaluzja 3x6 6.1.c', false);
        changeVis('Zaluzja 3x6 6.1.c2', false);
      } else {
        changeVis('Modern Plus 3x6 6.1.c2', true);
      }
    }
  } else if (Wiata2 == 1) {
    if (my_5_c == 1 && _3C == 1) {
      if (isObjectVisible('Modern Plus 6x6 6.1.c')) {
        changeVis('Falista 6x6 6.1.c', false);
        changeVis('Falista 6x6 6.1.c2', false);
        changeVis('Falista 6x6 6.1.y', false);
        changeVis('Horyzontal 6x6 6.1.c', false);
        changeVis('Horyzontal 6x6 6.1.y', false);
        changeVis('Horyzontal 6x6 6.1.c2', false);
        changeVis('Modern Plus 6x6 6.1.c', false);
        changeVis('Modern Plus 6x6 6.1.y', false);
        changeVis('Modern Plus 6x6 6.1.c2', false);
        changeVis('Zaluzja 6x6 6.1.c', false);
        changeVis('Zaluzja 6x6 6.1.y', false);
        changeVis('Zaluzja 6x6 6.1.c2', false);
      } else {
        changeVis('Modern Plus 6x6 6.1.c', true);
      }
    } else if (my_5_c == 1 && _3E == 1) {
      if (isObjectVisible('Modern Plus 6x6 6.1.c2')) {
        changeVis('Falista 6x6 6.1.c', false);
        changeVis('Falista 6x6 6.1.c2', false);
        changeVis('Horyzontal 6x6 6.1.c', false);
        changeVis('Horyzontal 6x6 6.1.c2', false);
        changeVis('Modern Plus 6x6 6.1.c', false);
        changeVis('Modern Plus 6x6 6.1.c2', false);
        changeVis('Zaluzja 6x6 6.1.c', false);
        changeVis('Zaluzja 6x6 6.1.c2', false);
      } else {
        changeVis('Modern Plus 6x6 6.1.c2', true);
      }
    }
  } else if (Wiata3 == 1) {
    if (my_5_c == 1 && _3C == 1) {
      if (isObjectVisible('Modern Plus 6x6 6.1.c')) {
        changeVis('Falista 6x6 6.1.c', false);
        changeVis('Falista 6x6 6.1.c2', false);
        changeVis('Falista 6x6 6.1.y', false);
        changeVis('Horyzontal 6x6 6.1.c', false);
        changeVis('Horyzontal 6x6 6.1.y', false);
        changeVis('Horyzontal 6x6 6.1.c2', false);
        changeVis('Modern Plus 6x6 6.1.c', false);
        changeVis('Modern Plus 6x6 6.1.y', false);
        changeVis('Modern Plus 6x6 6.1.c2', false);
        changeVis('Zaluzja 6x6 6.1.c', false);
        changeVis('Zaluzja 6x6 6.1.y', false);
        changeVis('Zaluzja 6x6 6.1.c2', false);
      } else {
        changeVis('Modern Plus 6x6 6.1.c', true);
      }
    } else if (my_5_c == 1 && _3E == 1) {
      if (isObjectVisible('Modern Plus 6x6 6.1.c2')) {
        changeVis('Falista 6x6 6.1.c', false);
        changeVis('Falista 6x6 6.1.c2', false);
        changeVis('Horyzontal 6x6 6.1.c', false);
        changeVis('Horyzontal 6x6 6.1.c2', false);
        changeVis('Modern Plus 6x6 6.1.c', false);
        changeVis('Modern Plus 6x6 6.1.c2', false);
        changeVis('Zaluzja 6x6 6.1.c', false);
        changeVis('Zaluzja 6x6 6.1.c2', false);
      } else {
        changeVis('Modern Plus 6x6 6.1.c2', true);
      }
    }
  }
});
eventHTMLElem('click', '6.1.c', true, function(event) {
  if (Wiata1 == 1) {
    if (my_5_d == 1 && _3C == 1) {
      if (isObjectVisible('Zaluzja 3x6 6.1.c')) {
        changeVis('Falista 3x6 6.1.c', false);
        changeVis('Falista 3x6 6.1.c2', false);
        changeVis('Falista 3x6 6.1.y', false);
        changeVis('Horyzontal 3x6 6.1.c', false);
        changeVis('Horyzontal 3x6 6.1.y', false);
        changeVis('Horyzontal 3x6 6.1.c2', false);
        changeVis('Modern Plus 3x6 6.1.c', false);
        changeVis('Modern Plus 3x6 6.1.y', false);
        changeVis('Modern Plus 3x6 6.1.c2', false);
        changeVis('Zaluzja 3x6 6.1.c', false);
        changeVis('Zaluzja 3x6 6.1.y', false);
        changeVis('Zaluzja 3x6 6.1.c2', false);
      } else {
        changeVis('Zaluzja 3x6 6.1.c', true);
      }
    } else if (my_5_d == 1 && _3E == 1) {
      if (isObjectVisible('Zaluzja 3x6 6.1.c2')) {
        changeVis('Falista 3x6 6.1.c', false);
        changeVis('Falista 3x6 6.1.c2', false);
        changeVis('Horyzontal 3x6 6.1.c', false);
        changeVis('Horyzontal 3x6 6.1.c2', false);
        changeVis('Modern Plus 3x6 6.1.c', false);
        changeVis('Modern Plus 3x6 6.1.c2', false);
        changeVis('Zaluzja 3x6 6.1.c', false);
        changeVis('Zaluzja 3x6 6.1.c2', false);
      } else {
        changeVis('Zaluzja 3x6 6.1.c2', true);
      }
    }
  } else if (Wiata2 == 1) {
    if (my_5_d == 1 && _3C == 1) {
      if (isObjectVisible('Zaluzja 6x6 6.1.c')) {
        changeVis('Falista 6x6 6.1.c', false);
        changeVis('Falista 6x6 6.1.c2', false);
        changeVis('Falista 6x6 6.1.y', false);
        changeVis('Horyzontal 6x6 6.1.c', false);
        changeVis('Horyzontal 6x6 6.1.y', false);
        changeVis('Horyzontal 6x6 6.1.c2', false);
        changeVis('Modern Plus 6x6 6.1.c', false);
        changeVis('Modern Plus 6x6 6.1.y', false);
        changeVis('Modern Plus 6x6 6.1.c2', false);
        changeVis('Zaluzja 6x6 6.1.c', false);
        changeVis('Zaluzja 6x6 6.1.y', false);
        changeVis('Zaluzja 6x6 6.1.c2', false);
      } else {
        changeVis('Zaluzja 6x6 6.1.c', true);
      }
    } else if (my_5_d == 1 && _3E == 1) {
      if (isObjectVisible('Zaluzja 6x6 6.1.c2')) {
        changeVis('Falista 6x6 6.1.c', false);
        changeVis('Falista 6x6 6.1.c2', false);
        changeVis('Horyzontal 6x6 6.1.c', false);
        changeVis('Horyzontal 6x6 6.1.c2', false);
        changeVis('Modern Plus 6x6 6.1.c', false);
        changeVis('Modern Plus 6x6 6.1.c2', false);
        changeVis('Zaluzja 6x6 6.1.c', false);
        changeVis('Zaluzja 6x6 6.1.c2', false);
      } else {
        changeVis('Zaluzja 6x6 6.1.c2', true);
      }
    }
  } else if (Wiata2 == 1) {
    if (my_5_d == 1 && _3C == 1) {
      if (isObjectVisible('Zaluzja 6x6 6.1.c')) {
        changeVis('Falista 6x6 6.1.c', false);
        changeVis('Falista 6x6 6.1.c2', false);
        changeVis('Falista 6x6 6.1.y', false);
        changeVis('Horyzontal 6x6 6.1.c', false);
        changeVis('Horyzontal 6x6 6.1.y', false);
        changeVis('Horyzontal 6x6 6.1.c2', false);
        changeVis('Modern Plus 6x6 6.1.c', false);
        changeVis('Modern Plus 6x6 6.1.y', false);
        changeVis('Modern Plus 6x6 6.1.c2', false);
        changeVis('Zaluzja 6x6 6.1.c', false);
        changeVis('Zaluzja 6x6 6.1.y', false);
        changeVis('Zaluzja 6x6 6.1.c2', false);
      } else {
        changeVis('Zaluzja 6x6 6.1.c', true);
      }
    } else if (my_5_d == 1 && _3E == 1) {
      if (isObjectVisible('Zaluzja 6x6 6.1.c2')) {
        changeVis('Falista 6x6 6.1.c', false);
        changeVis('Falista 6x6 6.1.c2', false);
        changeVis('Horyzontal 6x6 6.1.c', false);
        changeVis('Horyzontal 6x6 6.1.c2', false);
        changeVis('Modern Plus 6x6 6.1.c', false);
        changeVis('Modern Plus 6x6 6.1.c2', false);
        changeVis('Zaluzja 6x6 6.1.c', false);
        changeVis('Zaluzja 6x6 6.1.c2', false);
      } else {
        changeVis('Zaluzja 6x6 6.1.c2', true);
      }
    }
  }
});

eventHTMLElem('click', '6.1.d', true, function(event) {
  if (Wiata1 == 1) {
    if (my_5_a == 1) {
      if (isObjectVisible('Falista 3x6 6.1.d')) {
        changeVis('Falista 3x6 6.1.d', false);
        changeVis('Horyzontal 3x6 6.1.d', false);
        changeVis('Modern Plus 3x6 6.1.d', false);
        changeVis('Zaluzja 3x6 6.1.d', false);
        changeVis('Profil 3x6 dodatek', false);
      } else {
        changeVis('Profil 3x6 dodatek', true);
        changeVis('Falista 3x6 6.1.d', true);
      }
    }
  } else if (Wiata2 == 1) {
    if (my_5_a == 1) {
      if (isObjectVisible('Falista 6x6 6.1.d')) {
        my_61d = 1;
        changeVis('Falista 6x6 6.1.d', false);
        changeVis('Horyzontal 6x6 6.1.d', false);
        changeVis('Modern Plus 6x6 6.1.d', false);
        changeVis('Zaluzja 6x6 6.1.d', false);
      } else {
        my_61d = 0;
        changeVis('Falista 6x6 6.1.d', true);
      }
    }
    if (my_61d == 1 && my_61e == 1) {
      changeVis('Profil 6x6 tył', false);
    } else {
      changeVis('Profil 6x6 tył', true);
    }
  } else if (Wiata3 == 1) {
    if (my_5_a == 1) {
      if (isObjectVisible('Falista 6x6 6.1.d')) {
        changeVis('Profil 6x6 tył', false);
        changeVis('Falista 6x6 6.1.d', false);
        changeVis('Falista 6x6 6.1.h', false);
        changeVis('Horyzontal 6x6 6.1.d', false);
        changeVis('Horyzontal 6x6 6.1.h', false);
        changeVis('Modern Plus 6x6 6.1.d', false);
        changeVis('Modern Plus 6x6 6.1.h', false);
        changeVis('Zaluzja 6x6 6.1.d', false);
        changeVis('Zaluzja 6x6 6.1.h', false);
      } else {
        changeVis('Falista 6x6 6.1.d', true);
        changeVis('Falista 6x6 6.1.h', true);
        changeVis('Profil 6x6 tył', true);
      }
    }
  }
});
eventHTMLElem('click', '6.1.d', true, function(event) {
  if (Wiata1 == 1) {
    if (my_5_b == 1) {
      if (isObjectVisible('Horyzontal 3x6 6.1.d')) {
        changeVis('Falista 3x6 6.1.d', false);
        changeVis('Horyzontal 3x6 6.1.d', false);
        changeVis('Modern Plus 3x6 6.1.d', false);
        changeVis('Zaluzja 3x6 6.1.d', false);
        changeVis('Profil 3x6 dodatek', false);
      } else {
        changeVis('Horyzontal 3x6 6.1.d', true);
        changeVis('Profil 3x6 dodatek', true);
      }
    }
  } else if (Wiata2 == 1) {
    if (my_5_b == 1) {
      if (isObjectVisible('Horyzontal 6x6 6.1.d')) {
        my_61d = 1;
        changeVis('Falista 6x6 6.1.d', false);
        changeVis('Horyzontal 6x6 6.1.d', false);
        changeVis('Modern Plus 6x6 6.1.d', false);
        changeVis('Zaluzja 6x6 6.1.d', false);
      } else {
        changeVis('Horyzontal 6x6 6.1.d', true);
        my_61d = 0;
      }
    }
    if (my_61d == 1 && my_61e == 1) {
      changeVis('Profil 6x6 tył', false);
    } else {
      changeVis('Profil 6x6 tył', true);
    }
  } else if (Wiata3 == 1) {
    if (my_5_b == 1) {
      if (isObjectVisible('Horyzontal 6x6 6.1.d')) {
        changeVis('Profil 6x6 tył', false);
        changeVis('Falista 6x6 6.1.d', false);
        changeVis('Falista 6x6 6.1.h', false);
        changeVis('Horyzontal 6x6 6.1.d', false);
        changeVis('Horyzontal 6x6 6.1.h', false);
        changeVis('Modern Plus 6x6 6.1.d', false);
        changeVis('Modern Plus 6x6 6.1.h', false);
        changeVis('Zaluzja 6x6 6.1.d', false);
        changeVis('Zaluzja 6x6 6.1.h', false);
      } else {
        changeVis('Horyzontal 6x6 6.1.d', true);
        changeVis('Horyzontal 6x6 6.1.h', true);
        changeVis('Profil 6x6 tył', true);
      }
    }
  }
});
eventHTMLElem('click', '6.1.d', true, function(event) {
  if (Wiata1 == 1) {
    if (my_5_c == 1) {
      if (isObjectVisible('Modern Plus 3x6 6.1.d')) {
        changeVis('Falista 3x6 6.1.d', false);
        changeVis('Horyzontal 3x6 6.1.d', false);
        changeVis('Modern Plus 3x6 6.1.d', false);
        changeVis('Zaluzja 3x6 6.1.d', false);
        changeVis('Profil 3x6 dodatek', false);
      } else {
        changeVis('Modern Plus 3x6 6.1.d', true);
        changeVis('Profil 3x6 dodatek', true);
      }
    }
  } else if (Wiata2 == 1) {
    if (my_5_c == 1) {
      if (isObjectVisible('Modern Plus 6x6 6.1.d')) {
        my_61d = 1;
        changeVis('Falista 6x6 6.1.d', false);
        changeVis('Horyzontal 6x6 6.1.d', false);
        changeVis('Modern Plus 6x6 6.1.d', false);
        changeVis('Zaluzja 6x6 6.1.d', false);
      } else {
        changeVis('Modern Plus 6x6 6.1.d', true);
        my_61d = 0;
      }
    }
    if (my_61d == 1 && my_61e == 1) {
      changeVis('Profil 6x6 tył', false);
    } else {
      changeVis('Profil 6x6 tył', true);
    }
  } else if (Wiata3 == 1) {
    if (my_5_c == 1) {
      if (isObjectVisible('Modern Plus 6x6 6.1.d')) {
        changeVis('Profil 6x6 tył', false);
        changeVis('Falista 6x6 6.1.d', false);
        changeVis('Falista 6x6 6.1.h', false);
        changeVis('Horyzontal 6x6 6.1.d', false);
        changeVis('Horyzontal 6x6 6.1.h', false);
        changeVis('Modern Plus 6x6 6.1.d', false);
        changeVis('Modern Plus 6x6 6.1.h', false);
        changeVis('Zaluzja 6x6 6.1.d', false);
        changeVis('Zaluzja 6x6 6.1.h', false);
      } else {
        changeVis('Modern Plus 6x6 6.1.d', true);
        changeVis('Modern Plus 6x6 6.1.h', true);
        changeVis('Profil 6x6 tył', true);
      }
    }
  }
});
eventHTMLElem('click', '6.1.d', true, function(event) {
  if (Wiata1 == 1) {
    if (my_5_d == 1) {
      if (isObjectVisible('Zaluzja 3x6 6.1.d')) {
        changeVis('Falista 3x6 6.1.d', false);
        changeVis('Horyzontal 3x6 6.1.d', false);
        changeVis('Modern Plus 3x6 6.1.d', false);
        changeVis('Zaluzja 3x6 6.1.d', false);
        changeVis('Profil 3x6 dodatek', false);
      } else {
        changeVis('Zaluzja 3x6 6.1.d', true);
        changeVis('Profil 3x6 dodatek', true);
      }
    }
  } else if (Wiata2 == 1) {
    if (my_5_d == 1) {
      if (isObjectVisible('Zaluzja 6x6 6.1.d')) {
        my_61d = 1;
        changeVis('Falista 6x6 6.1.d', false);
        changeVis('Horyzontal 6x6 6.1.d', false);
        changeVis('Modern Plus 6x6 6.1.d', false);
        changeVis('Zaluzja 6x6 6.1.d', false);
      } else {
        changeVis('Zaluzja 6x6 6.1.d', true);
        my_61d = 0;
      }
    }
    if (my_61d == 1 && my_61e == 1) {
      changeVis('Profil 6x6 tył', false);
    } else {
      changeVis('Profil 6x6 tył', true);
    }
  } else if (Wiata3 == 1) {
    if (my_5_d == 1) {
      if (isObjectVisible('Zaluzja 6x6 6.1.d')) {
        changeVis('Profil 6x6 tył', false);
        changeVis('Falista 6x6 6.1.d', false);
        changeVis('Falista 6x6 6.1.h', false);
        changeVis('Horyzontal 6x6 6.1.d', false);
        changeVis('Horyzontal 6x6 6.1.h', false);
        changeVis('Modern Plus 6x6 6.1.d', false);
        changeVis('Modern Plus 6x6 6.1.h', false);
        changeVis('Zaluzja 6x6 6.1.d', false);
        changeVis('Zaluzja 6x6 6.1.h', false);
      } else {
        changeVis('Zaluzja 6x6 6.1.d', true);
        changeVis('Zaluzja 6x6 6.1.h', true);
        changeVis('Profil 6x6 tył', true);
      }
    }
  }
});

eventHTMLElem('click', '6.1.e', true, function(event) {
  if (Wiata1 == 1) {
    if (my_5_a == 1 && _3C == 1) {
      if (isObjectVisible('Falista 3x6 6.1.e')) {
        changeVis('Falista 3x6 6.1.e', false);
        changeVis('Falista 3x6 6.1.e2', false);
        changeVis('Falista 6x6 6.1.f2', false);
        changeVis('Horyzontal 3x6 6.1.e', false);
        changeVis('Horyzontal 3x6 6.1.e2', false);
        changeVis('Horyzontal 3x6 6.1.f2', false);
        changeVis('Modern Plus 3x6 6.1.e', false);
        changeVis('Modern Plus 3x6 6.1.e2', false);
        changeVis('Modern Plus 3x6 6.1.f2', false);
        changeVis('Zaluzja 3x6 6.1.e', false);
        changeVis('Zaluzja 3x6 6.1.e2', false);
        changeVis('Zaluzja 3x6 6.1.f2', false);
      } else {
        changeVis('Falista 3x6 6.1.e', true);
      }
    } else if (my_5_a == 1 && _3E == 1) {
      if (isObjectVisible('Falista 3x6 6.1.e2')) {
        changeVis('Falista 3x6 6.1.e', false);
        changeVis('Falista 3x6 6.1.e2', false);
        changeVis('Falista 6x6 6.1.f', false);
        changeVis('Horyzontal 3x6 6.1.e', false);
        changeVis('Horyzontal 3x6 6.1.e2', false);
        changeVis('Horyzontal 3x6 6.1.f', false);
        changeVis('Modern Plus 3x6 6.1.e', false);
        changeVis('Modern Plus 3x6 6.1.e2', false);
        changeVis('Modern Plus 3x6 6.1.f', false);
        changeVis('Zaluzja 3x6 6.1.e', false);
        changeVis('Zaluzja 3x6 6.1.e2', false);
        changeVis('Zaluzja 3x6 6.1.f', false);
      } else {
        changeVis('Falista 3x6 6.1.e2', true);
      }
    }
  } else if (Wiata2 == 1) {
    if (my_5_a == 1) {
      if (isObjectVisible('Falista 6x6 6.1.h')) {
        my_61e = 1;
        changeVis('Falista 6x6 6.1.h', false);
        changeVis('Horyzontal 6x6 6.1.h', false);
        changeVis('Modern Plus 6x6 6.1.h', false);
        changeVis('Zaluzja 6x6 6.1.h', false);
      } else {
        my_61e = 0;
        changeVis('Falista 6x6 6.1.h', true);
      }
    }
    if (my_61d == 1 && my_61e == 1) {
      changeVis('Profil 6x6 tył', false);
    } else {
      changeVis('Profil 6x6 tył', true);
    }
  } else if (Wiata3 == 1) {
    if (my_5_a == 1) {
      if (isObjectVisible('Falista Wielostan 6.1.d')) {
        changeVis('Profil Wielostan dodatek', false);
        changeVis('Falista Wielostan 6.1.d', false);
        changeVis('Horyzontal Wielostan 6.1.d', false);
        changeVis('Modern Plus Wielostan 6.1.d', false);
        changeVis('Zaluzja Wielostan 6.1.d', false);
      } else {
        changeVis('Falista Wielostan 6.1.d', true);
        changeVis('Profil Wielostan dodatek', true);
      }
    }
  }
});
eventHTMLElem('click', '6.1.e', true, function(event) {
  if (Wiata1 == 1) {
    if (my_5_b == 1 && _3C == 1) {
      if (isObjectVisible('Horyzontal 3x6 6.1.e')) {
        changeVis('Falista 3x6 6.1.e', false);
        changeVis('Falista 3x6 6.1.e2', false);
        changeVis('Falista 6x6 6.1.f2', false);
        changeVis('Horyzontal 3x6 6.1.e', false);
        changeVis('Horyzontal 3x6 6.1.e2', false);
        changeVis('Horyzontal 3x6 6.1.f2', false);
        changeVis('Modern Plus 3x6 6.1.e', false);
        changeVis('Modern Plus 3x6 6.1.e2', false);
        changeVis('Modern Plus 3x6 6.1.f2', false);
        changeVis('Zaluzja 3x6 6.1.e', false);
        changeVis('Zaluzja 3x6 6.1.e2', false);
        changeVis('Zaluzja 3x6 6.1.f2', false);
      } else {
        changeVis('Horyzontal 3x6 6.1.e', true);
      }
    } else if (my_5_b == 1 && _3E == 1) {
      if (isObjectVisible('Horyzontal 3x6 6.1.e2')) {
        changeVis('Falista 3x6 6.1.e', false);
        changeVis('Falista 3x6 6.1.e2', false);
        changeVis('Falista 6x6 6.1.f', false);
        changeVis('Horyzontal 3x6 6.1.e', false);
        changeVis('Horyzontal 3x6 6.1.e2', false);
        changeVis('Horyzontal 3x6 6.1.f', false);
        changeVis('Modern Plus 3x6 6.1.e', false);
        changeVis('Modern Plus 3x6 6.1.e2', false);
        changeVis('Modern Plus 3x6 6.1.f', false);
        changeVis('Zaluzja 3x6 6.1.e', false);
        changeVis('Zaluzja 3x6 6.1.e2', false);
        changeVis('Zaluzja 3x6 6.1.f', false);
      } else {
        changeVis('Horyzontal 3x6 6.1.e2', true);
      }
    }
  } else if (Wiata2 == 1) {
    if (my_5_b == 1) {
      if (isObjectVisible('Horyzontal 6x6 6.1.h')) {
        my_61e = 1;
        changeVis('Falista 6x6 6.1.h', false);
        changeVis('Horyzontal 6x6 6.1.h', false);
        changeVis('Modern Plus 6x6 6.1.h', false);
        changeVis('Zaluzja 6x6 6.1.h', false);
      } else {
        changeVis('Horyzontal 6x6 6.1.h', true);
        my_61e = 0;
      }
    }
    if (my_61d == 1 && my_61e == 1) {
      changeVis('Profil 6x6 tył', false);
    } else {
      changeVis('Profil 6x6 tył', true);
    }
  } else if (Wiata3 == 1) {
    if (my_5_b == 1) {
      if (isObjectVisible('Horyzontal Wielostan 6.1.d')) {
        changeVis('Profil Wielostan dodatek', false);
        changeVis('Falista Wielostan 6.1.d', false);
        changeVis('Horyzontal Wielostan 6.1.d', false);
        changeVis('Modern Plus Wielostan 6.1.d', false);
        changeVis('Zaluzja Wielostan 6.1.d', false);
      } else {
        changeVis('Horyzontal Wielostan 6.1.d', true);
        changeVis('Profil Wielostan dodatek', true);
      }
    }
  }
});
eventHTMLElem('click', '6.1.e', true, function(event) {
  if (Wiata1 == 1) {
    if (my_5_c == 1 && _3C == 1) {
      if (isObjectVisible('Modern Plus 3x6 6.1.e')) {
        changeVis('Falista 3x6 6.1.e', false);
        changeVis('Falista 3x6 6.1.e2', false);
        changeVis('Falista 6x6 6.1.f2', false);
        changeVis('Horyzontal 3x6 6.1.e', false);
        changeVis('Horyzontal 3x6 6.1.e2', false);
        changeVis('Horyzontal 3x6 6.1.f2', false);
        changeVis('Modern Plus 3x6 6.1.e', false);
        changeVis('Modern Plus 3x6 6.1.e2', false);
        changeVis('Modern Plus 3x6 6.1.f2', false);
        changeVis('Zaluzja 3x6 6.1.e', false);
        changeVis('Zaluzja 3x6 6.1.e2', false);
        changeVis('Zaluzja 3x6 6.1.f2', false);
      } else {
        changeVis('Modern Plus 3x6 6.1.e', true);
      }
    } else if (my_5_c == 1 && _3E == 1) {
      if (isObjectVisible('Modern Plus 3x6 6.1.e2')) {
        changeVis('Falista 3x6 6.1.e', false);
        changeVis('Falista 3x6 6.1.e2', false);
        changeVis('Falista 6x6 6.1.f', false);
        changeVis('Horyzontal 3x6 6.1.e', false);
        changeVis('Horyzontal 3x6 6.1.e2', false);
        changeVis('Horyzontal 3x6 6.1.f', false);
        changeVis('Modern Plus 3x6 6.1.e', false);
        changeVis('Modern Plus 3x6 6.1.e2', false);
        changeVis('Modern Plus 3x6 6.1.f', false);
        changeVis('Zaluzja 3x6 6.1.e', false);
        changeVis('Zaluzja 3x6 6.1.e2', false);
        changeVis('Zaluzja 3x6 6.1.f', false);
      } else {
        changeVis('Modern Plus 3x6 6.1.e2', true);
      }
    }
  } else if (Wiata2 == 1) {
    if (my_5_c == 1) {
      if (isObjectVisible('Modern Plus 6x6 6.1.h')) {
        my_61e = 1;
        changeVis('Falista 6x6 6.1.h', false);
        changeVis('Horyzontal 6x6 6.1.h', false);
        changeVis('Modern Plus 6x6 6.1.h', false);
        changeVis('Zaluzja 6x6 6.1.h', false);
      } else {
        changeVis('Modern Plus 6x6 6.1.h', true);
        my_61e = 0;
      }
    }
    if (my_61d == 1 && my_61e == 1) {
      changeVis('Profil 6x6 tył', false);
    } else {
      changeVis('Profil 6x6 tył', true);
    }
  } else if (Wiata3 == 1) {
    if (my_5_c == 1) {
      if (isObjectVisible('Modern Plus Wielostan 6.1.d')) {
        changeVis('Profil Wielostan dodatek', false);
        changeVis('Falista Wielostan 6.1.d', false);
        changeVis('Horyzontal Wielostan 6.1.d', false);
        changeVis('Modern Plus Wielostan 6.1.d', false);
        changeVis('Zaluzja Wielostan 6.1.d', false);
      } else {
        changeVis('Modern Plus Wielostan 6.1.d', true);
        changeVis('Profil Wielostan dodatek', true);
      }
    }
  }
});
eventHTMLElem('click', '6.1.e', true, function(event) {
  if (Wiata1 == 1) {
    if (my_5_d == 1 && _3C == 1) {
      if (isObjectVisible('Zaluzja 3x6 6.1.e')) {
        changeVis('Falista 3x6 6.1.e', false);
        changeVis('Falista 3x6 6.1.e2', false);
        changeVis('Falista 6x6 6.1.f2', false);
        changeVis('Horyzontal 3x6 6.1.e', false);
        changeVis('Horyzontal 3x6 6.1.e2', false);
        changeVis('Horyzontal 3x6 6.1.f2', false);
        changeVis('Modern Plus 3x6 6.1.e', false);
        changeVis('Modern Plus 3x6 6.1.e2', false);
        changeVis('Modern Plus 3x6 6.1.f2', false);
        changeVis('Zaluzja 3x6 6.1.e', false);
        changeVis('Zaluzja 3x6 6.1.e2', false);
        changeVis('Zaluzja 3x6 6.1.f2', false);
      } else {
        changeVis('Zaluzja 3x6 6.1.e', true);
      }
    } else if (my_5_d == 1 && _3E == 1) {
      if (isObjectVisible('Zaluzja 3x6 6.1.e2')) {
        changeVis('Falista 3x6 6.1.e', false);
        changeVis('Falista 3x6 6.1.e2', false);
        changeVis('Falista 6x6 6.1.f', false);
        changeVis('Horyzontal 3x6 6.1.e', false);
        changeVis('Horyzontal 3x6 6.1.e2', false);
        changeVis('Horyzontal 3x6 6.1.f', false);
        changeVis('Modern Plus 3x6 6.1.e', false);
        changeVis('Modern Plus 3x6 6.1.e2', false);
        changeVis('Modern Plus 3x6 6.1.f', false);
        changeVis('Zaluzja 3x6 6.1.e', false);
        changeVis('Zaluzja 3x6 6.1.e2', false);
        changeVis('Zaluzja 3x6 6.1.f', false);
      } else {
        changeVis('Zaluzja 3x6 6.1.e2', true);
      }
    }
  } else if (Wiata2 == 1) {
    if (my_5_d == 1) {
      if (isObjectVisible('Zaluzja 6x6 6.1.h')) {
        my_61e = 1;
        changeVis('Falista 6x6 6.1.h', false);
        changeVis('Horyzontal 6x6 6.1.h', false);
        changeVis('Modern Plus 6x6 6.1.h', false);
        changeVis('Zaluzja 6x6 6.1.h', false);
      } else {
        changeVis('Zaluzja 6x6 6.1.h', true);
        my_61e = 0;
      }
    }
    if (my_61d == 1 && my_61e == 1) {
      changeVis('Profil 6x6 tył', false);
    } else {
      changeVis('Profil 6x6 tył', true);
    }
  } else if (Wiata3 == 1) {
    if (my_5_d == 1) {
      if (isObjectVisible('Zaluzja Wielostan 6.1.d')) {
        changeVis('Profil Wielostan dodatek', false);
        changeVis('Falista Wielostan 6.1.d', false);
        changeVis('Horyzontal Wielostan 6.1.d', false);
        changeVis('Modern Plus Wielostan 6.1.d', false);
        changeVis('Zaluzja Wielostan 6.1.d', false);
      } else {
        changeVis('Zaluzja Wielostan 6.1.d', true);
        changeVis('Profil Wielostan dodatek', true);
      }
    }
  }
});

eventHTMLElem('click', '6.1.f', true, function(event) {
  if (Wiata1 == 1) {
    if (my_5_a == 1 && _3C == 1) {
      if (isObjectVisible('Falista 3x6 6.1.f')) {
        changeVis('Falista 3x6 6.1.f', false);
        changeVis('Falista 3x6 6.1.f2', false);
        changeVis('Falista 3x6 6.1.g2', false);
        changeVis('Horyzontal 3x6 6.1.f', false);
        changeVis('Horyzontal 3x6 6.1.f2', false);
        changeVis('Horyzontal 3x6 6.1.g2', false);
        changeVis('Modern Plus 3x6 6.1.f', false);
        changeVis('Modern Plus 3x6 6.1.g2', false);
        changeVis('Modern Plus 3x6 6.1.f2', false);
        changeVis('Zaluzja 3x6 6.1.f', false);
        changeVis('Zaluzja 3x6 6.1.g2', false);
        changeVis('Zaluzja 3x6 6.1.f2', false);
      } else {
        changeVis('Falista 3x6 6.1.f', true);
      }
    } else if (my_5_a == 1 && _3E == 1) {
      if (isObjectVisible('Falista 3x6 6.1.f2')) {
        changeVis('Falista 3x6 6.1.f', false);
        changeVis('Falista 3x6 6.1.f2', false);
        changeVis('Falista 3x6 6.1.g', false);
        changeVis('Horyzontal 3x6 6.1.f', false);
        changeVis('Horyzontal 3x6 6.1.f2', false);
        changeVis('Horyzontal 3x6 6.1.g', false);
        changeVis('Modern Plus 3x6 6.1.f', false);
        changeVis('Modern Plus 3x6 6.1.g', false);
        changeVis('Modern Plus 3x6 6.1.f2', false);
        changeVis('Zaluzja 3x6 6.1.f', false);
        changeVis('Zaluzja 3x6 6.1.g', false);
        changeVis('Zaluzja 3x6 6.1.f2', false);
      } else {
        changeVis('Falista 3x6 6.1.f2', true);
      }
    }
  } else if (Wiata2 == 1) {
    if (my_5_a == 1 && _3C == 1) {
      if (isObjectVisible('Falista 6x6 6.1.e')) {
        changeVis('Falista 6x6 6.1.e', false);
        changeVis('Falista 6x6 6.1.e2', false);
        changeVis('Falista 6x6 6.1.f2', false);
        changeVis('Horyzontal 6x6 6.1.e', false);
        changeVis('Horyzontal 6x6 6.1.f2', false);
        changeVis('Horyzontal 6x6 6.1.e2', false);
        changeVis('Modern Plus 6x6 6.1.e', false);
        changeVis('Modern Plus 6x6 6.1.f2', false);
        changeVis('Modern Plus 6x6 6.1.e2', false);
        changeVis('Zaluzja 6x6 6.1.e', false);
        changeVis('Zaluzja 6x6 6.1.f2', false);
        changeVis('Zaluzja 6x6 6.1.e2', false);
      } else {
        changeVis('Falista 6x6 6.1.e', true);
      }
    } else if (my_5_a == 1 && _3E == 1) {
      if (isObjectVisible('Falista 6x6 6.1.e2')) {
        changeVis('Falista 6x6 6.1.e', false);
        changeVis('Falista 6x6 6.1.e2', false);
        changeVis('Falista 6x6 6.1.f', false);
        changeVis('Horyzontal 6x6 6.1.e', false);
        changeVis('Horyzontal 6x6 6.1.f', false);
        changeVis('Horyzontal 6x6 6.1.e2', false);
        changeVis('Modern Plus 6x6 6.1.e', false);
        changeVis('Modern Plus 6x6 6.1.f', false);
        changeVis('Modern Plus 6x6 6.1.e2', false);
        changeVis('Zaluzja 6x6 6.1.e', false);
        changeVis('Zaluzja 6x6 6.1.f', false);
        changeVis('Zaluzja 6x6 6.1.e2', false);
      } else {
        changeVis('Falista 6x6 6.1.e2', true);
      }
    }
  } else if (Wiata3 == 1) {
    if (my_5_a == 1 && _3C == 1) {
      if (isObjectVisible('Falista Wielostan 6.1.e')) {
        changeVis('Falista Wielostan 6.1.e', false);
        changeVis('Falista Wielostan 6.1.e2', false);
        changeVis('Falista Wielostan 6.1.f2', false);
        changeVis('Horyzontal Wielostan 6.1.e', false);
        changeVis('Horyzontal Wielostan 6.1.e2', false);
        changeVis('Horyzontal Wielostan 6.1.f2', false);
        changeVis('Modern Plus Wielostan 6.1.e', false);
        changeVis('Modern Plus Wielostan 6.1.e2', false);
        changeVis('Modern Plus Wielostan 6.1.f2', false);
        changeVis('Zaluzja Wielostan 6.1.e', false);
        changeVis('Zaluzja Wielostan 6.1.e2', false);
        changeVis('Zaluzja Wielostan 6.1.f2', false);
      } else {
        changeVis('Falista Wielostan 6.1.e', true);
      }
    } else if (my_5_a == 1 && _3E == 1) {
      if (isObjectVisible('Falista Wielostan 6.1.e2')) {
        changeVis('Falista Wielostan 6.1.e', false);
        changeVis('Falista Wielostan 6.1.e2', false);
        changeVis('Falista Wielostan 6.1.f', false);
        changeVis('Horyzontal Wielostan 6.1.e', false);
        changeVis('Horyzontal Wielostan 6.1.e2', false);
        changeVis('Horyzontal Wielostan 6.1.f', false);
        changeVis('Modern Plus Wielostan 6.1.e', false);
        changeVis('Modern Plus Wielostan 6.1.e2', false);
        changeVis('Modern Plus Wielostan 6.1.f', false);
        changeVis('Zaluzja Wielostan 6.1.e', false);
        changeVis('Zaluzja Wielostan 6.1.e2', false);
        changeVis('Zaluzja Wielostan 6.1.f', false);
      } else {
        changeVis('Falista Wielostan 6.1.e2', true);
      }
    }
  }
});
eventHTMLElem('click', '6.1.f', true, function(event) {
  if (Wiata1 == 1) {
    if (my_5_b == 1 && _3C == 1) {
      if (isObjectVisible('Horyzontal 3x6 6.1.f')) {
        changeVis('Falista 3x6 6.1.f', false);
        changeVis('Falista 3x6 6.1.f2', false);
        changeVis('Falista 3x6 6.1.g2', false);
        changeVis('Horyzontal 3x6 6.1.f', false);
        changeVis('Horyzontal 3x6 6.1.f2', false);
        changeVis('Horyzontal 3x6 6.1.g2', false);
        changeVis('Modern Plus 3x6 6.1.f', false);
        changeVis('Modern Plus 3x6 6.1.g2', false);
        changeVis('Modern Plus 3x6 6.1.f2', false);
        changeVis('Zaluzja 3x6 6.1.f', false);
        changeVis('Zaluzja 3x6 6.1.g2', false);
        changeVis('Zaluzja 3x6 6.1.f2', false);
      } else {
        changeVis('Horyzontal 3x6 6.1.f', true);
      }
    } else if (my_5_b == 1 && _3E == 1) {
      if (isObjectVisible('Horyzontal 3x6 6.1.f2')) {
        changeVis('Falista 3x6 6.1.f', false);
        changeVis('Falista 3x6 6.1.f2', false);
        changeVis('Falista 3x6 6.1.g', false);
        changeVis('Horyzontal 3x6 6.1.f', false);
        changeVis('Horyzontal 3x6 6.1.f2', false);
        changeVis('Horyzontal 3x6 6.1.g', false);
        changeVis('Modern Plus 3x6 6.1.f', false);
        changeVis('Modern Plus 3x6 6.1.g', false);
        changeVis('Modern Plus 3x6 6.1.f2', false);
        changeVis('Zaluzja 3x6 6.1.f', false);
        changeVis('Zaluzja 3x6 6.1.g', false);
        changeVis('Zaluzja 3x6 6.1.f2', false);
      } else {
        changeVis('Horyzontal 3x6 6.1.f2', true);
      }
    }
  } else if (Wiata2 == 1) {
    if (my_5_b == 1 && _3C == 1) {
      if (isObjectVisible('Horyzontal 6x6 6.1.e')) {
        changeVis('Falista 6x6 6.1.e', false);
        changeVis('Falista 6x6 6.1.e2', false);
        changeVis('Falista 6x6 6.1.f2', false);
        changeVis('Horyzontal 6x6 6.1.e', false);
        changeVis('Horyzontal 6x6 6.1.f2', false);
        changeVis('Horyzontal 6x6 6.1.e2', false);
        changeVis('Modern Plus 6x6 6.1.e', false);
        changeVis('Modern Plus 6x6 6.1.f2', false);
        changeVis('Modern Plus 6x6 6.1.e2', false);
        changeVis('Zaluzja 6x6 6.1.e', false);
        changeVis('Zaluzja 6x6 6.1.f2', false);
        changeVis('Zaluzja 6x6 6.1.e2', false);
      } else {
        changeVis('Horyzontal 6x6 6.1.e', true);
      }
    } else if (my_5_b == 1 && _3E == 1) {
      if (isObjectVisible('Horyzontal 6x6 6.1.e2')) {
        changeVis('Falista 6x6 6.1.e', false);
        changeVis('Falista 6x6 6.1.e2', false);
        changeVis('Falista 6x6 6.1.f', false);
        changeVis('Horyzontal 6x6 6.1.e', false);
        changeVis('Horyzontal 6x6 6.1.f', false);
        changeVis('Horyzontal 6x6 6.1.e2', false);
        changeVis('Modern Plus 6x6 6.1.e', false);
        changeVis('Modern Plus 6x6 6.1.f', false);
        changeVis('Modern Plus 6x6 6.1.e2', false);
        changeVis('Zaluzja 6x6 6.1.e', false);
        changeVis('Zaluzja 6x6 6.1.f', false);
        changeVis('Zaluzja 6x6 6.1.e2', false);
      } else {
        changeVis('Horyzontal 6x6 6.1.e2', true);
      }
    }
  } else if (Wiata3 == 1) {
    if (my_5_b == 1 && _3C == 1) {
      if (isObjectVisible('Horyzontal Wielostan 6.1.e')) {
        changeVis('Falista Wielostan 6.1.e', false);
        changeVis('Falista Wielostan 6.1.e2', false);
        changeVis('Falista Wielostan 6.1.f2', false);
        changeVis('Horyzontal Wielostan 6.1.e', false);
        changeVis('Horyzontal Wielostan 6.1.e2', false);
        changeVis('Horyzontal Wielostan 6.1.f2', false);
        changeVis('Modern Plus Wielostan 6.1.e', false);
        changeVis('Modern Plus Wielostan 6.1.e2', false);
        changeVis('Modern Plus Wielostan 6.1.f2', false);
        changeVis('Zaluzja Wielostan 6.1.e', false);
        changeVis('Zaluzja Wielostan 6.1.e2', false);
        changeVis('Zaluzja Wielostan 6.1.f2', false);
      } else {
        changeVis('Horyzontal Wielostan 6.1.e', true);
      }
    } else if (my_5_b == 1 && _3E == 1) {
      if (isObjectVisible('Horyzontal Wielostan 6.1.e2')) {
        changeVis('Falista Wielostan 6.1.e', false);
        changeVis('Falista Wielostan 6.1.e2', false);
        changeVis('Falista Wielostan 6.1.f', false);
        changeVis('Horyzontal Wielostan 6.1.e', false);
        changeVis('Horyzontal Wielostan 6.1.e2', false);
        changeVis('Horyzontal Wielostan 6.1.f', false);
        changeVis('Modern Plus Wielostan 6.1.e', false);
        changeVis('Modern Plus Wielostan 6.1.e2', false);
        changeVis('Modern Plus Wielostan 6.1.f', false);
        changeVis('Zaluzja Wielostan 6.1.e', false);
        changeVis('Zaluzja Wielostan 6.1.e2', false);
        changeVis('Zaluzja Wielostan 6.1.f', false);
      } else {
        changeVis('Horyzontal Wielostan 6.1.e2', true);
      }
    }
  }
});
eventHTMLElem('click', '6.1.f', true, function(event) {
  if (Wiata1 == 1) {
    if (my_5_c == 1 && _3C == 1) {
      if (isObjectVisible('Modern Plus 3x6 6.1.f')) {
        changeVis('Falista 3x6 6.1.f', false);
        changeVis('Falista 3x6 6.1.f2', false);
        changeVis('Falista 3x6 6.1.g2', false);
        changeVis('Horyzontal 3x6 6.1.f', false);
        changeVis('Horyzontal 3x6 6.1.f2', false);
        changeVis('Horyzontal 3x6 6.1.g2', false);
        changeVis('Modern Plus 3x6 6.1.f', false);
        changeVis('Modern Plus 3x6 6.1.g2', false);
        changeVis('Modern Plus 3x6 6.1.f2', false);
        changeVis('Zaluzja 3x6 6.1.f', false);
        changeVis('Zaluzja 3x6 6.1.g2', false);
        changeVis('Zaluzja 3x6 6.1.f2', false);
      } else {
        changeVis('Modern Plus 3x6 6.1.f', true);
      }
    } else if (my_5_c == 1 && _3E == 1) {
      if (isObjectVisible('Modern Plus 3x6 6.1.f2')) {
        changeVis('Falista 3x6 6.1.f', false);
        changeVis('Falista 3x6 6.1.f2', false);
        changeVis('Falista 3x6 6.1.g', false);
        changeVis('Horyzontal 3x6 6.1.f', false);
        changeVis('Horyzontal 3x6 6.1.f2', false);
        changeVis('Horyzontal 3x6 6.1.g', false);
        changeVis('Modern Plus 3x6 6.1.f', false);
        changeVis('Modern Plus 3x6 6.1.g', false);
        changeVis('Modern Plus 3x6 6.1.f2', false);
        changeVis('Zaluzja 3x6 6.1.f', false);
        changeVis('Zaluzja 3x6 6.1.g', false);
        changeVis('Zaluzja 3x6 6.1.f2', false);
      } else {
        changeVis('Modern Plus 3x6 6.1.f2', true);
      }
    }
  } else if (Wiata2 == 1) {
    if (my_5_c == 1 && _3C == 1) {
      if (isObjectVisible('Modern Plus 6x6 6.1.e')) {
        changeVis('Falista 6x6 6.1.e', false);
        changeVis('Falista 6x6 6.1.e2', false);
        changeVis('Falista 6x6 6.1.f2', false);
        changeVis('Horyzontal 6x6 6.1.e', false);
        changeVis('Horyzontal 6x6 6.1.f2', false);
        changeVis('Horyzontal 6x6 6.1.e2', false);
        changeVis('Modern Plus 6x6 6.1.e', false);
        changeVis('Modern Plus 6x6 6.1.f2', false);
        changeVis('Modern Plus 6x6 6.1.e2', false);
        changeVis('Zaluzja 6x6 6.1.e', false);
        changeVis('Zaluzja 6x6 6.1.f2', false);
        changeVis('Zaluzja 6x6 6.1.e2', false);
      } else {
        changeVis('Modern Plus 6x6 6.1.e', true);
      }
    } else if (my_5_c == 1 && _3E == 1) {
      if (isObjectVisible('Modern Plus 6x6 6.1.e2')) {
        changeVis('Falista 6x6 6.1.e', false);
        changeVis('Falista 6x6 6.1.e2', false);
        changeVis('Falista 6x6 6.1.f', false);
        changeVis('Horyzontal 6x6 6.1.e', false);
        changeVis('Horyzontal 6x6 6.1.f', false);
        changeVis('Horyzontal 6x6 6.1.e2', false);
        changeVis('Modern Plus 6x6 6.1.e', false);
        changeVis('Modern Plus 6x6 6.1.f', false);
        changeVis('Modern Plus 6x6 6.1.e2', false);
        changeVis('Zaluzja 6x6 6.1.e', false);
        changeVis('Zaluzja 6x6 6.1.f', false);
        changeVis('Zaluzja 6x6 6.1.e2', false);
      } else {
        changeVis('Modern Plus 6x6 6.1.e2', true);
      }
    }
  } else if (Wiata3 == 1) {
    if (my_5_c == 1 && _3C == 1) {
      if (isObjectVisible('Modern Plus Wielostan 6.1.e')) {
        changeVis('Falista Wielostan 6.1.e', false);
        changeVis('Falista Wielostan 6.1.e2', false);
        changeVis('Falista Wielostan 6.1.f2', false);
        changeVis('Horyzontal Wielostan 6.1.e', false);
        changeVis('Horyzontal Wielostan 6.1.e2', false);
        changeVis('Horyzontal Wielostan 6.1.f2', false);
        changeVis('Modern Plus Wielostan 6.1.e', false);
        changeVis('Modern Plus Wielostan 6.1.e2', false);
        changeVis('Modern Plus Wielostan 6.1.f2', false);
        changeVis('Zaluzja Wielostan 6.1.e', false);
        changeVis('Zaluzja Wielostan 6.1.e2', false);
        changeVis('Zaluzja Wielostan 6.1.f2', false);
      } else {
        changeVis('Modern Plus Wielostan 6.1.e', true);
      }
    } else if (my_5_c == 1 && _3E == 1) {
      if (isObjectVisible('Modern Plus Wielostan 6.1.e2')) {
        changeVis('Falista Wielostan 6.1.e', false);
        changeVis('Falista Wielostan 6.1.e2', false);
        changeVis('Falista Wielostan 6.1.f', false);
        changeVis('Horyzontal Wielostan 6.1.e', false);
        changeVis('Horyzontal Wielostan 6.1.e2', false);
        changeVis('Horyzontal Wielostan 6.1.f', false);
        changeVis('Modern Plus Wielostan 6.1.e', false);
        changeVis('Modern Plus Wielostan 6.1.e2', false);
        changeVis('Modern Plus Wielostan 6.1.f', false);
        changeVis('Zaluzja Wielostan 6.1.e', false);
        changeVis('Zaluzja Wielostan 6.1.e2', false);
        changeVis('Zaluzja Wielostan 6.1.f', false);
      } else {
        changeVis('Modern Plus Wielostan 6.1.e2', true);
      }
    }
  }
});
eventHTMLElem('click', '6.1.f', true, function(event) {
  if (Wiata1 == 1) {
    if (my_5_d == 1 && _3C == 1) {
      if (isObjectVisible('Zaluzja 3x6 6.1.f')) {
        changeVis('Falista 3x6 6.1.f', false);
        changeVis('Falista 3x6 6.1.f2', false);
        changeVis('Falista 3x6 6.1.g2', false);
        changeVis('Horyzontal 3x6 6.1.f', false);
        changeVis('Horyzontal 3x6 6.1.f2', false);
        changeVis('Horyzontal 3x6 6.1.g2', false);
        changeVis('Modern Plus 3x6 6.1.f', false);
        changeVis('Modern Plus 3x6 6.1.g2', false);
        changeVis('Modern Plus 3x6 6.1.f2', false);
        changeVis('Zaluzja 3x6 6.1.f', false);
        changeVis('Zaluzja 3x6 6.1.g2', false);
        changeVis('Zaluzja 3x6 6.1.f2', false);
      } else {
        changeVis('Zaluzja 3x6 6.1.f', true);
      }
    } else if (my_5_d == 1 && _3E == 1) {
      if (isObjectVisible('Zaluzja 3x6 6.1.f2')) {
        changeVis('Falista 3x6 6.1.f', false);
        changeVis('Falista 3x6 6.1.f2', false);
        changeVis('Falista 3x6 6.1.g', false);
        changeVis('Horyzontal 3x6 6.1.f', false);
        changeVis('Horyzontal 3x6 6.1.f2', false);
        changeVis('Horyzontal 3x6 6.1.g', false);
        changeVis('Modern Plus 3x6 6.1.f', false);
        changeVis('Modern Plus 3x6 6.1.g', false);
        changeVis('Modern Plus 3x6 6.1.f2', false);
        changeVis('Zaluzja 3x6 6.1.f', false);
        changeVis('Zaluzja 3x6 6.1.g', false);
        changeVis('Zaluzja 3x6 6.1.f2', false);
      } else {
        changeVis('Zaluzja 3x6 6.1.f2', true);
      }
    }
  } else if (Wiata2 == 1) {
    if (my_5_d == 1 && _3C == 1) {
      if (isObjectVisible('Zaluzja 6x6 6.1.e')) {
        changeVis('Falista 6x6 6.1.e', false);
        changeVis('Falista 6x6 6.1.e2', false);
        changeVis('Falista 6x6 6.1.f2', false);
        changeVis('Horyzontal 6x6 6.1.e', false);
        changeVis('Horyzontal 6x6 6.1.f2', false);
        changeVis('Horyzontal 6x6 6.1.e2', false);
        changeVis('Modern Plus 6x6 6.1.e', false);
        changeVis('Modern Plus 6x6 6.1.f2', false);
        changeVis('Modern Plus 6x6 6.1.e2', false);
        changeVis('Zaluzja 6x6 6.1.e', false);
        changeVis('Zaluzja 6x6 6.1.f2', false);
        changeVis('Zaluzja 6x6 6.1.e2', false);
      } else {
        changeVis('Zaluzja 6x6 6.1.e', true);
      }
    } else if (my_5_d == 1 && _3E == 1) {
      if (isObjectVisible('Zaluzja 6x6 6.1.e2')) {
        changeVis('Falista 6x6 6.1.e', false);
        changeVis('Falista 6x6 6.1.e2', false);
        changeVis('Falista 6x6 6.1.f', false);
        changeVis('Horyzontal 6x6 6.1.e', false);
        changeVis('Horyzontal 6x6 6.1.f', false);
        changeVis('Horyzontal 6x6 6.1.e2', false);
        changeVis('Modern Plus 6x6 6.1.e', false);
        changeVis('Modern Plus 6x6 6.1.f', false);
        changeVis('Modern Plus 6x6 6.1.e2', false);
        changeVis('Zaluzja 6x6 6.1.e', false);
        changeVis('Zaluzja 6x6 6.1.f', false);
        changeVis('Zaluzja 6x6 6.1.e2', false);
      } else {
        changeVis('Zaluzja 6x6 6.1.e2', true);
      }
    }
  } else if (Wiata3 == 1) {
    if (my_5_d == 1 && _3C == 1) {
      if (isObjectVisible('Zaluzja Wielostan 6.1.e')) {
        changeVis('Falista Wielostan 6.1.e', false);
        changeVis('Falista Wielostan 6.1.e2', false);
        changeVis('Falista Wielostan 6.1.f2', false);
        changeVis('Horyzontal Wielostan 6.1.e', false);
        changeVis('Horyzontal Wielostan 6.1.e2', false);
        changeVis('Horyzontal Wielostan 6.1.f2', false);
        changeVis('Modern Plus Wielostan 6.1.e', false);
        changeVis('Modern Plus Wielostan 6.1.e2', false);
        changeVis('Modern Plus Wielostan 6.1.f2', false);
        changeVis('Zaluzja Wielostan 6.1.e', false);
        changeVis('Zaluzja Wielostan 6.1.e2', false);
        changeVis('Zaluzja Wielostan 6.1.f2', false);
      } else {
        changeVis('Zaluzja Wielostan 6.1.e', true);
      }
    } else if (my_5_d == 1 && _3E == 1) {
      if (isObjectVisible('Zaluzja Wielostan 6.1.e2')) {
        changeVis('Falista Wielostan 6.1.e', false);
        changeVis('Falista Wielostan 6.1.e2', false);
        changeVis('Falista Wielostan 6.1.f', false);
        changeVis('Horyzontal Wielostan 6.1.e', false);
        changeVis('Horyzontal Wielostan 6.1.e2', false);
        changeVis('Horyzontal Wielostan 6.1.f', false);
        changeVis('Modern Plus Wielostan 6.1.e', false);
        changeVis('Modern Plus Wielostan 6.1.e2', false);
        changeVis('Modern Plus Wielostan 6.1.f', false);
        changeVis('Zaluzja Wielostan 6.1.e', false);
        changeVis('Zaluzja Wielostan 6.1.e2', false);
        changeVis('Zaluzja Wielostan 6.1.f', false);
      } else {
        changeVis('Zaluzja Wielostan 6.1.e2', true);
      }
    }
  }
});

eventHTMLElem('click', '6.1.g', true, function(event) {
  if (Wiata1 == 1) {
    if (my_5_a == 1 && _3C == 1) {
      if (isObjectVisible('Falista 3x6 6.1.g')) {
        changeVis('Falista 3x6 6.1.g', false);
        changeVis('Falista 3x6 6.1.g2', false);
        changeVis('Falista 3x6 6.1.z', false);
        changeVis('Horyzontal 3x6 6.1.g', false);
        changeVis('Horyzontal 3x6 6.1.g2', false);
        changeVis('Horyzontal 3x6 6.1.z', false);
        changeVis('Modern Plus 3x6 6.1.g', false);
        changeVis('Modern Plus 3x6 6.1.g2', false);
        changeVis('Modern Plus 3x6 6.1.z', false);
        changeVis('Zaluzja 3x6 6.1.g', false);
        changeVis('Zaluzja 3x6 6.1.g2', false);
        changeVis('Zaluzja 3x6 6.1.z', false);
      } else {
        changeVis('Falista 3x6 6.1.g', true);
      }
    } else if (my_5_a == 1 && _3E == 1) {
      if (isObjectVisible('Falista 3x6 6.1.g2')) {
        changeVis('Falista 3x6 6.1.g', false);
        changeVis('Falista 3x6 6.1.g2', false);
        changeVis('Horyzontal 3x6 6.1.g', false);
        changeVis('Horyzontal 3x6 6.1.g2', false);
        changeVis('Modern Plus 3x6 6.1.g', false);
        changeVis('Modern Plus 3x6 6.1.g2', false);
        changeVis('Zaluzja 3x6 6.1.g', false);
        changeVis('Zaluzja 3x6 6.1.g2', false);
      } else {
        changeVis('Falista 3x6 6.1.g', true);
      }
    }
  } else if (Wiata2 == 1) {
    if (my_5_a == 1 && _3C == 1) {
      if (isObjectVisible('Falista 6x6 6.1.f')) {
        changeVis('Falista 6x6 6.1.f', false);
        changeVis('Falista 6x6 6.1.g2', false);
        changeVis('Falista 6x6 6.1.f2', false);
        changeVis('Horyzontal 6x6 6.1.f', false);
        changeVis('Horyzontal 6x6 6.1.f2', false);
        changeVis('Horyzontal 6x6 6.1.g2', false);
        changeVis('Modern Plus 6x6 6.1.f', false);
        changeVis('Modern Plus 6x6 6.1.f2', false);
        changeVis('Modern Plus 6x6 6.1.g2', false);
        changeVis('Zaluzja 6x6 6.1.f', false);
        changeVis('Zaluzja 6x6 6.1.f2', false);
        changeVis('Zaluzja 6x6 6.1.g2', false);
      } else {
        changeVis('Falista 6x6 6.1.f', true);
      }
    } else if (my_5_a == 1 && _3E == 1) {
      if (isObjectVisible('Falista 6x6 6.1.f2')) {
        changeVis('Falista 6x6 6.1.f', false);
        changeVis('Falista 6x6 6.1.g', false);
        changeVis('Falista 6x6 6.1.f2', false);
        changeVis('Horyzontal 6x6 6.1.f', false);
        changeVis('Horyzontal 6x6 6.1.f2', false);
        changeVis('Horyzontal 6x6 6.1.g', false);
        changeVis('Modern Plus 6x6 6.1.f', false);
        changeVis('Modern Plus 6x6 6.1.f2', false);
        changeVis('Modern Plus 6x6 6.1.g', false);
        changeVis('Zaluzja 6x6 6.1.f', false);
        changeVis('Zaluzja 6x6 6.1.f2', false);
        changeVis('Zaluzja 6x6 6.1.g', false);
      } else {
        changeVis('Falista 6x6 6.1.f2', true);
      }
    }
  } else if (Wiata3 == 1) {
    if (my_5_a == 1 && _3C == 1) {
      if (isObjectVisible('Falista Wielostan 6.1.f')) {
        changeVis('Falista Wielostan 6.1.f', false);
        changeVis('Falista Wielostan 6.1.g2', false);
        changeVis('Falista Wielostan 6.1.f2', false);
        changeVis('Horyzontal Wielostan 6.1.f', false);
        changeVis('Horyzontal Wielostan 6.1.g2', false);
        changeVis('Horyzontal Wielostan 6.1.f2', false);
        changeVis('Modern Plus Wielostan 6.1.f', false);
        changeVis('Modern Plus Wielostan 6.1.g2', false);
        changeVis('Modern Plus Wielostan 6.1.f2', false);
        changeVis('Zaluzja Wielostan 6.1.f', false);
        changeVis('Zaluzja Wielostan 6.1.g2', false);
        changeVis('Zaluzja Wielostan 6.1.f2', false);
      } else {
        changeVis('Falista Wielostan 6.1.f', true);
      }
    } else if (my_5_a == 1 && _3E == 1) {
      if (isObjectVisible('Falista Wielostan 6.1.f2')) {
        changeVis('Falista Wielostan 6.1.f', false);
        changeVis('Falista Wielostan 6.1.g', false);
        changeVis('Falista Wielostan 6.1.f2', false);
        changeVis('Horyzontal Wielostan 6.1.f', false);
        changeVis('Horyzontal Wielostan 6.1.g', false);
        changeVis('Horyzontal Wielostan 6.1.f2', false);
        changeVis('Modern Plus Wielostan 6.1.f', false);
        changeVis('Modern Plus Wielostan 6.1.g', false);
        changeVis('Modern Plus Wielostan 6.1.f2', false);
        changeVis('Zaluzja Wielostan 6.1.f', false);
        changeVis('Zaluzja Wielostan 6.1.g', false);
        changeVis('Zaluzja Wielostan 6.1.f2', false);
      } else {
        changeVis('Falista Wielostan 6.1.f2', true);
      }
    }
  }
});
eventHTMLElem('click', '6.1.g', true, function(event) {
  if (Wiata1 == 1) {
    if (my_5_b == 1 && _3C == 1) {
      if (isObjectVisible('Horyzontal 3x6 6.1.g')) {
        changeVis('Falista 3x6 6.1.g', false);
        changeVis('Falista 3x6 6.1.g2', false);
        changeVis('Falista 3x6 6.1.z', false);
        changeVis('Horyzontal 3x6 6.1.g', false);
        changeVis('Horyzontal 3x6 6.1.g2', false);
        changeVis('Horyzontal 3x6 6.1.z', false);
        changeVis('Modern Plus 3x6 6.1.g', false);
        changeVis('Modern Plus 3x6 6.1.g2', false);
        changeVis('Modern Plus 3x6 6.1.z', false);
        changeVis('Zaluzja 3x6 6.1.g', false);
        changeVis('Zaluzja 3x6 6.1.g2', false);
        changeVis('Zaluzja 3x6 6.1.z', false);
      } else {
        changeVis('Horyzontal 3x6 6.1.g', true);
      }
    } else if (my_5_b == 1 && _3E == 1) {
      if (isObjectVisible('Horyzontal 3x6 6.1.g2')) {
        changeVis('Falista 3x6 6.1.g', false);
        changeVis('Falista 3x6 6.1.g2', false);
        changeVis('Horyzontal 3x6 6.1.g', false);
        changeVis('Horyzontal 3x6 6.1.g2', false);
        changeVis('Modern Plus 3x6 6.1.g', false);
        changeVis('Modern Plus 3x6 6.1.g2', false);
        changeVis('Zaluzja 3x6 6.1.g', false);
        changeVis('Zaluzja 3x6 6.1.g2', false);
      } else {
        changeVis('Horyzontal 3x6 6.1.g2', true);
      }
    }
  } else if (Wiata2 == 1) {
    if (my_5_b == 1 && _3C == 1) {
      if (isObjectVisible('Horyzontal 6x6 6.1.f')) {
        changeVis('Falista 6x6 6.1.f', false);
        changeVis('Falista 6x6 6.1.g2', false);
        changeVis('Falista 6x6 6.1.f2', false);
        changeVis('Horyzontal 6x6 6.1.f', false);
        changeVis('Horyzontal 6x6 6.1.f2', false);
        changeVis('Horyzontal 6x6 6.1.g2', false);
        changeVis('Modern Plus 6x6 6.1.f', false);
        changeVis('Modern Plus 6x6 6.1.f2', false);
        changeVis('Modern Plus 6x6 6.1.g2', false);
        changeVis('Zaluzja 6x6 6.1.f', false);
        changeVis('Zaluzja 6x6 6.1.f2', false);
        changeVis('Zaluzja 6x6 6.1.g2', false);
      } else {
        changeVis('Horyzontal 6x6 6.1.f', true);
      }
    } else if (my_5_b == 1 && _3E == 1) {
      if (isObjectVisible('Horyzontal 6x6 6.1.f2')) {
        changeVis('Falista 6x6 6.1.f', false);
        changeVis('Falista 6x6 6.1.g', false);
        changeVis('Falista 6x6 6.1.f2', false);
        changeVis('Horyzontal 6x6 6.1.f', false);
        changeVis('Horyzontal 6x6 6.1.f2', false);
        changeVis('Horyzontal 6x6 6.1.g', false);
        changeVis('Modern Plus 6x6 6.1.f', false);
        changeVis('Modern Plus 6x6 6.1.f2', false);
        changeVis('Modern Plus 6x6 6.1.g', false);
        changeVis('Zaluzja 6x6 6.1.f', false);
        changeVis('Zaluzja 6x6 6.1.f2', false);
        changeVis('Zaluzja 6x6 6.1.g', false);
      } else {
        changeVis('Horyzontal 6x6 6.1.f2', true);
      }
    }
  } else if (Wiata3 == 1) {
    if (my_5_b == 1 && _3C == 1) {
      if (isObjectVisible('Horyzontal Wielostan 6.1.f')) {
        changeVis('Falista Wielostan 6.1.f', false);
        changeVis('Falista Wielostan 6.1.g2', false);
        changeVis('Falista Wielostan 6.1.f2', false);
        changeVis('Horyzontal Wielostan 6.1.f', false);
        changeVis('Horyzontal Wielostan 6.1.g2', false);
        changeVis('Horyzontal Wielostan 6.1.f2', false);
        changeVis('Modern Plus Wielostan 6.1.f', false);
        changeVis('Modern Plus Wielostan 6.1.g2', false);
        changeVis('Modern Plus Wielostan 6.1.f2', false);
        changeVis('Zaluzja Wielostan 6.1.f', false);
        changeVis('Zaluzja Wielostan 6.1.g2', false);
        changeVis('Zaluzja Wielostan 6.1.f2', false);
      } else {
        changeVis('Horyzontal Wielostan 6.1.f', true);
      }
    } else if (my_5_b == 1 && _3E == 1) {
      if (isObjectVisible('Horyzontal Wielostan 6.1.f2')) {
        changeVis('Falista Wielostan 6.1.f', false);
        changeVis('Falista Wielostan 6.1.g', false);
        changeVis('Falista Wielostan 6.1.f2', false);
        changeVis('Horyzontal Wielostan 6.1.f', false);
        changeVis('Horyzontal Wielostan 6.1.g', false);
        changeVis('Horyzontal Wielostan 6.1.f2', false);
        changeVis('Modern Plus Wielostan 6.1.f', false);
        changeVis('Modern Plus Wielostan 6.1.g', false);
        changeVis('Modern Plus Wielostan 6.1.f2', false);
        changeVis('Zaluzja Wielostan 6.1.f', false);
        changeVis('Zaluzja Wielostan 6.1.g', false);
        changeVis('Zaluzja Wielostan 6.1.f2', false);
      } else {
        changeVis('Horyzontal Wielostan 6.1.f2', true);
      }
    }
  }
});
eventHTMLElem('click', '6.1.g', true, function(event) {
  if (Wiata1 == 1) {
    if (my_5_c == 1 && _3C == 1) {
      if (isObjectVisible('Modern Plus 3x6 6.1.g')) {
        changeVis('Falista 3x6 6.1.g', false);
        changeVis('Falista 3x6 6.1.g2', false);
        changeVis('Falista 3x6 6.1.z', false);
        changeVis('Horyzontal 3x6 6.1.g', false);
        changeVis('Horyzontal 3x6 6.1.g2', false);
        changeVis('Horyzontal 3x6 6.1.z', false);
        changeVis('Modern Plus 3x6 6.1.g', false);
        changeVis('Modern Plus 3x6 6.1.g2', false);
        changeVis('Modern Plus 3x6 6.1.z', false);
        changeVis('Zaluzja 3x6 6.1.g', false);
        changeVis('Zaluzja 3x6 6.1.g2', false);
        changeVis('Zaluzja 3x6 6.1.z', false);
      } else {
        changeVis('Modern Plus 3x6 6.1.g', true);
      }
    } else if (my_5_c == 1 && _3E == 1) {
      if (isObjectVisible('Modern Plus 3x6 6.1.g2')) {
        changeVis('Falista 3x6 6.1.g', false);
        changeVis('Falista 3x6 6.1.g2', false);
        changeVis('Horyzontal 3x6 6.1.g', false);
        changeVis('Horyzontal 3x6 6.1.g2', false);
        changeVis('Modern Plus 3x6 6.1.g', false);
        changeVis('Modern Plus 3x6 6.1.g2', false);
        changeVis('Zaluzja 3x6 6.1.g', false);
        changeVis('Zaluzja 3x6 6.1.g2', false);
      } else {
        changeVis('Modern Plus 3x6 6.1.g2', true);
      }
    }
  } else if (Wiata2 == 1) {
    if (my_5_c == 1 && _3C == 1) {
      if (isObjectVisible('Modern Plus 6x6 6.1.f')) {
        changeVis('Falista 6x6 6.1.f', false);
        changeVis('Falista 6x6 6.1.g2', false);
        changeVis('Falista 6x6 6.1.f2', false);
        changeVis('Horyzontal 6x6 6.1.f', false);
        changeVis('Horyzontal 6x6 6.1.f2', false);
        changeVis('Horyzontal 6x6 6.1.g2', false);
        changeVis('Modern Plus 6x6 6.1.f', false);
        changeVis('Modern Plus 6x6 6.1.f2', false);
        changeVis('Modern Plus 6x6 6.1.g2', false);
        changeVis('Zaluzja 6x6 6.1.f', false);
        changeVis('Zaluzja 6x6 6.1.f2', false);
        changeVis('Zaluzja 6x6 6.1.g2', false);
      } else {
        changeVis('Modern Plus 6x6 6.1.f', true);
      }
    } else if (my_5_c == 1 && _3E == 1) {
      if (isObjectVisible('Modern Plus 6x6 6.1.f2')) {
        changeVis('Falista 6x6 6.1.f', false);
        changeVis('Falista 6x6 6.1.g', false);
        changeVis('Falista 6x6 6.1.f2', false);
        changeVis('Horyzontal 6x6 6.1.f', false);
        changeVis('Horyzontal 6x6 6.1.f2', false);
        changeVis('Horyzontal 6x6 6.1.g', false);
        changeVis('Modern Plus 6x6 6.1.f', false);
        changeVis('Modern Plus 6x6 6.1.f2', false);
        changeVis('Modern Plus 6x6 6.1.g', false);
        changeVis('Zaluzja 6x6 6.1.f', false);
        changeVis('Zaluzja 6x6 6.1.f2', false);
        changeVis('Zaluzja 6x6 6.1.g', false);
      } else {
        changeVis('Modern Plus 6x6 6.1.f2', true);
      }
    }
  } else if (Wiata3 == 1) {
    if (my_5_c == 1 && _3C == 1) {
      if (isObjectVisible('Modern Plus Wielostan 6.1.f')) {
        changeVis('Falista Wielostan 6.1.f', false);
        changeVis('Falista Wielostan 6.1.g2', false);
        changeVis('Falista Wielostan 6.1.f2', false);
        changeVis('Horyzontal Wielostan 6.1.f', false);
        changeVis('Horyzontal Wielostan 6.1.g2', false);
        changeVis('Horyzontal Wielostan 6.1.f2', false);
        changeVis('Modern Plus Wielostan 6.1.f', false);
        changeVis('Modern Plus Wielostan 6.1.g2', false);
        changeVis('Modern Plus Wielostan 6.1.f2', false);
        changeVis('Zaluzja Wielostan 6.1.f', false);
        changeVis('Zaluzja Wielostan 6.1.g2', false);
        changeVis('Zaluzja Wielostan 6.1.f2', false);
      } else {
        changeVis('Modern Plus Wielostan 6.1.f', true);
      }
    } else if (my_5_c == 1 && _3E == 1) {
      if (isObjectVisible('Modern Plus Wielostan 6.1.f2')) {
        changeVis('Falista Wielostan 6.1.f', false);
        changeVis('Falista Wielostan 6.1.g', false);
        changeVis('Falista Wielostan 6.1.f2', false);
        changeVis('Horyzontal Wielostan 6.1.f', false);
        changeVis('Horyzontal Wielostan 6.1.g', false);
        changeVis('Horyzontal Wielostan 6.1.f2', false);
        changeVis('Modern Plus Wielostan 6.1.f', false);
        changeVis('Modern Plus Wielostan 6.1.g', false);
        changeVis('Modern Plus Wielostan 6.1.f2', false);
        changeVis('Zaluzja Wielostan 6.1.f', false);
        changeVis('Zaluzja Wielostan 6.1.g', false);
        changeVis('Zaluzja Wielostan 6.1.f2', false);
      } else {
        changeVis('Modern Plus Wielostan 6.1.f2', true);
      }
    }
  }
});
eventHTMLElem('click', '6.1.g', true, function(event) {
  if (Wiata1 == 1) {
    if (my_5_d == 1 && _3C == 1) {
      if (isObjectVisible('Zaluzja 3x6 6.1.g')) {
        changeVis('Falista 3x6 6.1.g', false);
        changeVis('Falista 3x6 6.1.g2', false);
        changeVis('Falista 3x6 6.1.z', false);
        changeVis('Horyzontal 3x6 6.1.g', false);
        changeVis('Horyzontal 3x6 6.1.g2', false);
        changeVis('Horyzontal 3x6 6.1.z', false);
        changeVis('Modern Plus 3x6 6.1.g', false);
        changeVis('Modern Plus 3x6 6.1.g2', false);
        changeVis('Modern Plus 3x6 6.1.z', false);
        changeVis('Zaluzja 3x6 6.1.g', false);
        changeVis('Zaluzja 3x6 6.1.g2', false);
        changeVis('Zaluzja 3x6 6.1.z', false);
      } else {
        changeVis('Zaluzja 3x6 6.1.g', true);
      }
    } else if (my_5_d == 1 && _3E == 1) {
      if (isObjectVisible('Zaluzja 3x6 6.1.g2')) {
        changeVis('Falista 3x6 6.1.g', false);
        changeVis('Falista 3x6 6.1.g2', false);
        changeVis('Horyzontal 3x6 6.1.g', false);
        changeVis('Horyzontal 3x6 6.1.g2', false);
        changeVis('Modern Plus 3x6 6.1.g', false);
        changeVis('Modern Plus 3x6 6.1.g2', false);
        changeVis('Zaluzja 3x6 6.1.g', false);
        changeVis('Zaluzja 3x6 6.1.g2', false);
      } else {
        changeVis('Zaluzja 3x6 6.1.g2', true);
      }
    }
  } else if (Wiata2 == 1) {
    if (my_5_d == 1 && _3C == 1) {
      if (isObjectVisible('Zaluzja 6x6 6.1.f')) {
        changeVis('Falista 6x6 6.1.f', false);
        changeVis('Falista 6x6 6.1.g2', false);
        changeVis('Falista 6x6 6.1.f2', false);
        changeVis('Horyzontal 6x6 6.1.f', false);
        changeVis('Horyzontal 6x6 6.1.f2', false);
        changeVis('Horyzontal 6x6 6.1.g2', false);
        changeVis('Modern Plus 6x6 6.1.f', false);
        changeVis('Modern Plus 6x6 6.1.f2', false);
        changeVis('Modern Plus 6x6 6.1.g2', false);
        changeVis('Zaluzja 6x6 6.1.f', false);
        changeVis('Zaluzja 6x6 6.1.f2', false);
        changeVis('Zaluzja 6x6 6.1.g2', false);
      } else {
        changeVis('Zaluzja 6x6 6.1.f', true);
      }
    } else if (my_5_d == 1 && _3E == 1) {
      if (isObjectVisible('Zaluzja 6x6 6.1.f2')) {
        changeVis('Falista 6x6 6.1.f', false);
        changeVis('Falista 6x6 6.1.g', false);
        changeVis('Falista 6x6 6.1.f2', false);
        changeVis('Horyzontal 6x6 6.1.f', false);
        changeVis('Horyzontal 6x6 6.1.f2', false);
        changeVis('Horyzontal 6x6 6.1.g', false);
        changeVis('Modern Plus 6x6 6.1.f', false);
        changeVis('Modern Plus 6x6 6.1.f2', false);
        changeVis('Modern Plus 6x6 6.1.g', false);
        changeVis('Zaluzja 6x6 6.1.f', false);
        changeVis('Zaluzja 6x6 6.1.f2', false);
        changeVis('Zaluzja 6x6 6.1.g', false);
      } else {
        changeVis('Zaluzja 6x6 6.1.f2', true);
      }
    }
  } else if (Wiata3 == 1) {
    if (my_5_d == 1 && _3C == 1) {
      if (isObjectVisible('Zaluzja Wielostan 6.1.f')) {
        changeVis('Falista Wielostan 6.1.f', false);
        changeVis('Falista Wielostan 6.1.g2', false);
        changeVis('Falista Wielostan 6.1.f2', false);
        changeVis('Horyzontal Wielostan 6.1.f', false);
        changeVis('Horyzontal Wielostan 6.1.g2', false);
        changeVis('Horyzontal Wielostan 6.1.f2', false);
        changeVis('Modern Plus Wielostan 6.1.f', false);
        changeVis('Modern Plus Wielostan 6.1.g2', false);
        changeVis('Modern Plus Wielostan 6.1.f2', false);
        changeVis('Zaluzja Wielostan 6.1.f', false);
        changeVis('Zaluzja Wielostan 6.1.g2', false);
        changeVis('Zaluzja Wielostan 6.1.f2', false);
      } else {
        changeVis('Zaluzja Wielostan 6.1.f', true);
      }
    } else if (my_5_d == 1 && _3E == 1) {
      if (isObjectVisible('Zaluzja Wielostan 6.1.f2')) {
        changeVis('Falista Wielostan 6.1.f', false);
        changeVis('Falista Wielostan 6.1.g', false);
        changeVis('Falista Wielostan 6.1.f2', false);
        changeVis('Horyzontal Wielostan 6.1.f', false);
        changeVis('Horyzontal Wielostan 6.1.g', false);
        changeVis('Horyzontal Wielostan 6.1.f2', false);
        changeVis('Modern Plus Wielostan 6.1.f', false);
        changeVis('Modern Plus Wielostan 6.1.g', false);
        changeVis('Modern Plus Wielostan 6.1.f2', false);
        changeVis('Zaluzja Wielostan 6.1.f', false);
        changeVis('Zaluzja Wielostan 6.1.g', false);
        changeVis('Zaluzja Wielostan 6.1.f2', false);
      } else {
        changeVis('Zaluzja Wielostan 6.1.f2', true);
      }
    }
  }
});

eventHTMLElem('click', '6.1.h', true, function(event) {
  if (Wiata2 == 1) {
    if (my_5_a == 1 && _3C == 1) {
      if (isObjectVisible('Falista 6x6 6.1.g')) {
        changeVis('Falista 6x6 6.1.g', false);
        changeVis('Falista 6x6 6.1.g2', false);
        changeVis('Falista 6x6 6.1.z', false);
        changeVis('Horyzontal 6x6 6.1.g', false);
        changeVis('Horyzontal 6x6 6.1.z', false);
        changeVis('Horyzontal 6x6 6.1.g2', false);
        changeVis('Modern Plus 6x6 6.1.g', false);
        changeVis('Modern Plus 6x6 6.1.z', false);
        changeVis('Modern Plus 6x6 6.1.g2', false);
        changeVis('Zaluzja 6x6 6.1.g', false);
        changeVis('Zaluzja 6x6 6.1.z', false);
        changeVis('Zaluzja 6x6 6.1.g2', false);
      } else {
        changeVis('Falista 6x6 6.1.g', true);
      }
    } else if (my_5_a == 1 && _3E == 1) {
      if (isObjectVisible('Falista 6x6 6.1.g2')) {
        changeVis('Falista 6x6 6.1.g', false);
        changeVis('Falista 6x6 6.1.g2', false);
        changeVis('Horyzontal 6x6 6.1.g', false);
        changeVis('Horyzontal 6x6 6.1.g2', false);
        changeVis('Modern Plus 6x6 6.1.g', false);
        changeVis('Modern Plus 6x6 6.1.g2', false);
        changeVis('Zaluzja 6x6 6.1.g', false);
        changeVis('Zaluzja 6x6 6.1.g2', false);
      } else {
        changeVis('Falista 6x6 6.1.g2', true);
      }
    }
  } else if (Wiata3 == 1) {
    if (my_5_a == 1 && _3C == 1) {
      if (isObjectVisible('Falista Wielostan 6.1.g')) {
        changeVis('Falista Wielostan 6.1.g', false);
        changeVis('Falista Wielostan 6.1.g2', false);
        changeVis('Falista Wielostan 6.1.z', false);
        changeVis('Horyzontal Wielostan 6.1.g', false);
        changeVis('Horyzontal Wielostan 6.1.g2', false);
        changeVis('Horyzontal Wielostan 6.1.z', false);
        changeVis('Modern Plus Wielostan 6.1.g', false);
        changeVis('Modern Plus Wielostan 6.1.g2', false);
        changeVis('Modern Plus Wielostan 6.1.z', false);
        changeVis('Zaluzja Wielostan 6.1.g', false);
        changeVis('Zaluzja Wielostan 6.1.g2', false);
        changeVis('Zaluzja Wielostan 6.1.z', false);
      } else {
        changeVis('Falista Wielostan 6.1.g', true);
      }
    } else if (my_5_a == 1 && _3E == 1) {
      if (isObjectVisible('Falista Wielostan 6.1.g2')) {
        changeVis('Falista Wielostan 6.1.g', false);
        changeVis('Falista Wielostan 6.1.g2', false);
        changeVis('Horyzontal Wielostan 6.1.g', false);
        changeVis('Horyzontal Wielostan 6.1.g2', false);
        changeVis('Modern Plus Wielostan 6.1.g', false);
        changeVis('Modern Plus Wielostan 6.1.g2', false);
        changeVis('Zaluzja Wielostan 6.1.g', false);
        changeVis('Zaluzja Wielostan 6.1.g2', false);
      } else {
        changeVis('Falista Wielostan 6.1.g2', true);
      }
    }
  }
});
eventHTMLElem('click', '6.1.h', true, function(event) {
  if (Wiata2 == 1) {
    if (my_5_b == 1 && _3C == 1) {
      if (isObjectVisible('Horyzontal 6x6 6.1.g')) {
        changeVis('Falista 6x6 6.1.g', false);
        changeVis('Falista 6x6 6.1.g2', false);
        changeVis('Falista 6x6 6.1.z', false);
        changeVis('Horyzontal 6x6 6.1.g', false);
        changeVis('Horyzontal 6x6 6.1.z', false);
        changeVis('Horyzontal 6x6 6.1.g2', false);
        changeVis('Modern Plus 6x6 6.1.g', false);
        changeVis('Modern Plus 6x6 6.1.z', false);
        changeVis('Modern Plus 6x6 6.1.g2', false);
        changeVis('Zaluzja 6x6 6.1.g', false);
        changeVis('Zaluzja 6x6 6.1.z', false);
        changeVis('Zaluzja 6x6 6.1.g2', false);
      } else {
        changeVis('Horyzontal 6x6 6.1.g', true);
      }
    } else if (my_5_b == 1 && _3E == 1) {
      if (isObjectVisible('Horyzontal 6x6 6.1.g2')) {
        changeVis('Falista 6x6 6.1.g', false);
        changeVis('Falista 6x6 6.1.g2', false);
        changeVis('Horyzontal 6x6 6.1.g', false);
        changeVis('Horyzontal 6x6 6.1.g2', false);
        changeVis('Modern Plus 6x6 6.1.g', false);
        changeVis('Modern Plus 6x6 6.1.g2', false);
        changeVis('Zaluzja 6x6 6.1.g', false);
        changeVis('Zaluzja 6x6 6.1.g2', false);
      } else {
        changeVis('Horyzontal 6x6 6.1.g2', true);
      }
    }
  } else if (Wiata3 == 1) {
    if (my_5_b == 1 && _3C == 1) {
      if (isObjectVisible('Horyzontal Wielostan 6.1.g')) {
        changeVis('Falista Wielostan 6.1.g', false);
        changeVis('Falista Wielostan 6.1.g2', false);
        changeVis('Falista Wielostan 6.1.z', false);
        changeVis('Horyzontal Wielostan 6.1.g', false);
        changeVis('Horyzontal Wielostan 6.1.g2', false);
        changeVis('Horyzontal Wielostan 6.1.z', false);
        changeVis('Modern Plus Wielostan 6.1.g', false);
        changeVis('Modern Plus Wielostan 6.1.g2', false);
        changeVis('Modern Plus Wielostan 6.1.z', false);
        changeVis('Zaluzja Wielostan 6.1.g', false);
        changeVis('Zaluzja Wielostan 6.1.g2', false);
        changeVis('Zaluzja Wielostan 6.1.z', false);
      } else {
        changeVis('Horyzontal Wielostan 6.1.g', true);
      }
    } else if (my_5_b == 1 && _3E == 1) {
      if (isObjectVisible('Horyzontal Wielostan 6.1.g2')) {
        changeVis('Falista Wielostan 6.1.g', false);
        changeVis('Falista Wielostan 6.1.g2', false);
        changeVis('Horyzontal Wielostan 6.1.g', false);
        changeVis('Horyzontal Wielostan 6.1.g2', false);
        changeVis('Modern Plus Wielostan 6.1.g', false);
        changeVis('Modern Plus Wielostan 6.1.g2', false);
        changeVis('Zaluzja Wielostan 6.1.g', false);
        changeVis('Zaluzja Wielostan 6.1.g2', false);
      } else {
        changeVis('Horyzontal Wielostan 6.1.g2', true);
      }
    }
  }
});
eventHTMLElem('click', '6.1.h', true, function(event) {
  if (Wiata2 == 1) {
    if (my_5_c == 1 && _3C == 1) {
      if (isObjectVisible('Modern Plus 6x6 6.1.g')) {
        changeVis('Falista 6x6 6.1.g', false);
        changeVis('Falista 6x6 6.1.g2', false);
        changeVis('Falista 6x6 6.1.z', false);
        changeVis('Horyzontal 6x6 6.1.g', false);
        changeVis('Horyzontal 6x6 6.1.z', false);
        changeVis('Horyzontal 6x6 6.1.g2', false);
        changeVis('Modern Plus 6x6 6.1.g', false);
        changeVis('Modern Plus 6x6 6.1.z', false);
        changeVis('Modern Plus 6x6 6.1.g2', false);
        changeVis('Zaluzja 6x6 6.1.g', false);
        changeVis('Zaluzja 6x6 6.1.z', false);
        changeVis('Zaluzja 6x6 6.1.g2', false);
      } else {
        changeVis('Modern Plus 6x6 6.1.g', true);
      }
    } else if (my_5_c == 1 && _3E == 1) {
      if (isObjectVisible('Modern Plus 6x6 6.1.g2')) {
        changeVis('Falista 6x6 6.1.g', false);
        changeVis('Falista 6x6 6.1.g2', false);
        changeVis('Horyzontal 6x6 6.1.g', false);
        changeVis('Horyzontal 6x6 6.1.g2', false);
        changeVis('Modern Plus 6x6 6.1.g', false);
        changeVis('Modern Plus 6x6 6.1.g2', false);
        changeVis('Zaluzja 6x6 6.1.g', false);
        changeVis('Zaluzja 6x6 6.1.g2', false);
      } else {
        changeVis('Modern Plus 6x6 6.1.g2', true);
      }
    }
  } else if (Wiata3 == 1) {
    if (my_5_c == 1 && _3C == 1) {
      if (isObjectVisible('Modern Plus Wielostan 6.1.g')) {
        changeVis('Falista Wielostan 6.1.g', false);
        changeVis('Falista Wielostan 6.1.g2', false);
        changeVis('Falista Wielostan 6.1.z', false);
        changeVis('Horyzontal Wielostan 6.1.g', false);
        changeVis('Horyzontal Wielostan 6.1.g2', false);
        changeVis('Horyzontal Wielostan 6.1.z', false);
        changeVis('Modern Plus Wielostan 6.1.g', false);
        changeVis('Modern Plus Wielostan 6.1.g2', false);
        changeVis('Modern Plus Wielostan 6.1.z', false);
        changeVis('Zaluzja Wielostan 6.1.g', false);
        changeVis('Zaluzja Wielostan 6.1.g2', false);
        changeVis('Zaluzja Wielostan 6.1.z', false);
      } else {
        changeVis('Modern Plus Wielostan 6.1.g', true);
      }
    } else if (my_5_c == 1 && _3E == 1) {
      if (isObjectVisible('Modern Plus Wielostan 6.1.g2')) {
        changeVis('Falista Wielostan 6.1.g', false);
        changeVis('Falista Wielostan 6.1.g2', false);
        changeVis('Horyzontal Wielostan 6.1.g', false);
        changeVis('Horyzontal Wielostan 6.1.g2', false);
        changeVis('Modern Plus Wielostan 6.1.g', false);
        changeVis('Modern Plus Wielostan 6.1.g2', false);
        changeVis('Zaluzja Wielostan 6.1.g', false);
        changeVis('Zaluzja Wielostan 6.1.g2', false);
      } else {
        changeVis('Modern Plus Wielostan 6.1.g2', true);
      }
    }
  }
});
eventHTMLElem('click', '6.1.h', true, function(event) {
  if (Wiata2 == 1) {
    if (my_5_d == 1 && _3C == 1) {
      if (isObjectVisible('Zaluzja 6x6 6.1.g')) {
        changeVis('Falista 6x6 6.1.g', false);
        changeVis('Falista 6x6 6.1.g2', false);
        changeVis('Falista 6x6 6.1.z', false);
        changeVis('Horyzontal 6x6 6.1.g', false);
        changeVis('Horyzontal 6x6 6.1.z', false);
        changeVis('Horyzontal 6x6 6.1.g2', false);
        changeVis('Modern Plus 6x6 6.1.g', false);
        changeVis('Modern Plus 6x6 6.1.z', false);
        changeVis('Modern Plus 6x6 6.1.g2', false);
        changeVis('Zaluzja 6x6 6.1.g', false);
        changeVis('Zaluzja 6x6 6.1.z', false);
        changeVis('Zaluzja 6x6 6.1.g2', false);
      } else {
        changeVis('Zaluzja 6x6 6.1.g', true);
      }
    } else if (my_5_d == 1 && _3E == 1) {
      if (isObjectVisible('Zaluzja 6x6 6.1.g2')) {
        changeVis('Falista 6x6 6.1.g', false);
        changeVis('Falista 6x6 6.1.g2', false);
        changeVis('Horyzontal 6x6 6.1.g', false);
        changeVis('Horyzontal 6x6 6.1.g2', false);
        changeVis('Modern Plus 6x6 6.1.g', false);
        changeVis('Modern Plus 6x6 6.1.g2', false);
        changeVis('Zaluzja 6x6 6.1.g', false);
        changeVis('Zaluzja 6x6 6.1.g2', false);
      } else {
        changeVis('Zaluzja 6x6 6.1.g2', true);
      }
    }
  } else if (Wiata3 == 1) {
    if (my_5_d == 1 && _3C == 1) {
      if (isObjectVisible('Zaluzja Wielostan 6.1.g')) {
        changeVis('Falista Wielostan 6.1.g', false);
        changeVis('Falista Wielostan 6.1.g2', false);
        changeVis('Falista Wielostan 6.1.z', false);
        changeVis('Horyzontal Wielostan 6.1.g', false);
        changeVis('Horyzontal Wielostan 6.1.g2', false);
        changeVis('Horyzontal Wielostan 6.1.z', false);
        changeVis('Modern Plus Wielostan 6.1.g', false);
        changeVis('Modern Plus Wielostan 6.1.g2', false);
        changeVis('Modern Plus Wielostan 6.1.z', false);
        changeVis('Zaluzja Wielostan 6.1.g', false);
        changeVis('Zaluzja Wielostan 6.1.g2', false);
        changeVis('Zaluzja Wielostan 6.1.z', false);
      } else {
        changeVis('Zaluzja Wielostan 6.1.g', true);
      }
    } else if (my_5_d == 1 && _3E == 1) {
      if (isObjectVisible('Zaluzja Wielostan 6.1.g2')) {
        changeVis('Falista Wielostan 6.1.g', false);
        changeVis('Falista Wielostan 6.1.g2', false);
        changeVis('Horyzontal Wielostan 6.1.g', false);
        changeVis('Horyzontal Wielostan 6.1.g2', false);
        changeVis('Modern Plus Wielostan 6.1.g', false);
        changeVis('Modern Plus Wielostan 6.1.g2', false);
        changeVis('Zaluzja Wielostan 6.1.g', false);
        changeVis('Zaluzja Wielostan 6.1.g2', false);
      } else {
        changeVis('Zaluzja Wielostan 6.1.g2', true);
      }
    }
  }
});

eventHTMLElem('click', '6.1.y', true, function(event) {
  if (Wiata1 == 1) {
    if (my_5_a == 1 && _3E == 1) {
      if (isObjectVisible('Falista 3x6 6.1.y')) {
        changeVis('Falista 3x6 6.1.c', false);
        changeVis('Falista 3x6 6.1.y', false);
        changeVis('Horyzontal 3x6 6.1.c', false);
        changeVis('Horyzontal 3x6 6.1.y', false);
        changeVis('Modern Plus 3x6 6.1.c', false);
        changeVis('Modern Plus 3x6 6.1.y', false);
        changeVis('Zaluzja 3x6 6.1.c', false);
        changeVis('Zaluzja 3x6 6.1.y', false);
      } else {
        changeVis('Falista 3x6 6.1.y', true);
      }
    }
  } else if (Wiata2 == 1) {
    if (my_5_a == 1 && _3E == 1) {
      if (isObjectVisible('Falista 6x6 6.1.y')) {
        changeVis('Falista 6x6 6.1.c', false);
        changeVis('Falista 6x6 6.1.y', false);
        changeVis('Horyzontal 6x6 6.1.c', false);
        changeVis('Horyzontal 6x6 6.1.y', false);
        changeVis('Modern Plus 6x6 6.1.c', false);
        changeVis('Modern Plus 6x6 6.1.y', false);
        changeVis('Zaluzja 6x6 6.1.c', false);
        changeVis('Zaluzja 6x6 6.1.y', false);
      } else {
        changeVis('Falista 6x6 6.1.y', true);
      }
    }
  } else if (Wiata3 == 1) {
    if (my_5_a == 1 && _3E == 1) {
      if (isObjectVisible('Falista 6x6 6.1.y')) {
        changeVis('Falista 6x6 6.1.c', false);
        changeVis('Falista 6x6 6.1.y', false);
        changeVis('Horyzontal 6x6 6.1.c', false);
        changeVis('Horyzontal 6x6 6.1.y', false);
        changeVis('Modern Plus 6x6 6.1.c', false);
        changeVis('Modern Plus 6x6 6.1.y', false);
        changeVis('Zaluzja 6x6 6.1.c', false);
        changeVis('Zaluzja 6x6 6.1.y', false);
      } else {
        changeVis('Falista 6x6 6.1.y', true);
      }
    }
  }
});
eventHTMLElem('click', '6.1.y', true, function(event) {
  if (Wiata1 == 1) {
    if (my_5_b == 1 && _3E == 1) {
      if (isObjectVisible('Horyzontal 3x6 6.1.y')) {
        changeVis('Falista 3x6 6.1.c', false);
        changeVis('Falista 3x6 6.1.y', false);
        changeVis('Horyzontal 3x6 6.1.c', false);
        changeVis('Horyzontal 3x6 6.1.y', false);
        changeVis('Modern Plus 3x6 6.1.c', false);
        changeVis('Modern Plus 3x6 6.1.y', false);
        changeVis('Zaluzja 3x6 6.1.c', false);
        changeVis('Zaluzja 3x6 6.1.y', false);
      } else {
        changeVis('Horyzontal 3x6 6.1.y', true);
      }
    }
  } else if (Wiata2 == 1) {
    if (my_5_b == 1 && _3E == 1) {
      if (isObjectVisible('Horyzontal 6x6 6.1.y')) {
        changeVis('Falista 6x6 6.1.c', false);
        changeVis('Falista 6x6 6.1.y', false);
        changeVis('Horyzontal 6x6 6.1.c', false);
        changeVis('Horyzontal 6x6 6.1.y', false);
        changeVis('Modern Plus 6x6 6.1.c', false);
        changeVis('Modern Plus 6x6 6.1.y', false);
        changeVis('Zaluzja 6x6 6.1.c', false);
        changeVis('Zaluzja 6x6 6.1.y', false);
      } else {
        changeVis('Horyzontal 6x6 6.1.y', true);
      }
    }
  } else if (Wiata3 == 1) {
    if (my_5_b == 1 && _3E == 1) {
      if (isObjectVisible('Horyzontal 6x6 6.1.y')) {
        changeVis('Falista 6x6 6.1.c', false);
        changeVis('Falista 6x6 6.1.y', false);
        changeVis('Horyzontal 6x6 6.1.c', false);
        changeVis('Horyzontal 6x6 6.1.y', false);
        changeVis('Modern Plus 6x6 6.1.c', false);
        changeVis('Modern Plus 6x6 6.1.y', false);
        changeVis('Zaluzja 6x6 6.1.c', false);
        changeVis('Zaluzja 6x6 6.1.y', false);
      } else {
        changeVis('Horyzontal 6x6 6.1.y', true);
      }
    }
  }
});
eventHTMLElem('click', '6.1.y', true, function(event) {
  if (Wiata1 == 1) {
    if (my_5_c == 1 && _3E == 1) {
      if (isObjectVisible('Modern Plus 3x6 6.1.y')) {
        changeVis('Falista 3x6 6.1.c', false);
        changeVis('Falista 3x6 6.1.y', false);
        changeVis('Horyzontal 3x6 6.1.c', false);
        changeVis('Horyzontal 3x6 6.1.y', false);
        changeVis('Modern Plus 3x6 6.1.c', false);
        changeVis('Modern Plus 3x6 6.1.y', false);
        changeVis('Zaluzja 3x6 6.1.c', false);
        changeVis('Zaluzja 3x6 6.1.y', false);
      } else {
        changeVis('Modern Plus 3x6 6.1.y', true);
      }
    }
  } else if (Wiata2 == 1) {
    if (my_5_c == 1 && _3E == 1) {
      if (isObjectVisible('Modern Plus 6x6 6.1.y')) {
        changeVis('Falista 6x6 6.1.c', false);
        changeVis('Falista 6x6 6.1.y', false);
        changeVis('Horyzontal 6x6 6.1.c', false);
        changeVis('Horyzontal 6x6 6.1.y', false);
        changeVis('Modern Plus 6x6 6.1.c', false);
        changeVis('Modern Plus 6x6 6.1.y', false);
        changeVis('Zaluzja 6x6 6.1.c', false);
        changeVis('Zaluzja 6x6 6.1.y', false);
      } else {
        changeVis('Modern Plus 6x6 6.1.y', true);
      }
    }
  } else if (Wiata3 == 1) {
    if (my_5_c == 1 && _3E == 1) {
      if (isObjectVisible('Modern Plus 6x6 6.1.y')) {
        changeVis('Falista 6x6 6.1.c', false);
        changeVis('Falista 6x6 6.1.y', false);
        changeVis('Horyzontal 6x6 6.1.c', false);
        changeVis('Horyzontal 6x6 6.1.y', false);
        changeVis('Modern Plus 6x6 6.1.c', false);
        changeVis('Modern Plus 6x6 6.1.y', false);
        changeVis('Zaluzja 6x6 6.1.c', false);
        changeVis('Zaluzja 6x6 6.1.y', false);
      } else {
        changeVis('Modern Plus 6x6 6.1.y', true);
      }
    }
  }
});
eventHTMLElem('click', '6.1.y', true, function(event) {
  if (Wiata1 == 1) {
    if (my_5_d == 1 && _3E == 1) {
      if (isObjectVisible('Zaluzja 3x6 6.1.y')) {
        changeVis('Falista 3x6 6.1.c', false);
        changeVis('Falista 3x6 6.1.y', false);
        changeVis('Horyzontal 3x6 6.1.c', false);
        changeVis('Horyzontal 3x6 6.1.y', false);
        changeVis('Modern Plus 3x6 6.1.c', false);
        changeVis('Modern Plus 3x6 6.1.y', false);
        changeVis('Zaluzja 3x6 6.1.c', false);
        changeVis('Zaluzja 3x6 6.1.y', false);
      } else {
        changeVis('Zaluzja 3x6 6.1.y', true);
      }
    }
  } else if (Wiata2 == 1) {
    if (my_5_d == 1 && _3E == 1) {
      if (isObjectVisible('Zaluzja 6x6 6.1.y')) {
        changeVis('Falista 6x6 6.1.c', false);
        changeVis('Falista 6x6 6.1.y', false);
        changeVis('Horyzontal 6x6 6.1.c', false);
        changeVis('Horyzontal 6x6 6.1.y', false);
        changeVis('Modern Plus 6x6 6.1.c', false);
        changeVis('Modern Plus 6x6 6.1.y', false);
        changeVis('Zaluzja 6x6 6.1.c', false);
        changeVis('Zaluzja 6x6 6.1.y', false);
      } else {
        changeVis('Zaluzja 6x6 6.1.y', true);
      }
    }
  } else if (Wiata3 == 1) {
    if (my_5_d == 1 && _3E == 1) {
      if (isObjectVisible('Zaluzja 6x6 6.1.y')) {
        changeVis('Falista 6x6 6.1.c', false);
        changeVis('Falista 6x6 6.1.y', false);
        changeVis('Horyzontal 6x6 6.1.c', false);
        changeVis('Horyzontal 6x6 6.1.y', false);
        changeVis('Modern Plus 6x6 6.1.c', false);
        changeVis('Modern Plus 6x6 6.1.y', false);
        changeVis('Zaluzja 6x6 6.1.c', false);
        changeVis('Zaluzja 6x6 6.1.y', false);
      } else {
        changeVis('Zaluzja 6x6 6.1.y', true);
      }
    }
  }
});

eventHTMLElem('click', '6.1.z', true, function(event) {
  if (Wiata1 == 1) {
    if (my_5_a == 1 && _3E == 1) {
      if (isObjectVisible('Falista 3x6 6.1.z')) {
        changeVis('Falista 3x6 6.1.g', false);
        changeVis('Falista 3x6 6.1.z', false);
        changeVis('Horyzontal 3x6 6.1.g', false);
        changeVis('Horyzontal 3x6 6.1.z', false);
        changeVis('Modern Plus 3x6 6.1.g', false);
        changeVis('Modern Plus 3x6 6.1.z', false);
        changeVis('Zaluzja 3x6 6.1.g', false);
        changeVis('Zaluzja 3x6 6.1.z', false);
      } else {
        changeVis('Falista 3x6 6.1.z', true);
      }
    }
  } else if (Wiata2 == 1) {
    if (my_5_a == 1 && _3E == 1) {
      if (isObjectVisible('Falista 6x6 6.1.z')) {
        changeVis('Falista 6x6 6.1.g', false);
        changeVis('Falista 6x6 6.1.z', false);
        changeVis('Horyzontal 6x6 6.1.g', false);
        changeVis('Horyzontal 6x6 6.1.z', false);
        changeVis('Modern Plus 6x6 6.1.g', false);
        changeVis('Modern Plus 6x6 6.1.z', false);
        changeVis('Zaluzja 6x6 6.1.g', false);
        changeVis('Zaluzja 6x6 6.1.z', false);
      } else {
        changeVis('Falista 6x6 6.1.z', true);
      }
    }
  } else if (Wiata3 == 1) {
    if (my_5_a == 1 && _3E == 1) {
      if (isObjectVisible('Falista Wielostan 6.1.z')) {
        changeVis('Falista Wielostan 6.1.g', false);
        changeVis('Falista Wielostan 6.1.z', false);
        changeVis('Horyzontal Wielostan 6.1.g', false);
        changeVis('Horyzontal Wielostan 6.1.z', false);
        changeVis('Modern Plus Wielostan 6.1.g', false);
        changeVis('Modern Plus Wielostan 6.1.z', false);
        changeVis('Zaluzja Wielostan 6.1.g', false);
        changeVis('Zaluzja Wielostan 6.1.z', false);
      } else {
        changeVis('Falista Wielostan 6.1.z', true);
      }
    }
  }
});
eventHTMLElem('click', '6.1.z', true, function(event) {
  if (Wiata1 == 1) {
    if (my_5_b == 1 && _3E == 1) {
      if (isObjectVisible('Horyzontal 3x6 6.1.z')) {
        changeVis('Falista 3x6 6.1.g', false);
        changeVis('Falista 3x6 6.1.z', false);
        changeVis('Horyzontal 3x6 6.1.g', false);
        changeVis('Horyzontal 3x6 6.1.z', false);
        changeVis('Modern Plus 3x6 6.1.g', false);
        changeVis('Modern Plus 3x6 6.1.z', false);
        changeVis('Zaluzja 3x6 6.1.g', false);
        changeVis('Zaluzja 3x6 6.1.z', false);
      } else {
        changeVis('Horyzontal 3x6 6.1.z', true);
      }
    }
  } else if (Wiata2 == 1) {
    if (my_5_b == 1 && _3E == 1) {
      if (isObjectVisible('Horyzontal 6x6 6.1.z')) {
        changeVis('Falista 6x6 6.1.g', false);
        changeVis('Falista 6x6 6.1.z', false);
        changeVis('Horyzontal 6x6 6.1.g', false);
        changeVis('Horyzontal 6x6 6.1.z', false);
        changeVis('Modern Plus 6x6 6.1.g', false);
        changeVis('Modern Plus 6x6 6.1.z', false);
        changeVis('Zaluzja 6x6 6.1.g', false);
        changeVis('Zaluzja 6x6 6.1.z', false);
      } else {
        changeVis('Horyzontal 6x6 6.1.z', true);
      }
    }
  } else if (Wiata3 == 1) {
    if (my_5_b == 1 && _3E == 1) {
      if (isObjectVisible('Horyzontal Wielostan 6.1.z')) {
        changeVis('Falista Wielostan 6.1.g', false);
        changeVis('Falista Wielostan 6.1.z', false);
        changeVis('Horyzontal Wielostan 6.1.g', false);
        changeVis('Horyzontal Wielostan 6.1.z', false);
        changeVis('Modern Plus Wielostan 6.1.g', false);
        changeVis('Modern Plus Wielostan 6.1.z', false);
        changeVis('Zaluzja Wielostan 6.1.g', false);
        changeVis('Zaluzja Wielostan 6.1.z', false);
      } else {
        changeVis('Horyzontal Wielostan 6.1.z', true);
      }
    }
  }
});
eventHTMLElem('click', '6.1.z', true, function(event) {
  if (Wiata1 == 1) {
    if (my_5_c == 1 && _3E == 1) {
      if (isObjectVisible('Modern Plus 3x6 6.1.z')) {
        changeVis('Falista 3x6 6.1.g', false);
        changeVis('Falista 3x6 6.1.z', false);
        changeVis('Horyzontal 3x6 6.1.g', false);
        changeVis('Horyzontal 3x6 6.1.z', false);
        changeVis('Modern Plus 3x6 6.1.g', false);
        changeVis('Modern Plus 3x6 6.1.z', false);
        changeVis('Zaluzja 3x6 6.1.g', false);
        changeVis('Zaluzja 3x6 6.1.z', false);
      } else {
        changeVis('Modern Plus 3x6 6.1.z', true);
      }
    }
  } else if (Wiata2 == 1) {
    if (my_5_c == 1 && _3E == 1) {
      if (isObjectVisible('Modern Plus 6x6 6.1.z')) {
        changeVis('Falista 6x6 6.1.g', false);
        changeVis('Falista 6x6 6.1.z', false);
        changeVis('Horyzontal 6x6 6.1.g', false);
        changeVis('Horyzontal 6x6 6.1.z', false);
        changeVis('Modern Plus 6x6 6.1.g', false);
        changeVis('Modern Plus 6x6 6.1.z', false);
        changeVis('Zaluzja 6x6 6.1.g', false);
        changeVis('Zaluzja 6x6 6.1.z', false);
      } else {
        changeVis('Modern Plus 6x6 6.1.z', true);
      }
    }
  } else if (Wiata3 == 1) {
    if (my_5_c == 1 && _3E == 1) {
      if (isObjectVisible('Modern Plus Wielostan 6.1.z')) {
        changeVis('Falista Wielostan 6.1.g', false);
        changeVis('Falista Wielostan 6.1.z', false);
        changeVis('Horyzontal Wielostan 6.1.g', false);
        changeVis('Horyzontal Wielostan 6.1.z', false);
        changeVis('Modern Plus Wielostan 6.1.g', false);
        changeVis('Modern Plus Wielostan 6.1.z', false);
        changeVis('Zaluzja Wielostan 6.1.g', false);
        changeVis('Zaluzja Wielostan 6.1.z', false);
      } else {
        changeVis('Modern Plus Wielostan 6.1.z', true);
      }
    }
  }
});
eventHTMLElem('click', '6.1.z', true, function(event) {
  if (Wiata1 == 1) {
    if (my_5_d == 1 && _3E == 1) {
      if (isObjectVisible('Zaluzja 3x6 6.1.z')) {
        changeVis('Falista 3x6 6.1.g', false);
        changeVis('Falista 3x6 6.1.z', false);
        changeVis('Horyzontal 3x6 6.1.g', false);
        changeVis('Horyzontal 3x6 6.1.z', false);
        changeVis('Modern Plus 3x6 6.1.g', false);
        changeVis('Modern Plus 3x6 6.1.z', false);
        changeVis('Zaluzja 3x6 6.1.g', false);
        changeVis('Zaluzja 3x6 6.1.z', false);
      } else {
        changeVis('Zaluzja 3x6 6.1.z', true);
      }
    }
  } else if (Wiata2 == 1) {
    if (my_5_d == 1 && _3E == 1) {
      if (isObjectVisible('Zaluzja 6x6 6.1.z')) {
        changeVis('Falista 6x6 6.1.g', false);
        changeVis('Falista 6x6 6.1.z', false);
        changeVis('Horyzontal 6x6 6.1.g', false);
        changeVis('Horyzontal 6x6 6.1.z', false);
        changeVis('Modern Plus 6x6 6.1.g', false);
        changeVis('Modern Plus 6x6 6.1.z', false);
        changeVis('Zaluzja 6x6 6.1.g', false);
        changeVis('Zaluzja 6x6 6.1.z', false);
      } else {
        changeVis('Zaluzja 6x6 6.1.z', true);
      }
    }
  } else if (Wiata3 == 1) {
    if (my_5_d == 1 && _3E == 1) {
      if (isObjectVisible('Zaluzja Wielostan 6.1.z')) {
        changeVis('Falista Wielostan 6.1.g', false);
        changeVis('Falista Wielostan 6.1.z', false);
        changeVis('Horyzontal Wielostan 6.1.g', false);
        changeVis('Horyzontal Wielostan 6.1.z', false);
        changeVis('Modern Plus Wielostan 6.1.g', false);
        changeVis('Modern Plus Wielostan 6.1.z', false);
        changeVis('Zaluzja Wielostan 6.1.g', false);
        changeVis('Zaluzja Wielostan 6.1.z', false);
      } else {
        changeVis('Zaluzja Wielostan 6.1.z', true);
      }
    }
  }
});

// Wiata 3x6 wybór koloru dachu
eventHTMLElem('click', '5.a', true, function(event) {
  assignMat(['GROUP', 'Falista 3x6'], 'Metal Gray');
  assignMat(['GROUP', 'Falista 6x6'], 'Metal Gray');
  assignMat(['GROUP', 'Falista Wielostan'], 'Metal Gray');
  assignMat(['GROUP', 'Horyzontal 3x6'], 'Metal Gray');
  assignMat(['GROUP', 'Horyzontal 6x6'], 'Metal Gray');
  assignMat(['GROUP', 'Modern Plus 3x6'], 'Metal Gray');
  assignMat(['GROUP', 'Modern Plus 6x6'], 'Metal Gray');
  assignMat(['GROUP', 'Zaluzja 3x6'], 'Metal Gray');
  assignMat(['GROUP', 'Zaluzja 6x6'], 'Metal Gray');
});
// Wiata 3x6 wybór koloru dachu
eventHTMLElem('click', '7.a', true, function(event) {
  assignMat(['GROUP', 'Horyzontal Wielostan'], 'Metal Gray');
  assignMat(['GROUP', 'Modern Plus Wielostan'], 'Metal Gray');
  assignMat(['GROUP', 'Zaluzja Wielostan'], 'Metal Gray');
  assignMat(['GROUP', 'Falista 3x6'], 'Metal Gray');
  assignMat(['GROUP', 'Falista 6x6'], 'Metal Gray');
  assignMat(['GROUP', 'Falista Wielostan'], 'Metal Gray');
  assignMat(['GROUP', 'Horyzontal 3x6'], 'Metal Gray');
  assignMat(['GROUP', 'Horyzontal 6x6'], 'Metal Gray');
  assignMat(['GROUP', 'Modern Plus 3x6'], 'Metal Gray');
  assignMat(['GROUP', 'Modern Plus 6x6'], 'Metal Gray');
  assignMat(['GROUP', 'Zaluzja 3x6'], 'Metal Gray');
  assignMat(['GROUP', 'Zaluzja 6x6'], 'Metal Gray');
});
// Wiata 3x6 wybór koloru dachu
eventHTMLElem('click', '7.b', true, function(event) {
  assignMat(['GROUP', 'Horyzontal Wielostan'], 'Bronze');
  assignMat(['GROUP', 'Horyzontal 3x6'], 'Bronze');
  assignMat(['GROUP', 'Horyzontal 6x6'], 'Bronze');
  assignMat(['GROUP', 'Modern Plus Wielostan'], 'Bronze');
  assignMat(['GROUP', 'Modern Plus 3x6'], 'Bronze');
  assignMat(['GROUP', 'Modern Plus 6x6'], 'Bronze');
  assignMat(['GROUP', 'Zaluzja Wielostan'], 'Bronze');
  assignMat(['GROUP', 'Zaluzja 3x6'], 'Bronze');
  assignMat(['GROUP', 'Zaluzja 6x6'], 'Bronze');
});
// Wiata 3x6 wybór koloru dachu
eventHTMLElem('click', '7.c', true, function(event) {
  assignMat(['GROUP', 'Horyzontal Wielostan'], 'Bronze Light');
  assignMat(['GROUP', 'Horyzontal 3x6'], 'Bronze Light');
  assignMat(['GROUP', 'Horyzontal 6x6'], 'Bronze Light');
  assignMat(['GROUP', 'Modern Plus Wielostan'], 'Bronze Light');
  assignMat(['GROUP', 'Modern Plus 3x6'], 'Bronze Light');
  assignMat(['GROUP', 'Modern Plus 6x6'], 'Bronze Light');
  assignMat(['GROUP', 'Zaluzja Wielostan'], 'Bronze Light');
  assignMat(['GROUP', 'Zaluzja 3x6'], 'Bronze Light');
  assignMat(['GROUP', 'Zaluzja 6x6'], 'Bronze Light');
});
// Wiata 3x6 wybór koloru dachu
eventHTMLElem('click', '7.d', true, function(event) {
  assignMat(['GROUP', 'Horyzontal Wielostan'], 'Silver');
  assignMat(['GROUP', 'Horyzontal 3x6'], 'Silver');
  assignMat(['GROUP', 'Horyzontal 6x6'], 'Silver');
  assignMat(['GROUP', 'Modern Plus Wielostan'], 'Silver');
  assignMat(['GROUP', 'Modern Plus 3x6'], 'Silver');
  assignMat(['GROUP', 'Modern Plus 6x6'], 'Silver');
  assignMat(['GROUP', 'Zaluzja Wielostan'], 'Silver');
  assignMat(['GROUP', 'Zaluzja 3x6'], 'Silver');
  assignMat(['GROUP', 'Zaluzja 6x6'], 'Silver');
});
// Wiata 3x6 wybór koloru dachu
eventHTMLElem('click', '7.e', true, function(event) {
  assignMat(['GROUP', 'Horyzontal Wielostan'], 'Black');
  assignMat(['GROUP', 'Horyzontal 3x6'], 'Black');
  assignMat(['GROUP', 'Horyzontal 6x6'], 'Black');
  assignMat(['GROUP', 'Modern Plus Wielostan'], 'Black');
  assignMat(['GROUP', 'Modern Plus 3x6'], 'Black');
  assignMat(['GROUP', 'Modern Plus 6x6'], 'Black');
  assignMat(['GROUP', 'Zaluzja Wielostan'], 'Black');
  assignMat(['GROUP', 'Zaluzja 3x6'], 'Black');
  assignMat(['GROUP', 'Zaluzja 6x6'], 'Black');
});
// Wiata 3x6 wybór koloru dachu
eventHTMLElem('click', '7.f', true, function(event) {
  assignMat(['GROUP', 'Horyzontal Wielostan'], 'White');
  assignMat(['GROUP', 'Horyzontal 3x6'], 'White');
  assignMat(['GROUP', 'Horyzontal 6x6'], 'White');
  assignMat(['GROUP', 'Modern Plus Wielostan'], 'White');
  assignMat(['GROUP', 'Modern Plus 3x6'], 'White');
  assignMat(['GROUP', 'Modern Plus 6x6'], 'White');
  assignMat(['GROUP', 'Zaluzja Wielostan'], 'White');
  assignMat(['GROUP', 'Zaluzja 3x6'], 'White');
  assignMat(['GROUP', 'Zaluzja 6x6'], 'White');
});

eventHTMLElem('click', '1.e', false, function(event) {
  if (PomL == 1 && PomP == 0) {
    changeVis(['GROUP', 'PG lewe'], true);
    changeVis(['GROUP', 'PG prawe'], false);
    changeVis('PG lewe profil 900 1', false);
    changeVis('PG lewe profil 900 2', false);
    changeVis('PG lewe profil 3', false);
  } else if (PomL == 0 && PomP == 1) {
    changeVis(['GROUP', 'PG prawe'], true);
    changeVis(['GROUP', 'PG lewe'], false);
    changeVis('PG prawe profil 900 1', false);
    changeVis('PG prawe profil 900 2', false);
    changeVis('PG prawe profil 3', false);
  }
});

eventHTMLElem('click', '1.d', true, function(event) {
  if (GaL == 1 && GaP == 0) {
    changeVis(['GROUP', 'Garaż lewy'], true);
    changeVis(['GROUP', 'Garaż prawy'], false);
    changeVis('Profil garaż lewy  2 900', false);
    changeVis('Profil garaż lewy  4 900', false);
    changeVis('Profil garaż lewy  3', false);
  } else if (GaL == 0 && GaP == 1) {
    changeVis(['GROUP', 'Garaż prawy'], true);
    changeVis(['GROUP', 'Garaż lewy'], false);
    changeVis('Profil garaż prawy 2 900', false);
    changeVis('Profil garaż prawy 4 900', false);
    changeVis('Profil garaż prawy 3', false);
  } else if (GaL == 1 && GaP == 1) {
    changeVis(['GROUP', 'Garaż prawy'], true);
    changeVis(['GROUP', 'Garaż lewy'], true);
    changeVis('Profil garaż lewy  2 900', false);
    changeVis('Profil garaż lewy  4 900', false);
    changeVis('Profil garaż lewy  3', false);
    changeVis('Profil garaż prawy 2 900', false);
    changeVis('Profil garaż prawy 4 900', false);
    changeVis('Profil garaż prawy 3', false);
  } else if (GaL == 0 && GaP == 0) {
    changeVis(['GROUP', 'Garaż lewy'], true);
    changeVis(['GROUP', 'Garaż prawy'], false);
    changeVis('Profil garaż lewy  2 900', false);
    changeVis('Profil garaż lewy  4 900', false);
    changeVis('Profil garaż lewy  3', false);
  }
});

eventHTMLElem('input', 'slider2', true, function(event) {});

eventHTMLElem('click', '3.1.a', true, function(event) {
  if (isObjectVisible(['GROUP', 'Garaż lewy'])) {
    GaP = 0;
    GaL = 0;
    changeVis(['GROUP', 'Garaż lewy'], false);
    changeVis(['GROUP', 'PG tył'], false);
    changeVis(['GROUP', 'PG lewe'], false);
    changeVis(['GROUP', 'PG prawe'], false);
  } else {
    GaP = 0;
    GaL = 1;
    if (getHTMLElemAttribute('value', 'slider2', true) < '0.599') {
      _3C = 1;
      _3E = 0;
      changeVis('Drzwi lewe', true);
      changeVis('Panel 1 lewy ', true);
      changeVis('Panel 2 lewy ', true);
      changeVis('Panel 3 lewy ', true);
      changeVis('Panel 4 lewy ', true);
      changeVis('Panel 5 lewy ', true);
      changeVis('Panel 6 lewy ', true);
      changeVis('Panel 7 lewy ', true);
      changeVis('Profil garaż lewy  1 700', true);
      changeVis('Profil garaż lewy  2 700', true);
      changeVis('Profil garaż lewy  4 700', true);
      changeVis('Profil garaż lewy  5 700', true);
      changeVis('Profil garaż lewy  4 900', false);
      changeVis('Profil garaż lewy  2 900', false);
      changeVis('Profil garaż lewy  3', false);
    } else if (getHTMLElemAttribute('value', 'slider2', true) > '0.599') {
      _3C = 0;
      _3E = 1;
      changeVis('Drzwi lewe', true);
      changeVis('Panel 1 lewy ', true);
      changeVis('Panel 2 lewy ', true);
      changeVis('Panel 3 lewy ', true);
      changeVis('Panel 4 lewy ', true);
      changeVis('Panel 5 lewy ', true);
      changeVis('Panel 6 lewy ', true);
      changeVis('Panel 7 lewy ', true);
      changeVis('Profil garaż lewy  1 700', true);
      changeVis('Profil garaż lewy  4 900', true);
      changeVis('Profil garaż lewy  2 900', true);
      changeVis('Profil garaż lewy  5 700', true);
      changeVis('Profil garaż lewy  3', true);
      changeVis('Profil garaż lewy  2 700', false);
      changeVis('Profil garaż lewy  4 700', false);
    }
  }
});
eventHTMLElem('click', '3.1.b', true, function(event) {
  if (isObjectVisible(['GROUP', 'Garaż prawy'])) {
    GaP = 0;
    GaL = 0;
    changeVis(['GROUP', 'Garaż prawy'], false);
    changeVis(['GROUP', 'PG tył'], false);
    changeVis(['GROUP', 'PG lewe'], false);
    changeVis(['GROUP', 'PG prawe'], false);
  } else {
    GaL = 0;
    GaP = 1;
    if (getHTMLElemAttribute('value', 'slider2', true) < '0.599') {
      _3C = 1;
      _3E = 0;
      changeVis('Drzwi prawe', true);
      changeVis('Panel 1 prawy', true);
      changeVis('Panel 2 prawy', true);
      changeVis('Panel 3 prawy', true);
      changeVis('Panel 4 prawy', true);
      changeVis('Panel 5 prawy', true);
      changeVis('Panel 6 prawy', true);
      changeVis('Panel 7 prawy', true);
      changeVis('Profil garaż prawy 1 700', true);
      changeVis('Profil garaż prawy 2 700', true);
      changeVis('Profil garaż prawy 4 700', true);
      changeVis('Profil garaż prawy 5 700', true);
      changeVis('Profil garaż prawy 4 900', false);
      changeVis('Profil garaż prawy 2 900', false);
      changeVis('Profil garaż prawy 3', false);
    } else if (getHTMLElemAttribute('value', 'slider2', true) > '0.599') {
      _3C = 0;
      _3E = 1;
      changeVis('Drzwi prawe', true);
      changeVis('Panel 1 prawy', true);
      changeVis('Panel 2 prawy', true);
      changeVis('Panel 3 prawy', true);
      changeVis('Panel 4 prawy', true);
      changeVis('Panel 5 prawy', true);
      changeVis('Panel 6 prawy', true);
      changeVis('Panel 7 prawy', true);
      changeVis('Profil garaż prawy 1 700', true);
      changeVis('Profil garaż prawy 2 900', true);
      changeVis('Profil garaż prawy 4 900', true);
      changeVis('Profil garaż prawy 5 700', true);
      changeVis('Profil garaż prawy 3', true);
      changeVis('Profil garaż prawy 2 700', false);
      changeVis('Profil garaż prawy 4 700', false);
    }
  }
});
eventHTMLElem('click', 'garage', true, function(event) {
  GaP = 0;
  GaL = 0;
  if (isObjectVisible([['GROUP', 'PG tył'], ['GROUP', 'PG lewe'], ['GROUP', 'PG prawe'], ['GROUP', 'Garaż prawy'], ['GROUP', 'Garaż lewy']])) {
    changeVis(['GROUP', 'PG lewe'], false);
    changeVis(['GROUP', 'PG prawe'], false);
    changeVis(['GROUP', 'PG tył'], false);
    changeVis(['GROUP', 'Garaż lewy'], false);
    changeVis(['GROUP', 'Garaż prawy'], false);
    changeVis('Maskownica 6x6', true);
    changeVis('Dach 6x6', true);
    changeVis('Profil Poprzeczny 6x6', true);
    changeVis('Narozniki 6x6', true);
  }
});

// Wiata 3x6 wybór koloru dachu
eventHTMLElem('click', '4.2.a', true, function(event) {
  assignMat('Dach 3x6', 'Metal Gray');
  assignMat('Dach 6x6', 'Metal Gray');
  assignMat('PG lewe dach', 'Metal Gray');
  assignMat('PG prawe dach', 'Metal Gray');
  assignMat('PG tył dach', 'Metal Gray');
  assignMat('Dach Wielostan', 'Metal Gray');
});
// Wiata 3x6 wybór koloru dachu
eventHTMLElem('click', '4.2.b', true, function(event) {
  assignMat('Dach 3x6', 'Bronze');
  assignMat('Dach 6x6', 'Bronze');
  assignMat('PG lewe dach', 'Bronze');
  assignMat('PG prawe dach', 'Bronze');
  assignMat('PG tył dach', 'Bronze');
  assignMat('Dach Wielostan', 'Bronze');
});
// Wiata 3x6 wybór koloru dachu
eventHTMLElem('click', '4.2.c', true, function(event) {
  assignMat('Dach 3x6', 'Silver');
  assignMat('Dach 6x6', 'Silver');
  assignMat('PG lewe dach', 'Silver');
  assignMat('PG prawe dach', 'Silver');
  assignMat('PG tył dach', 'Silver');
  assignMat('Dach Wielostan', 'Silver');
});
// Wiata 3x6 wybór koloru dachu
eventHTMLElem('click', '4.2.d', true, function(event) {
  assignMat('Dach 3x6', 'Black');
  assignMat('Dach 6x6', 'Black');
  assignMat('PG lewe dach', 'Black');
  assignMat('PG prawe dach', 'Black');
  assignMat('PG tył dach', 'Black');
  assignMat('Dach Wielostan', 'Black');
});

// Wiata 3x6 wybór koloru dachu
eventHTMLElem('click', '4.3.a', true, function(event) {
  assignMat('Maskownica 3x6', 'Metal Gray');
  assignMat('Narozniki 3x6', 'Metal Gray');
  assignMat('Narozniki 6x6', 'Metal Gray');
  assignMat('Maskownica 6x6', 'Metal Gray');
  assignMat('PG tył maskownica', 'Metal Gray');
  assignMat('PG lewe maskownica', 'Metal Gray');
  assignMat('PG prawe maskownica', 'Metal Gray');
  assignMat('Maskownica Wielostan', 'Metal Gray');
  assignMat('Narozniki Wielostan', 'Metal Gray');
});
// Wiata 3x6 wybór koloru dachu
eventHTMLElem('click', '4.3.b', true, function(event) {
  assignMat('Maskownica 3x6', 'Bronze');
  assignMat('Narozniki 3x6', 'Bronze');
  assignMat('Maskownica 6x6', 'Bronze');
  assignMat('Narozniki 6x6', 'Bronze');
  assignMat('PG tył maskownica', 'Bronze');
  assignMat('PG lewe maskownica', 'Bronze');
  assignMat('PG prawe maskownica', 'Bronze');
  assignMat('Maskownica Wielostan', 'Bronze');
  assignMat('Narozniki Wielostan', 'Bronze');
});
// Wiata 3x6 wybór koloru dachu
eventHTMLElem('click', '4.3.c', true, function(event) {
  assignMat('Maskownica 3x6', 'Bronze Light');
  assignMat('Narozniki 3x6', 'Bronze Light');
  assignMat('Maskownica 6x6', 'Bronze Light');
  assignMat('Narozniki 6x6', 'Bronze Light');
  assignMat('PG tył maskownica', 'Bronze Light');
  assignMat('PG lewe maskownica', 'Bronze Light');
  assignMat('PG prawe maskownica', 'Bronze Light');
  assignMat('Maskownica Wielostan', 'Bronze Light');
  assignMat('Narozniki Wielostan', 'Bronze Light');
});
// Wiata 3x6 wybór koloru dachu
eventHTMLElem('click', '4.3.d', true, function(event) {
  assignMat('Maskownica 3x6', 'Silver');
  assignMat('Narozniki 3x6', 'Silver');
  assignMat('Maskownica 6x6', 'Silver');
  assignMat('Narozniki 6x6', 'Silver');
  assignMat('PG tył maskownica', 'Silver');
  assignMat('PG lewe maskownica', 'Silver');
  assignMat('PG prawe maskownica', 'Silver');
  assignMat('Maskownica Wielostan', 'Silver');
  assignMat('Narozniki Wielostan', 'Silver');
});
// Wiata 3x6 wybór koloru dachu
eventHTMLElem('click', '4.3.e', true, function(event) {
  assignMat('Maskownica 3x6', 'Black');
  assignMat('Narozniki 3x6', 'Black');
  assignMat('Maskownica 6x6', 'Black');
  assignMat('Narozniki 6x6', 'Black');
  assignMat('PG tył maskownica', 'Black');
  assignMat('PG lewe maskownica', 'Black');
  assignMat('PG prawe maskownica', 'Black');
  assignMat('Maskownica Wielostan', 'Black');
  assignMat('Narozniki Wielostan', 'Black');
});
// Wiata 3x6 wybór koloru dachu
eventHTMLElem('click', '4.3.f', true, function(event) {
  assignMat('Maskownica 3x6', 'White');
  assignMat('Narozniki 3x6', 'White');
  assignMat('Maskownica 6x6', 'White');
  assignMat('Narozniki 6x6', 'White');
  assignMat('PG tył maskownica', 'White');
  assignMat('PG lewe maskownica', 'White');
  assignMat('PG prawe maskownica', 'White');
  assignMat('Maskownica Wielostan', 'White');
  assignMat('Narozniki Wielostan', 'White');
});

eventHTMLElem('click', '3.2.a', true, function(event) {
  changeVis(['GROUP', 'Ściany 2'], false);
  if (isObjectVisible(['GROUP', 'PG lewe'])) {
    PomL = 0;
    PomP = 0;
    PomB = 0;
    changeVis(['GROUP', 'PG lewe'], false);
    changeVis(['GROUP', 'Ściany 2'], false);
    changeVis('Profil Podluzny 6x6', true);
    changeVis('Profil Poprzeczny 6x6', true);
    changeVis('Narozniki 6x6', true);
    changeVis('Dach 6x6', true);
    changeVis('Maskownica 6x6', true);
    if (SP == 1) {
      changeVis('ScianaP2', true);
    }
    if (SL == 1) {
      changeVis('ScianaL2', true);
    }
    if (SB == 1) {
      changeVis('ScianaB2', true);
    }
  } else {
    PomL = 1;
    PomP = 0;
    PomB = 0;
    if (SP == 1) {
      changeVis('ScianaP2', true);
    }
    if (SL == 1) {
      changeVis('ScianaL2Pom', true);
    }
    if (SB == 1) {
      changeVis('ScianaB2PomL', true);
    }
    if (getHTMLElemAttribute('value', 'slider2', true) < '0.599') {
      _3C = 1;
      _3E = 0;
      changeVis('PG lewe', true);
      changeVis('PG lewe dach', true);
      changeVis('PG lewe maskownica', true);
      changeVis('PG lewe profil 700 1', true);
      changeVis('PG lewe profil 700 2', true);
      changeVis('PG lewe profil 700 3', true);
      changeVis('PG lewe profil 700 4', true);
      changeVis('PG lewe profil 900 1', false);
      changeVis('PG lewe profil 900 2', false);
      changeVis('PG lewe profil 3', false);
    } else if (getHTMLElemAttribute('value', 'slider2', true) > '0.599') {
      _3C = 0;
      _3E = 1;
      changeVis('PG lewe', true);
      changeVis('PG lewe dach', true);
      changeVis('PG lewe maskownica', true);
      changeVis('PG lewe profil 700 1', true);
      changeVis('PG lewe profil 900 1', true);
      changeVis('PG lewe profil 900 2', true);
      changeVis('PG lewe profil 700 4', true);
      changeVis('PG lewe profil 3', true);
      changeVis('PG lewe profil 700 2', false);
      changeVis('PG lewe profil 700 3', false);
    }
    changeVis('Narozniki 6x6', false);
    changeVis('Profil Poprzeczny 6x6', false);
    changeVis('Profil Podluzny 6x6', false);
    changeVis('Dach 6x6', false);
    changeVis('Maskownica 6x6', false);
  }
});
eventHTMLElem('click', '3.2.a', true, function(event) {
  if (isObjectVisible([['GROUP', 'PG prawe'], ['GROUP', 'PG tył'], ['GROUP', 'Garaż lewy'], ['GROUP', 'Garaż prawy']])) {
    changeVis(['GROUP', 'PG tył'], false);
    changeVis(['GROUP', 'PG prawe'], false);
    changeVis(['GROUP', 'Garaż lewy'], false);
    changeVis(['GROUP', 'Garaż prawy'], false);
  }
});
eventHTMLElem('click', '3.2.b', true, function(event) {
  changeVis(['GROUP', 'Ściany 2'], false);
  if (isObjectVisible(['GROUP', 'PG tył'])) {
    PomB = 0;
    PomL = 0;
    PomP = 0;
    changeVis(['GROUP', 'PG tył'], false);
    changeVis(['GROUP', 'Ściany 2'], false);
    changeVis('Narozniki 6x6', true);
    changeVis('Dach 6x6', true);
    changeVis('Profil Poprzeczny 6x6', true);
    changeVis('Maskownica 6x6', true);
    if (SP == 1) {
      changeVis('ScianaP2', true);
    }
    if (SL == 1) {
      changeVis('ScianaL2', true);
    }
    if (SB == 1) {
      changeVis('ScianaB2', true);
    }
  } else {
    if (SP == 1) {
      changeVis('ScianaP2PomB', true);
    }
    if (SL == 1) {
      changeVis('ScianaL2PomB', true);
    }
    if (SB == 1) {
      changeVis('ScianaB2Pom', true);
    }
    PomB = 1;
    PomL = 0;
    PomP = 0;
    changeVis(['GROUP', 'PG tył'], true);
    changeVis('Narozniki 6x6', false);
    changeVis('Profil Poprzeczny 6x6', false);
    changeVis('Dach 6x6', false);
    changeVis('Maskownica 6x6', false);
  }
});
eventHTMLElem('click', '3.2.b', true, function(event) {
  if (isObjectVisible([['GROUP', 'PG prawe'], ['GROUP', 'PG lewe'], ['GROUP', 'Garaż lewy'], ['GROUP', 'Garaż prawy']])) {
    changeVis(['GROUP', 'PG lewe'], false);
    changeVis(['GROUP', 'PG prawe'], false);
    changeVis(['GROUP', 'Garaż lewy'], false);
    changeVis(['GROUP', 'Garaż prawy'], false);
  }
});
eventHTMLElem('click', '3.2.c', true, function(event) {
  changeVis(['GROUP', 'Ściany 2'], false);
  if (isObjectVisible(['GROUP', 'PG prawe'])) {
    PomP = 0;
    PomB = 0;
    PomL = 0;
    changeVis(['GROUP', 'Ściany 2'], false);
    changeVis('<none>', false);
    changeVis('<none>', false);
    changeVis(['GROUP', 'PG prawe'], false);
    changeVis('Narozniki 6x6', true);
    changeVis('Profil Poprzeczny 6x6', true);
    changeVis('Dach 6x6', true);
    changeVis('Maskownica 6x6', true);
    if (SP == 1) {
      changeVis('ScianaP2', true);
    }
    if (SL == 1) {
      changeVis('ScianaL2', true);
    }
    if (SB == 1) {
      changeVis('ScianaB2', true);
    }
  } else {
    PomP = 1;
    PomB = 0;
    PomL = 0;
    if (SP == 1) {
      changeVis('ScianaP2Pom', true);
    }
    if (SL == 1) {
      changeVis('ScianaL2', true);
    }
    if (SB == 1) {
      changeVis('ScianaB2PomP', true);
    }
    if (getHTMLElemAttribute('value', 'slider2', true) < '0.599') {
      _3C = 1;
      _3E = 0;
      changeVis('PG prawe', true);
      changeVis('PG prawe dach', true);
      changeVis('PG prawe maskownica', true);
      changeVis('PG prawe profil 700 1', true);
      changeVis('PG prawe profil 700 1', true);
      changeVis('PG prawe profil 700 2', true);
      changeVis('PG prawe profil 700 3', true);
      changeVis('PG prawe profil 700 4', true);
      changeVis('PG prawe profil 900 1', false);
      changeVis('PG prawe profil 900 2', false);
      changeVis('PG prawe profil 3', false);
    }
    if (getHTMLElemAttribute('value', 'slider2', true) > '0.599') {
      _3C = 0;
      _3E = 1;
      changeVis('PG prawe', true);
      changeVis('PG prawe dach', true);
      changeVis('PG prawe maskownica', true);
      changeVis('PG prawe profil 700 1', true);
      changeVis('PG prawe profil 900 1', true);
      changeVis('PG prawe profil 900 2', true);
      changeVis('PG prawe profil 700 4', true);
      changeVis('PG prawe profil 3', true);
      changeVis('PG prawe profil 700 2', false);
      changeVis('PG prawe profil 700 3', false);
    }
    changeVis('Narozniki 6x6', false);
    changeVis('Profil Poprzeczny 6x6', false);
    changeVis('Dach 6x6', false);
    changeVis('Maskownica 6x6', false);
  }
});
eventHTMLElem('click', '3.2.c', true, function(event) {
  if (isObjectVisible([['GROUP', 'PG tył'], ['GROUP', 'PG lewe'], ['GROUP', 'Garaż lewy'], ['GROUP', 'Garaż prawy'], null, null, null, null, null, null, null])) {
    changeVis(['GROUP', 'PG lewe'], false);
    changeVis(['GROUP', 'PG tył'], false);
    changeVis(['GROUP', 'Garaż lewy'], false);
    changeVis(['GROUP', 'Garaż prawy'], false);
  }
});
eventHTMLElem('click', 'room', true, function(event) {
  PomB = 0;
  PomL = 0;
  PomP = 0;
  if (SP == 1) {
    changeVis('ScianaP2', true);
  }
  if (SL == 1) {
    changeVis('ScianaL2', true);
  }
  if (SB == 1) {
    changeVis('ScianaB2', true);
  }
  if (isObjectVisible([['GROUP', 'PG tył'], ['GROUP', 'PG lewe'], ['GROUP', 'PG prawe'], ['GROUP', 'Garaż lewy'], ['GROUP', 'Garaż prawy'], 'ScianaB2Pom', 'ScianaB2PomL', 'ScianaB2PomP', 'ScianaL2Pom', 'ScianaL2PomB', null, null])) {
    changeVis(['GROUP', 'PG lewe'], false);
    changeVis(['GROUP', 'PG prawe'], false);
    changeVis(['GROUP', 'PG tył'], false);
    changeVis(['GROUP', 'Garaż lewy'], false);
    changeVis(['GROUP', 'Garaż prawy'], false);
    changeVis('Maskownica 6x6', true);
    changeVis('Dach 6x6', true);
    changeVis('Profil Poprzeczny 6x6', true);
    changeVis('Narozniki 6x6', true);
    changeVis('ScianaB2Pom', false);
    changeVis('ScianaB2PomL', false);
    changeVis('ScianaB2PomP', false);
    changeVis('ScianaL2Pom', false);
    changeVis('ScianaL2PomB', false);
    changeVis('ScianaP2Pom', false);
    changeVis('ScianaP2PomB', false);
  }
});

eventHTMLElem('click', '3.3.a', true, function(event) {
  if (Wiata1 == 1) {
    if (isObjectVisible('ScianaL')) {
      changeVis('ScianaL', false);
    } else {
      changeVis('ScianaL', true);
    }
  } else if (Wiata2 == 1 && PomB == 0 && PomL == 0 && PomP == 0 && true) {
    if (isObjectVisible('ScianaL2')) {
      changeVis('ScianaL2', false);
      SL = 0;
    } else {
      changeVis('ScianaL2', true);
      SL = 1;
    }
  } else if (Wiata2 == 1 && PomB == 0 && PomL == 1 && PomP == 0 && true) {
    if (isObjectVisible('ScianaL2Pom')) {
      changeVis('ScianaL2Pom', false);
      changeVis('ScianaL2', false);
      SL = 0;
    } else {
      changeVis('ScianaL2Pom', true);
      SL = 1;
      changeVis('ScianaL2', false);
    }
  } else if (Wiata2 == 1 && PomB == 0 && PomL == 0 && PomP == 1 && true) {
    if (isObjectVisible('ScianaL2')) {
      changeVis('ScianaL2', false);
      SL = 0;
    } else {
      changeVis('ScianaL2', true);
      SL = 1;
    }
  } else if (Wiata2 == 1 && PomB == 1 && PomL == 0 && PomP == 0 && true) {
    if (isObjectVisible('ScianaL2PomB')) {
      changeVis('ScianaL2PomB', false);
      changeVis('ScianaL2', false);
    } else {
      changeVis('ScianaL2PomB', true);
      SL = 1;
      changeVis('ScianaL2', false);
    }
  } else if (Wiata3 == 1) {
    if (isObjectVisible('ScianaL3')) {
      changeVis('ScianaL3', false);
    } else {
      changeVis('ScianaL3', true);
    }
  }
});
eventHTMLElem('click', '3.3.b', true, function(event) {
  if (Wiata1 == 1) {
    if (isObjectVisible('ScianaP')) {
      changeVis('ScianaP', false);
    } else {
      changeVis('ScianaP', true);
    }
  } else if (Wiata2 == 1 && PomB == 0 && PomL == 0 && PomP == 0 && true) {
    if (isObjectVisible('ScianaP2')) {
      changeVis('ScianaP2', false);
      SP = 0;
    } else {
      changeVis('ScianaP2', true);
      SP = 1;
    }
  } else if (Wiata2 == 1 && PomB == 0 && PomL == 0 && PomP == 1 && true) {
    if (isObjectVisible('ScianaP2Pom')) {
      changeVis('ScianaP2Pom', false);
      changeVis('ScianaP2', false);
      SP = 0;
    } else {
      changeVis('ScianaP2Pom', true);
      SP = 1;
      changeVis('ScianaP2', false);
    }
  } else if (Wiata2 == 1 && PomB == 0 && PomL == 1 && PomP == 0 && true) {
    if (isObjectVisible('ScianaP2')) {
      changeVis('ScianaP2', false);
      SP = 0;
    } else {
      changeVis('ScianaP2', true);
      SP = 1;
    }
  } else if (Wiata2 == 1 && PomB == 1 && PomL == 0 && PomP == 0 && true) {
    if (isObjectVisible('ScianaP2PomB')) {
      changeVis('ScianaP2PomB', false);
      changeVis('ScianaP2', false);
      SP = 0;
    } else {
      changeVis('ScianaP2PomB', true);
      SP = 1;
      changeVis('ScianaP2', false);
    }
  } else if (Wiata3 == 1) {
    if (isObjectVisible('ScianaP3')) {
      changeVis('ScianaP3', false);
    } else {
      changeVis('ScianaP3', true);
    }
  }
});
eventHTMLElem('click', '3.3.c', true, function(event) {
  if (Wiata1 == 1) {
    if (isObjectVisible('ScianaB')) {
      changeVis('ScianaB', false);
    } else {
      changeVis('ScianaB', true);
    }
  } else if (Wiata2 == 1 && PomB == 0 && PomL == 0 && PomP == 0) {
    if (isObjectVisible('ScianaB2')) {
      changeVis('ScianaB2', false);
      changeVis('ScianaB2Pom', false);
      changeVis('ScianaB2PomL', false);
      changeVis('ScianaB2PomP', false);
      SB = 0;
    } else {
      changeVis('ScianaB2', true);
      SB = 1;
      changeVis('ScianaB2Pom', false);
      changeVis('ScianaB2PomL', false);
      changeVis('ScianaB2PomP', false);
    }
  } else if (Wiata2 == 1 && PomB == 1 && PomL == 0 && PomP == 0 && true) {
    if (isObjectVisible('ScianaB2Pom')) {
      changeVis('ScianaB2Pom', false);
      changeVis('ScianaB2', false);
      SB = 0;
    } else {
      changeVis('ScianaB2Pom', true);
      SB = 1;
      changeVis('ScianaB2', false);
    }
  } else if (Wiata2 == 1 && PomB == 0 && PomL == 1 && PomP == 0 && true) {
    if (isObjectVisible('ScianaB2PomL')) {
      changeVis('ScianaB2PomL', false);
      changeVis('ScianaB2', false);
      SB = 0;
    } else {
      changeVis('ScianaB2PomL', true);
      SB = 1;
      changeVis('ScianaB2', false);
    }
  } else if (Wiata2 == 1 && PomB == 0 && PomL == 0 && PomP == 1 && true) {
    if (isObjectVisible('ScianaB2PomP')) {
      changeVis('ScianaB2PomP', false);
      changeVis('ScianaB2', false);
      SB = 0;
    } else {
      changeVis('ScianaB2PomP', true);
      SB = 1;
      changeVis('ScianaB2', false);
    }
  } else if (Wiata3 == 1) {
    if (isObjectVisible('ScianaB3')) {
      changeVis('ScianaB3', false);
    } else {
      changeVis('ScianaB3', true);
    }
  }
});
eventHTMLElem('click', 'shedPosition', true, function(event) {
  SP = 0;
  SL = 0;
  SB = 0;
  if (Wiata1 == 1) {
    if (isObjectVisible('ScianaB') || isObjectVisible('ScianaL') || isObjectVisible('ScianaP')) {
      changeVis('ScianaB', false);
      changeVis('ScianaL', false);
      changeVis('ScianaP', false);
    }
  } else if (Wiata2 == 1) {
    if (isObjectVisible('ScianaB2') || isObjectVisible('ScianaL2') || isObjectVisible('ScianaP2') || isObjectVisible('ScianaB2Pom') || isObjectVisible('ScianaB2PomL') || isObjectVisible('ScianaB2PomP') || isObjectVisible('ScianaL2Pom') || isObjectVisible('ScianaL2PomB') || isObjectVisible('ScianaP2Pom') || isObjectVisible('ScianaP2PomB')) {
      changeVis('ScianaB2', false);
      changeVis('ScianaL2', false);
      changeVis('ScianaP2', false);
      changeVis('ScianaB2Pom', false);
      changeVis('ScianaB2PomL', false);
      changeVis('ScianaB2PomP', false);
      changeVis('ScianaL2Pom', false);
      changeVis('ScianaL2PomB', false);
      changeVis('ScianaP2Pom', false);
      changeVis('ScianaP2PomB', false);
    }
  } else if (Wiata3 == 1) {
    if (isObjectVisible('ScianaB3') || isObjectVisible('ScianaL3') || isObjectVisible('ScianaP3')) {
      changeVis('ScianaB3', false);
      changeVis('ScianaL3', false);
      changeVis('ScianaP3', false);
    }
  }
});



} // end of PL.init function

PL.disposeListeners = function() {
    if (_pGlob) {
        _pGlob.eventListeners.forEach(({ target, type, listener, optionsOrUseCapture }) => {
            target.removeEventListener(type, listener, optionsOrUseCapture);
        });
        _pGlob.eventListeners.length = 0;
    }
}

PL.dispose = function() {
    PL.disposeListeners();
    _pGlob = null;
    // backward compatibility
    if (v3d[Symbol.toStringTag] !== 'Module') {
        delete v3d.PL;
        delete v3d.puzzles;
    }
}



return PL;

}

export { createPL };
